{
  "id": "forbidden-city",
  "name": "Forbidden City",
  "hidden": true,
  "viewBox": {
    "x": 0,
    "y": 0,
    "width": 1154,
    "height": 1363
  },
  "backdropColor": {
    "light": "#e9dcb8",
    "dark": "#24251f",
    "topBar": true
  },
  "edgeConfig": {
    "internalBorderWidth": 7.5,
    "regionBorderWidth": 0,
    "bridgeStrokeWidth": 10
  },
  "zoomToggleCorner": "top-right",
  "hideAdjacencyLines": true,
  "noContinentFill": true,
  "borderShape": "M 0 0 L 0 1362 L 2 1362 L 2 1215 L 39 1203 L 45 1204 L 46 1217 L 49 1221 L 45 1225 L 47 1237 L 45 1260 L 48 1265 L 48 1271 L 45 1274 L 45 1287 L 47 1290 L 47 1300 L 45 1301 L 45 1316 L 47 1318 L 47 1328 L 45 1330 L 46 1362 L 53 1362 L 54 1356 L 63 1356 L 64 1362 L 96 1361 L 93 1360 L 95 1357 L 99 1358 L 99 1362 L 117 1362 L 118 1357 L 123 1357 L 123 1360 L 125 1357 L 128 1357 L 130 1362 L 154 1361 L 155 1357 L 160 1358 L 159 1362 L 179 1362 L 180 1357 L 183 1357 L 184 1361 L 185 1357 L 189 1357 L 190 1362 L 217 1361 L 214 1360 L 215 1357 L 220 1357 L 220 1362 L 270 1362 L 271 1357 L 281 1357 L 282 1362 L 309 1361 L 302 1361 L 302 1357 L 311 1357 L 313 1359 L 312 1362 L 339 1361 L 337 1360 L 338 1357 L 342 1357 L 343 1362 L 370 1360 L 362 1360 L 362 1357 L 372 1357 L 373 1362 L 391 1362 L 392 1357 L 396 1357 L 396 1360 L 399 1360 L 397 1359 L 398 1357 L 402 1357 L 403 1362 L 420 1362 L 423 1359 L 432 1362 L 451 1362 L 452 1359 L 461 1359 L 463 1362 L 480 1362 L 482 1358 L 489 1358 L 490 1362 L 668 1362 L 670 1359 L 678 1359 L 679 1362 L 696 1362 L 699 1359 L 700 1362 L 703 1357 L 705 1361 L 705 1358 L 708 1357 L 709 1362 L 728 1362 L 729 1357 L 732 1360 L 738 1357 L 740 1362 L 757 1362 L 763 1360 L 764 1357 L 769 1357 L 770 1360 L 765 1361 L 788 1362 L 796 1360 L 797 1357 L 800 1358 L 800 1362 L 818 1362 L 820 1358 L 822 1361 L 852 1362 L 850 1361 L 851 1357 L 860 1357 L 861 1362 L 888 1362 L 881 1361 L 881 1357 L 890 1357 L 891 1362 L 913 1361 L 910 1359 L 911 1357 L 922 1358 L 920 1362 L 916 1362 L 941 1362 L 943 1357 L 951 1357 L 951 1361 L 946 1361 L 951 1362 L 976 1361 L 976 1357 L 981 1357 L 983 1362 L 1001 1362 L 1002 1360 L 1008 1360 L 1009 1357 L 1013 1358 L 1013 1362 L 1032 1362 L 1033 1359 L 1042 1359 L 1044 1362 L 1069 1362 L 1070 1356 L 1079 1356 L 1080 1362 L 1083 1360 L 1088 1362 L 1086 1357 L 1088 1330 L 1085 1328 L 1085 1319 L 1088 1316 L 1088 1301 L 1086 1300 L 1088 1273 L 1085 1271 L 1086 1261 L 1088 1260 L 1088 1250 L 1086 1249 L 1088 1225 L 1085 1222 L 1085 1217 L 1088 1215 L 1087 1208 L 1090 1202 L 1152 1221 L 1153 1362 L 1153 0 Z M 240 1358 L 250 1357 L 251 1360 L 245 1361 Z M 131 1360 L 132 1357 L 147 1358 L 145 1361 Z M 70 1358 L 79 1357 L 80 1360 L 72 1361 Z M 1045 1358 L 1059 1356 L 1060 1360 L 1046 1361 Z M 1014 1357 L 1029 1356 L 1030 1359 L 1028 1361 L 1016 1361 Z M 923 1357 L 938 1357 L 939 1360 L 927 1361 Z M 893 1357 L 908 1357 L 909 1359 L 907 1361 L 895 1361 Z M 863 1357 L 868 1356 L 871 1360 L 864 1361 Z M 841 1358 L 847 1356 L 848 1360 L 842 1361 Z M 831 1358 L 833 1356 L 841 1357 L 839 1361 L 833 1361 Z M 801 1357 L 816 1356 L 817 1360 L 803 1361 Z M 779 1357 L 786 1356 L 787 1360 L 781 1361 Z M 771 1360 L 773 1356 L 779 1357 L 777 1361 Z M 360 1357 L 359 1361 L 346 1361 L 344 1359 L 345 1357 Z M 314 1357 L 323 1356 L 324 1360 L 315 1361 Z M 283 1357 L 298 1356 L 299 1360 L 284 1360 Z M 253 1357 L 268 1356 L 269 1359 L 267 1361 L 257 1361 Z M 222 1357 L 229 1356 L 231 1360 L 224 1361 Z M 192 1357 L 207 1356 L 208 1359 L 193 1361 Z M 170 1358 L 176 1356 L 177 1360 L 171 1361 Z M 161 1357 L 168 1356 L 169 1360 L 163 1361 Z M 107 1360 L 111 1356 L 116 1358 L 114 1361 Z M 100 1357 L 106 1356 L 107 1359 L 102 1361 Z M 984 1357 L 986 1355 L 990 1357 L 995 1356 L 996 1359 L 994 1361 L 985 1360 Z M 954 1356 L 967 1356 L 968 1359 L 955 1360 Z M 741 1356 L 751 1357 L 752 1360 L 743 1361 Z M 719 1357 L 725 1355 L 726 1359 L 720 1360 Z M 404 1356 L 419 1356 L 420 1359 L 407 1361 L 404 1359 Z M 390 1357 L 389 1360 L 375 1360 L 376 1356 L 383 1358 L 388 1355 Z M 1066 1352 L 1081 1351 L 1083 1355 L 1068 1356 Z M 51 1352 L 57 1351 L 59 1353 L 63 1351 L 64 1355 L 52 1356 Z M 426 1344 L 428 1345 L 428 1356 L 425 1355 Z M 1066 1347 L 1069 1346 L 1070 1340 L 1079 1340 L 1080 1345 L 1078 1346 L 1082 1346 L 1083 1350 L 1074 1351 L 1072 1346 L 1073 1350 L 1067 1351 Z M 49 1347 L 59 1346 L 53 1345 L 54 1340 L 64 1341 L 63 1351 L 51 1351 Z M 1069 1335 L 1079 1334 L 1080 1339 L 1072 1340 L 1069 1338 Z M 53 1339 L 54 1334 L 63 1334 L 65 1336 L 63 1339 Z M 1066 1324 L 1072 1323 L 1073 1327 L 1067 1328 Z M 537 1355 L 536 1357 L 480 1357 L 478 1359 L 450 1357 L 446 1361 L 443 1359 L 438 1361 L 431 1357 L 429 1347 L 455 1348 L 468 1345 L 490 1334 L 506 1323 Z M 1074 1322 L 1078 1324 L 1082 1322 L 1084 1324 L 1084 1328 L 1080 1329 L 1079 1334 L 1069 1333 L 1070 1328 L 1076 1328 L 1073 1327 Z M 590 1355 L 621 1322 L 645 1338 L 664 1346 L 674 1348 L 702 1347 L 699 1359 L 668 1357 L 666 1359 L 657 1358 L 654 1361 L 651 1357 L 591 1357 Z M 116 1324 L 118 1322 L 185 1322 L 187 1324 L 187 1353 L 117 1354 Z M 924 1319 L 951 1320 L 950 1354 L 923 1353 Z M 49 1325 L 57 1323 L 60 1319 L 62 1323 L 68 1324 L 68 1328 L 64 1329 L 63 1334 L 54 1334 L 53 1329 Z M 62 1318 L 67 1317 L 68 1321 L 63 1323 Z M 1066 1318 L 1069 1317 L 1070 1312 L 1079 1312 L 1080 1317 L 1083 1317 L 1084 1321 L 1075 1322 L 1074 1316 L 1073 1322 L 1067 1322 Z M 57 1312 L 58 1319 L 51 1323 L 50 1318 L 53 1317 L 54 1312 Z M 1064 1307 L 1067 1308 L 1065 1316 L 1063 1315 Z M 66 1307 L 70 1308 L 69 1316 L 65 1315 Z M 1069 1307 L 1079 1306 L 1080 1311 L 1070 1312 Z M 53 1307 L 62 1306 L 64 1310 L 54 1312 Z M 1083 1303 L 1087 1304 L 1087 1314 L 1085 1316 L 1082 1315 Z M 47 1303 L 51 1304 L 50 1316 L 46 1314 Z M 74 1302 L 115 1303 L 114 1354 L 73 1353 Z M 1066 1296 L 1082 1295 L 1083 1299 L 1079 1300 L 1079 1306 L 1070 1306 Z M 1066 1290 L 1069 1290 L 1070 1284 L 1079 1284 L 1083 1293 L 1081 1295 L 1067 1295 Z M 816 1353 L 817 1323 L 870 1322 L 871 1283 L 951 1284 L 951 1318 L 923 1319 L 921 1354 Z M 816 1284 L 868 1283 L 869 1321 L 817 1322 Z M 748 1283 L 816 1284 L 816 1352 L 814 1354 L 747 1353 Z M 336 1283 L 386 1284 L 385 1354 L 335 1353 Z M 67 1280 L 70 1281 L 68 1288 L 65 1287 Z M 1080 1279 L 1079 1284 L 1069 1283 L 1070 1279 Z M 506 1321 L 554 1278 L 576 1279 L 621 1320 L 588 1357 L 539 1357 Z M 58 1278 L 64 1280 L 64 1289 L 68 1290 L 68 1298 L 64 1301 L 63 1306 L 58 1304 L 58 1299 L 58 1305 L 54 1306 L 53 1300 L 50 1299 L 52 1295 L 63 1295 L 50 1294 L 50 1290 L 53 1290 L 53 1285 L 58 1284 L 54 1284 L 53 1281 Z M 287 1273 L 335 1274 L 335 1334 L 333 1336 L 288 1336 L 286 1334 Z M 188 1273 L 235 1274 L 234 1336 L 189 1336 L 187 1334 Z M 335 1338 L 335 1352 L 333 1354 L 189 1354 L 187 1352 L 188 1336 L 235 1336 L 236 1273 L 285 1273 L 286 1336 L 333 1336 Z M 73 1270 L 114 1269 L 115 1301 L 74 1301 Z M 710 1260 L 720 1261 L 719 1354 L 709 1353 Z M 413 1260 L 423 1261 L 422 1354 L 413 1354 L 411 1351 L 411 1273 Z M 276 1269 L 284 1260 L 409 1260 L 410 1353 L 402 1356 L 392 1356 L 387 1353 L 387 1282 L 337 1282 L 336 1272 L 277 1271 Z M 54 1256 L 63 1256 L 64 1261 L 68 1262 L 66 1266 L 61 1267 L 66 1267 L 68 1270 L 64 1272 L 63 1279 L 59 1277 L 54 1279 L 53 1272 L 50 1271 L 51 1267 L 58 1267 L 50 1266 Z M 66 1252 L 70 1253 L 68 1260 L 65 1258 Z M 117 1246 L 187 1247 L 186 1322 L 116 1321 Z M 54 1236 L 68 1238 L 68 1244 L 64 1246 L 64 1250 L 58 1251 L 63 1251 L 63 1256 L 53 1255 L 53 1246 L 50 1243 L 58 1241 L 59 1246 L 59 1242 L 62 1241 L 53 1241 L 52 1238 Z M 1079 1230 L 1080 1237 L 1084 1238 L 1083 1241 L 1079 1241 L 1082 1241 L 1084 1244 L 1080 1246 L 1081 1249 L 1079 1251 L 1074 1251 L 1081 1252 L 1080 1262 L 1084 1262 L 1084 1271 L 1080 1273 L 1079 1278 L 1070 1278 L 1066 1268 L 1072 1267 L 1076 1271 L 1074 1267 L 1066 1266 L 1066 1262 L 1069 1261 L 1069 1246 L 1065 1243 L 1067 1241 L 1075 1242 L 1067 1241 L 1066 1238 L 1069 1237 L 1070 1231 Z M 894 1231 L 894 1281 L 747 1281 L 746 1353 L 739 1356 L 729 1356 L 722 1353 L 723 1260 L 758 1258 L 793 1232 L 796 1232 L 806 1243 L 819 1247 L 831 1243 L 841 1230 Z M 586 1230 L 642 1231 L 672 1256 L 683 1260 L 707 1261 L 706 1356 L 702 1355 L 703 1344 L 676 1347 L 662 1344 L 644 1336 L 627 1324 L 575 1276 L 575 1242 Z M 553 1242 L 553 1276 L 498 1326 L 478 1339 L 459 1346 L 442 1347 L 425 1343 L 426 1260 L 449 1260 L 465 1253 L 489 1232 L 496 1230 L 542 1230 Z M 53 1231 L 63 1230 L 64 1235 L 54 1236 Z M 898 1229 L 916 1230 L 915 1282 L 896 1281 L 896 1231 Z M 1064 1226 L 1067 1227 L 1066 1234 L 1063 1233 Z M 73 1227 L 114 1226 L 115 1268 L 74 1269 Z M 66 1226 L 70 1230 L 68 1234 L 65 1233 Z M 1069 1225 L 1071 1223 L 1074 1226 L 1079 1225 L 1080 1229 L 1070 1230 Z M 53 1227 L 58 1226 L 59 1223 L 64 1224 L 61 1226 L 64 1227 L 63 1230 L 54 1230 Z M 1083 1220 L 1082 1224 L 1075 1224 L 1081 1219 Z M 49 1220 L 51 1219 L 58 1224 L 50 1224 Z M 71 1201 L 92 1173 L 161 1173 L 212 1260 L 239 1260 L 247 1270 L 235 1272 L 189 1271 L 188 1245 L 118 1245 L 116 1225 L 71 1225 L 68 1222 L 68 1219 L 72 1216 Z M 979 1173 L 1041 1173 L 1062 1201 L 1062 1217 L 1065 1219 L 1065 1223 L 1062 1224 L 1064 1244 L 1062 1245 L 1061 1259 L 1064 1262 L 1064 1271 L 1061 1273 L 1061 1288 L 1064 1290 L 1064 1299 L 1061 1305 L 1062 1317 L 1064 1319 L 1061 1330 L 1061 1345 L 1064 1347 L 1063 1356 L 1060 1354 L 1044 1354 L 1043 1356 L 1033 1356 L 1031 1354 L 1014 1354 L 1012 1356 L 1002 1356 L 1000 1354 L 983 1354 L 982 1356 L 953 1354 L 952 1282 L 918 1281 L 918 1231 L 968 1230 L 968 1185 Z M 1003 1152 L 1039 1152 L 1040 1171 L 1004 1172 Z M 93 1152 L 127 1152 L 128 1170 L 126 1172 L 95 1172 L 93 1170 Z M 608 1117 L 707 1118 L 708 1203 L 706 1237 L 684 1236 L 660 1216 L 644 1208 L 587 1208 L 575 1195 L 576 1153 L 613 1152 L 607 1123 Z M 425 1118 L 520 1117 L 521 1121 L 515 1152 L 552 1153 L 553 1195 L 541 1208 L 489 1208 L 472 1216 L 466 1223 L 448 1236 L 426 1237 L 424 1209 Z M 3 1112 L 44 1124 L 44 1201 L 4 1213 L 2 1212 Z M 1090 1123 L 1149 1106 L 1152 1108 L 1152 1216 L 1150 1218 L 1091 1202 L 1088 1199 L 1088 1125 Z M 1072 1102 L 1082 1108 L 1088 1124 L 1088 1201 L 1083 1215 L 1077 1221 L 1068 1223 L 1066 1206 L 1041 1170 L 1041 1154 L 1066 1119 L 1066 1103 Z M 526 1103 L 601 1102 L 611 1150 L 517 1151 L 516 1148 Z M 62 1102 L 66 1103 L 66 1115 L 69 1123 L 92 1154 L 92 1170 L 69 1201 L 66 1210 L 66 1222 L 53 1219 L 47 1210 L 45 1201 L 46 1116 L 54 1105 Z M 52 1098 L 54 1096 L 63 1096 L 64 1100 L 54 1103 Z M 53 1092 L 55 1090 L 62 1090 L 64 1094 L 54 1096 Z M 1076 1079 L 1083 1080 L 1083 1083 L 1080 1084 L 1079 1090 L 1081 1094 L 1079 1096 L 1081 1100 L 1079 1103 L 1068 1099 L 1070 1096 L 1076 1096 L 1069 1094 L 1070 1090 L 1076 1090 L 1069 1089 L 1069 1085 L 1075 1084 L 1074 1081 Z M 1066 1080 L 1073 1079 L 1074 1083 L 1067 1084 Z M 50 1080 L 56 1079 L 58 1085 L 58 1079 L 67 1079 L 68 1083 L 64 1085 L 63 1090 L 54 1090 L 54 1084 L 51 1084 Z M 179 1073 L 220 1072 L 222 1102 L 272 1102 L 274 1072 L 308 1072 L 310 1074 L 310 1201 L 212 1202 L 179 1146 Z M 1066 1074 L 1069 1073 L 1070 1067 L 1079 1067 L 1083 1078 L 1079 1079 L 1078 1076 L 1077 1079 L 1074 1079 L 1073 1073 L 1073 1078 L 1067 1079 Z M 50 1075 L 54 1072 L 54 1067 L 63 1067 L 63 1073 L 67 1073 L 68 1077 L 66 1079 L 60 1078 L 59 1072 L 57 1072 L 57 1078 L 52 1079 Z M 1069 1063 L 1079 1062 L 1080 1066 L 1070 1067 Z M 53 1063 L 63 1062 L 64 1065 L 62 1067 L 54 1067 Z M 965 1057 L 967 1059 L 966 1140 L 973 1145 L 977 1152 L 1002 1152 L 1003 1170 L 1000 1172 L 977 1172 L 966 1184 L 967 1215 L 965 1229 L 884 1229 L 884 1209 L 946 1209 L 946 1183 L 939 1177 L 935 1169 L 936 1152 L 946 1141 L 946 1058 Z M 505 1080 L 525 1078 L 557 1053 L 571 1053 L 599 1076 L 610 1080 L 622 1080 L 623 1083 L 620 1092 L 614 1098 L 605 1101 L 523 1101 L 514 1098 L 508 1092 Z M 1081 1047 L 1083 1049 L 1083 1056 L 1080 1057 L 1080 1061 L 1070 1062 L 1066 1054 L 1073 1053 L 1075 1057 L 1075 1053 L 1080 1053 L 1078 1051 L 1074 1053 L 1073 1049 Z M 223 1043 L 273 1044 L 272 1101 L 222 1100 L 221 1045 Z M 771 1038 L 853 1039 L 852 1151 L 770 1150 Z M 67 1036 L 70 1037 L 69 1044 L 65 1042 Z M 1070 1032 L 1079 1032 L 1081 1034 L 1080 1047 L 1068 1046 L 1069 1039 L 1073 1038 L 1069 1036 Z M 90 1028 L 110 1028 L 110 1039 L 115 1052 L 224 1238 L 241 1238 L 251 1228 L 252 1203 L 271 1203 L 272 1228 L 282 1238 L 329 1238 L 331 1240 L 331 1257 L 329 1259 L 282 1259 L 274 1269 L 268 1272 L 254 1272 L 241 1259 L 214 1259 L 163 1172 L 128 1171 L 128 1153 L 130 1151 L 151 1151 L 93 1052 Z M 50 1018 L 57 1017 L 58 1021 L 52 1023 Z M 1070 1011 L 1079 1011 L 1080 1017 L 1084 1019 L 1082 1023 L 1077 1022 L 1083 1024 L 1080 1032 L 1070 1032 L 1066 1026 L 1067 1023 L 1072 1023 L 1073 1027 L 1075 1027 L 1074 1019 L 1076 1018 L 1074 1017 L 1072 1023 L 1066 1022 Z M 54 1011 L 63 1011 L 64 1017 L 68 1018 L 68 1027 L 64 1029 L 63 1037 L 64 1045 L 68 1046 L 68 1056 L 64 1057 L 63 1062 L 54 1062 L 53 1057 L 50 1056 L 51 1048 L 56 1048 L 58 1053 L 65 1053 L 57 1052 L 57 1049 L 62 1047 L 54 1048 L 52 1046 L 53 1039 L 56 1038 L 53 1037 L 53 1033 L 61 1032 L 54 1032 L 53 1027 L 50 1026 L 51 1023 L 57 1023 L 57 1027 L 61 1027 L 58 1026 L 59 1017 L 53 1016 Z M 854 1010 L 895 1011 L 894 1151 L 853 1150 Z M 179 1007 L 309 1006 L 310 1071 L 274 1072 L 273 1043 L 221 1043 L 220 1072 L 180 1072 Z M 66 1002 L 70 1003 L 69 1010 L 65 1009 Z M 53 1001 L 63 1000 L 64 1010 L 54 1011 Z M 710 998 L 720 999 L 719 1237 L 709 1236 L 709 1116 L 607 1116 L 603 1104 L 604 1102 L 709 1102 Z M 576 1010 L 586 998 L 706 998 L 707 1100 L 616 1101 L 615 1099 L 623 1089 L 625 1079 L 610 1079 L 601 1076 L 576 1055 Z M 425 999 L 542 998 L 553 1011 L 553 1054 L 524 1077 L 517 1079 L 504 1078 L 505 1089 L 511 1098 L 509 1101 L 426 1101 Z M 413 998 L 423 999 L 423 1102 L 524 1103 L 521 1116 L 423 1116 L 422 1237 L 411 1236 L 411 1007 Z M 368 998 L 410 999 L 409 1237 L 367 1236 L 367 1080 L 375 1072 L 378 1065 L 378 1049 L 375 1042 L 367 1034 Z M 1083 989 L 1086 990 L 1085 999 L 1082 998 Z M 1069 985 L 1083 986 L 1080 989 L 1081 999 L 1078 1000 L 1081 1002 L 1079 1011 L 1069 1009 L 1069 996 L 1076 995 L 1069 994 Z M 52 986 L 63 985 L 65 995 L 65 989 L 68 988 L 70 990 L 68 998 L 59 1000 L 58 996 L 60 995 L 58 995 L 58 999 L 53 1000 Z M 1066 981 L 1076 980 L 1077 983 L 1069 985 Z M 50 981 L 66 980 L 67 986 L 65 987 L 58 983 L 52 985 Z M 1074 975 L 1080 975 L 1083 978 L 1083 983 L 1078 984 L 1078 979 L 1075 979 Z M 1074 975 L 1072 980 L 1066 979 L 1070 975 Z M 58 976 L 63 974 L 68 979 L 59 980 Z M 1069 971 L 1079 970 L 1080 973 L 1070 974 Z M 54 965 L 58 966 L 57 969 L 64 970 L 63 974 L 58 974 L 57 980 L 51 979 L 55 974 L 53 973 Z M 66 962 L 70 963 L 69 969 L 65 968 Z M 853 961 L 903 959 L 904 1008 L 854 1009 Z M 770 960 L 852 960 L 853 1036 L 771 1037 Z M 248 958 L 322 957 L 323 1004 L 321 1006 L 249 1006 Z M 165 958 L 246 957 L 247 1005 L 167 1006 L 165 1004 Z M 50 958 L 58 956 L 58 961 L 61 961 L 59 960 L 60 956 L 68 957 L 67 960 L 64 960 L 63 969 L 59 969 L 58 965 L 54 965 L 54 961 Z M 50 952 L 56 951 L 57 955 L 51 956 Z M 1070 943 L 1074 944 L 1072 952 L 1074 951 L 1075 943 L 1079 943 L 1080 948 L 1083 949 L 1078 951 L 1083 952 L 1082 956 L 1077 956 L 1083 958 L 1080 961 L 1079 969 L 1069 968 L 1069 960 L 1066 957 L 1074 956 L 1066 955 L 1066 950 L 1069 948 Z M 50 949 L 53 948 L 54 944 L 63 943 L 64 948 L 67 949 L 67 955 L 58 956 L 57 952 L 62 951 L 59 948 L 57 951 L 51 951 Z M 1069 938 L 1079 937 L 1080 942 L 1070 943 Z M 64 939 L 63 943 L 53 942 L 54 938 L 62 937 Z M 1083 934 L 1087 936 L 1085 942 L 1082 941 Z M 66 934 L 70 935 L 69 941 L 65 940 Z M 48 934 L 51 935 L 50 941 L 46 940 Z M 1065 925 L 1067 923 L 1082 923 L 1083 931 L 1080 932 L 1081 936 L 1070 937 L 1068 935 L 1069 932 L 1065 931 L 1068 928 Z M 1015 921 L 1060 922 L 1059 1009 L 993 1009 L 991 1007 L 991 958 L 1014 957 Z M 1068 921 L 1070 917 L 1074 919 L 1079 917 L 1083 922 L 1069 923 Z M 62 917 L 65 921 L 68 921 L 68 926 L 54 927 L 57 929 L 57 932 L 60 932 L 57 931 L 58 927 L 67 927 L 68 931 L 64 932 L 63 937 L 54 938 L 53 932 L 50 931 L 50 924 L 62 923 L 58 922 Z M 53 918 L 57 917 L 58 922 L 53 923 Z M 122 914 L 222 914 L 229 923 L 237 927 L 253 926 L 266 914 L 344 915 L 344 1034 L 338 1039 L 333 1050 L 334 1068 L 344 1080 L 343 1237 L 283 1237 L 273 1225 L 274 1203 L 311 1203 L 311 1008 L 324 1006 L 324 957 L 163 956 L 164 1007 L 178 1008 L 177 1145 L 211 1203 L 250 1204 L 250 1226 L 240 1237 L 225 1237 L 116 1051 L 112 1041 L 112 926 Z M 1069 914 L 1078 913 L 1080 916 L 1070 917 Z M 979 909 L 1026 910 L 1025 920 L 1013 920 L 1013 955 L 990 956 L 990 1010 L 1060 1010 L 1064 1018 L 1064 1028 L 1061 1030 L 1061 1044 L 1064 1046 L 1061 1072 L 1064 1074 L 1064 1083 L 1062 1085 L 1061 1100 L 1064 1102 L 1064 1112 L 1060 1126 L 1041 1150 L 979 1150 L 968 1139 L 968 920 Z M 757 909 L 819 909 L 830 920 L 846 922 L 855 918 L 863 909 L 935 909 L 945 920 L 945 1139 L 939 1144 L 934 1153 L 935 1173 L 945 1184 L 945 1206 L 943 1208 L 841 1208 L 830 1197 L 831 1152 L 896 1152 L 895 1015 L 897 1010 L 906 1010 L 905 958 L 769 958 L 768 1151 L 807 1153 L 807 1196 L 796 1208 L 778 1214 L 750 1236 L 722 1236 L 722 999 L 756 998 Z M 1069 909 L 1079 908 L 1080 912 L 1070 913 Z M 52 909 L 63 908 L 64 916 L 54 917 L 53 914 L 58 913 L 54 913 Z M 66 905 L 70 906 L 69 912 L 65 910 Z M 49 905 L 51 911 L 47 913 L 46 908 Z M 50 899 L 66 898 L 67 902 L 64 903 L 63 908 L 59 907 L 59 903 L 62 902 L 56 902 L 59 904 L 59 907 L 54 908 Z M 1066 899 L 1068 897 L 1081 897 L 1083 901 L 1080 902 L 1079 908 L 1070 908 L 1070 902 L 1067 902 Z M 50 894 L 53 892 L 57 893 L 58 896 L 51 897 Z M 1066 894 L 1074 893 L 1069 892 L 1070 888 L 1079 887 L 1081 889 L 1080 893 L 1083 896 L 1067 897 Z M 58 888 L 63 887 L 63 892 L 66 892 L 67 896 L 59 897 Z M 1069 883 L 1080 882 L 1081 885 L 1079 887 L 1070 887 Z M 538 882 L 590 881 L 591 911 L 589 913 L 539 913 Z M 53 883 L 55 881 L 63 881 L 64 886 L 54 887 Z M 157 894 L 223 893 L 232 882 L 239 879 L 248 879 L 259 885 L 264 893 L 326 893 L 327 912 L 264 913 L 256 923 L 248 926 L 239 926 L 229 921 L 223 913 L 159 913 L 157 911 Z M 57 871 L 67 870 L 68 874 L 58 875 Z M 50 871 L 56 870 L 57 875 L 64 876 L 64 880 L 54 881 Z M 1067 865 L 1083 866 L 1082 875 L 1073 875 L 1079 875 L 1079 881 L 1069 880 L 1069 875 L 1066 874 L 1066 871 L 1072 870 L 1073 872 L 1078 868 L 1067 869 Z M 1068 863 L 1070 859 L 1079 859 L 1081 862 L 1080 865 L 1069 865 Z M 50 866 L 62 865 L 54 865 L 53 859 L 55 858 L 63 859 L 64 864 L 66 863 L 68 868 L 66 870 L 51 870 Z M 66 855 L 70 856 L 69 862 L 65 861 Z M 1080 853 L 1079 858 L 1069 857 L 1070 853 Z M 64 854 L 63 858 L 53 857 L 54 853 L 62 852 Z M 1083 849 L 1087 850 L 1085 861 L 1082 860 Z M 50 844 L 67 843 L 68 846 L 59 846 L 63 847 L 64 851 L 54 852 Z M 426 834 L 444 835 L 444 974 L 439 976 L 425 974 Z M 686 833 L 707 835 L 706 975 L 685 974 Z M 661 834 L 662 974 L 586 975 L 575 963 L 576 915 L 625 914 L 625 873 L 653 871 L 653 834 Z M 468 834 L 474 833 L 476 835 L 476 871 L 504 873 L 504 914 L 552 915 L 552 964 L 541 976 L 467 974 Z M 833 831 L 849 831 L 851 833 L 851 876 L 862 887 L 885 887 L 885 907 L 862 907 L 853 918 L 838 921 L 828 917 L 821 907 L 797 906 L 798 887 L 821 887 L 831 876 L 831 833 Z M 1070 830 L 1079 830 L 1083 836 L 1082 838 L 1078 837 L 1083 839 L 1082 843 L 1073 843 L 1074 848 L 1075 843 L 1083 844 L 1079 852 L 1070 852 L 1069 847 L 1066 846 L 1069 842 L 1066 840 L 1074 838 L 1073 836 L 1072 838 L 1066 837 Z M 58 831 L 63 830 L 64 834 L 68 835 L 68 838 L 63 839 L 59 837 Z M 54 830 L 58 831 L 58 836 L 54 838 L 62 838 L 62 843 L 52 843 L 50 841 L 50 836 L 53 835 Z M 73 826 L 89 863 L 89 879 L 80 888 L 76 901 L 76 908 L 80 918 L 89 926 L 89 1043 L 96 1061 L 147 1147 L 146 1150 L 91 1150 L 71 1123 L 69 1110 L 72 1096 L 69 1074 L 72 1072 L 72 1059 L 69 1055 L 69 1046 L 72 1044 L 72 1030 L 70 1028 L 70 1018 L 72 1017 L 72 1003 L 70 999 L 72 986 L 70 985 L 70 977 L 72 976 L 69 949 L 71 948 L 72 933 L 69 931 L 69 922 L 72 919 L 69 898 L 72 876 L 69 874 L 69 865 L 71 863 L 72 847 L 70 846 L 70 836 Z M 1069 826 L 1079 825 L 1080 829 L 1071 830 Z M 53 826 L 63 825 L 64 828 L 62 830 L 55 830 Z M 1083 820 L 1086 821 L 1085 829 L 1082 828 Z M 468 819 L 476 820 L 475 832 L 467 831 Z M 654 818 L 662 820 L 661 832 L 654 832 L 652 830 L 652 820 Z M 650 815 L 651 869 L 624 870 L 624 911 L 622 913 L 593 913 L 591 911 L 591 880 L 564 879 L 564 851 L 626 850 L 626 817 L 628 815 Z M 564 831 L 582 830 L 583 815 L 625 815 L 626 848 L 565 849 Z M 502 817 L 504 815 L 545 815 L 546 830 L 564 831 L 564 848 L 503 849 Z M 479 815 L 500 815 L 502 817 L 502 850 L 564 851 L 564 879 L 537 880 L 536 913 L 506 913 L 505 871 L 477 869 L 477 821 Z M 1066 815 L 1074 814 L 1075 818 L 1076 814 L 1082 814 L 1083 817 L 1080 819 L 1079 824 L 1070 824 Z M 68 814 L 63 824 L 54 824 L 53 818 L 50 817 L 51 814 L 57 814 L 59 819 L 59 814 Z M 953 809 L 965 809 L 967 811 L 966 876 L 977 887 L 1047 888 L 1046 920 L 1029 920 L 1027 907 L 977 907 L 975 912 L 966 919 L 965 1057 L 948 1057 L 946 1055 L 946 919 L 938 912 L 936 907 L 886 906 L 887 887 L 936 887 L 946 876 L 946 811 Z M 50 810 L 67 809 L 68 812 L 51 814 Z M 72 805 L 74 806 L 73 820 L 70 817 L 70 807 Z M 1066 811 L 1079 809 L 1073 808 L 1073 803 L 1079 802 L 1083 813 L 1069 814 Z M 58 803 L 63 802 L 67 808 L 60 809 Z M 546 802 L 548 800 L 580 800 L 581 829 L 547 830 Z M 1069 796 L 1079 795 L 1080 801 L 1070 802 Z M 1083 793 L 1087 794 L 1085 802 L 1082 801 Z M 66 792 L 70 793 L 69 805 L 65 803 Z M 879 782 L 1011 781 L 1012 808 L 880 809 Z M 564 781 L 625 780 L 626 814 L 583 815 L 582 800 L 564 799 Z M 502 781 L 563 780 L 564 799 L 546 800 L 545 815 L 504 815 L 502 813 Z M 72 777 L 74 778 L 74 789 L 70 790 L 69 779 Z M 1070 775 L 1080 775 L 1083 779 L 1080 781 L 1083 782 L 1080 795 L 1070 795 L 1069 790 L 1066 789 L 1067 785 L 1074 785 L 1073 780 L 1066 780 Z M 51 779 L 54 775 L 59 776 L 58 781 L 52 781 Z M 63 774 L 65 778 L 68 778 L 68 788 L 64 790 L 64 800 L 56 802 L 58 803 L 58 808 L 54 809 L 52 807 L 53 796 L 59 795 L 54 795 L 50 786 L 56 785 L 58 791 L 58 785 L 52 785 L 50 782 L 62 781 L 59 779 L 59 776 Z M 65 771 L 69 770 L 70 775 L 66 777 Z M 67 763 L 70 764 L 69 770 L 65 769 Z M 1067 757 L 1073 757 L 1073 760 L 1075 757 L 1083 758 L 1080 762 L 1081 769 L 1079 774 L 1069 773 L 1069 766 L 1076 765 L 1070 765 L 1069 761 L 1066 760 Z M 475 750 L 476 816 L 468 817 L 467 757 Z M 72 748 L 74 749 L 73 762 L 69 759 Z M 1066 750 L 1070 746 L 1079 746 L 1083 750 L 1083 756 L 1069 757 L 1066 755 L 1067 753 L 1079 752 L 1067 752 Z M 66 740 L 70 741 L 69 748 L 65 746 Z M 1069 740 L 1079 739 L 1080 744 L 1070 745 Z M 1083 735 L 1087 736 L 1085 744 L 1082 743 Z M 63 733 L 63 747 L 68 750 L 68 755 L 57 757 L 58 761 L 58 758 L 66 756 L 67 760 L 64 761 L 63 765 L 57 765 L 64 766 L 64 773 L 54 775 L 53 771 L 58 770 L 53 769 L 50 753 L 63 752 L 50 751 L 53 748 L 53 740 L 59 739 L 54 739 L 53 735 L 55 733 Z M 564 731 L 606 730 L 607 751 L 650 751 L 651 814 L 628 815 L 626 813 L 626 779 L 565 779 Z M 563 730 L 563 779 L 502 779 L 502 814 L 479 815 L 477 813 L 477 758 L 479 751 L 522 751 L 523 730 Z M 1066 729 L 1082 728 L 1083 732 L 1080 733 L 1079 739 L 1070 739 L 1069 734 L 1074 732 L 1067 733 Z M 59 729 L 67 728 L 68 732 L 60 733 Z M 50 729 L 58 728 L 59 732 L 53 733 Z M 72 720 L 75 724 L 73 745 L 71 744 L 72 734 L 69 732 L 69 722 Z M 50 724 L 54 716 L 58 716 L 59 721 L 57 723 L 62 724 L 60 717 L 63 716 L 68 726 L 66 728 L 52 728 Z M 1086 710 L 1087 715 L 1083 719 L 1082 711 Z M 48 709 L 51 710 L 50 719 L 46 718 L 46 711 Z M 58 700 L 67 699 L 68 703 L 59 704 Z M 1070 688 L 1079 688 L 1081 692 L 1080 695 L 1071 695 L 1076 695 L 1078 699 L 1079 695 L 1083 696 L 1079 716 L 1083 723 L 1081 728 L 1066 727 L 1066 724 L 1069 723 L 1069 717 L 1074 716 L 1069 715 L 1069 704 L 1066 703 L 1067 699 L 1073 700 L 1066 698 Z M 54 688 L 64 689 L 63 693 L 58 694 L 65 692 L 68 694 L 67 698 L 55 699 L 58 700 L 57 704 L 64 705 L 64 714 L 61 716 L 53 715 L 53 704 L 50 703 L 52 699 L 50 696 L 54 694 Z M 819 683 L 862 683 L 864 685 L 864 829 L 862 831 L 820 831 L 818 829 Z M 66 683 L 70 684 L 69 691 L 65 690 Z M 1064 682 L 1067 684 L 1066 691 L 1063 690 Z M 72 682 L 74 683 L 73 705 L 69 703 Z M 53 683 L 62 682 L 64 686 L 57 688 L 53 686 Z M 1080 682 L 1079 687 L 1069 686 L 1070 682 Z M 969 664 L 1010 664 L 1012 666 L 1011 781 L 969 781 L 967 779 L 967 666 Z M 925 664 L 967 665 L 966 781 L 925 781 L 923 779 L 923 666 Z M 880 664 L 921 664 L 923 666 L 923 779 L 921 781 L 879 780 Z M 71 664 L 74 665 L 74 681 L 70 675 Z M 564 673 L 582 672 L 583 657 L 625 657 L 626 690 L 565 691 Z M 502 659 L 504 657 L 544 657 L 546 659 L 546 672 L 564 673 L 564 690 L 503 691 Z M 1079 653 L 1082 666 L 1078 668 L 1084 669 L 1084 675 L 1080 677 L 1079 681 L 1070 681 L 1069 676 L 1066 675 L 1068 672 L 1066 668 L 1070 662 L 1074 662 L 1070 662 L 1069 659 L 1075 658 L 1070 658 L 1069 655 Z M 686 651 L 707 652 L 706 817 L 685 816 L 684 763 L 685 757 L 692 750 L 696 740 L 695 724 L 684 709 Z M 653 651 L 662 652 L 662 711 L 654 719 L 651 727 L 653 747 L 662 757 L 661 817 L 653 816 L 652 750 L 610 750 L 608 748 L 609 713 L 653 712 Z M 468 651 L 476 652 L 476 713 L 520 713 L 519 750 L 475 749 L 478 742 L 478 727 L 474 718 L 467 712 Z M 426 651 L 444 652 L 444 711 L 437 718 L 433 726 L 434 745 L 444 757 L 443 817 L 425 816 Z M 1064 650 L 1067 651 L 1066 658 L 1063 657 Z M 66 650 L 70 651 L 69 658 L 65 656 Z M 48 650 L 51 651 L 50 657 L 46 655 Z M 1066 644 L 1081 643 L 1083 647 L 1079 648 L 1079 653 L 1070 653 Z M 51 643 L 61 643 L 64 649 L 64 661 L 59 662 L 63 662 L 68 667 L 57 668 L 68 669 L 68 675 L 64 677 L 63 682 L 54 682 L 53 676 L 50 675 L 50 666 L 54 662 L 53 659 L 56 658 L 53 657 L 53 648 L 50 647 Z M 1083 638 L 1082 643 L 1066 642 L 1067 638 Z M 654 636 L 662 637 L 661 649 L 652 648 L 652 638 Z M 468 636 L 476 637 L 475 649 L 467 648 Z M 71 636 L 74 637 L 75 648 L 73 651 L 69 647 L 69 638 Z M 297 634 L 351 635 L 351 822 L 349 824 L 296 823 Z M 186 634 L 258 635 L 257 779 L 185 778 Z M 152 634 L 185 635 L 185 780 L 258 780 L 258 635 L 295 635 L 294 824 L 151 823 Z M 1069 633 L 1080 632 L 1081 636 L 1070 638 Z M 53 633 L 63 632 L 64 637 L 66 636 L 68 639 L 66 643 L 68 646 L 63 648 L 63 643 L 57 642 L 57 639 L 61 637 L 57 637 L 56 643 L 51 643 L 50 638 L 53 638 Z M 1069 626 L 1079 625 L 1081 629 L 1077 632 L 1070 632 Z M 53 626 L 63 625 L 64 630 L 54 632 Z M 564 624 L 625 623 L 626 656 L 583 657 L 581 642 L 566 643 L 564 641 Z M 502 624 L 563 623 L 563 642 L 581 644 L 581 671 L 546 671 L 546 644 L 559 643 L 546 642 L 545 657 L 503 657 Z M 1083 621 L 1087 623 L 1087 631 L 1084 635 L 1082 634 Z M 67 621 L 70 622 L 69 628 L 65 627 Z M 48 621 L 51 622 L 50 629 L 47 628 L 46 623 Z M 1066 617 L 1073 616 L 1074 619 L 1075 616 L 1082 616 L 1083 619 L 1079 625 L 1070 625 Z M 377 611 L 376 628 L 351 627 L 352 610 L 375 609 Z M 72 607 L 74 608 L 74 620 L 69 618 L 69 609 Z M 565 604 L 651 605 L 650 712 L 607 712 L 606 729 L 564 728 L 565 692 L 626 692 L 626 623 L 566 623 L 564 621 Z M 479 604 L 564 605 L 564 621 L 562 623 L 502 623 L 502 692 L 563 692 L 563 729 L 523 729 L 522 712 L 478 711 L 477 632 Z M 1065 609 L 1069 607 L 1070 602 L 1079 602 L 1083 610 L 1077 611 L 1082 611 L 1083 615 L 1067 616 L 1067 611 L 1073 612 L 1074 610 L 1066 611 Z M 54 602 L 63 602 L 63 607 L 68 609 L 67 611 L 57 612 L 67 612 L 66 615 L 56 616 L 59 619 L 60 616 L 67 617 L 63 625 L 54 625 L 53 620 L 50 619 L 52 616 L 50 615 L 52 611 L 50 609 L 54 607 Z M 222 600 L 350 599 L 351 632 L 223 633 L 221 622 Z M 1064 598 L 1067 599 L 1066 606 L 1063 605 Z M 66 598 L 70 600 L 69 606 L 65 605 Z M 1083 597 L 1086 598 L 1087 602 L 1085 606 L 1082 605 Z M 48 597 L 51 598 L 50 606 L 46 605 Z M 1069 597 L 1079 596 L 1081 600 L 1079 602 L 1072 602 L 1069 600 Z M 53 598 L 63 596 L 64 601 L 54 602 Z M 973 593 L 973 648 L 971 650 L 877 649 L 878 629 L 952 629 L 952 593 Z M 53 592 L 62 591 L 64 595 L 54 596 Z M 421 587 L 422 634 L 410 635 L 410 974 L 368 975 L 367 915 L 391 914 L 391 812 L 398 806 L 403 794 L 401 777 L 391 765 L 391 692 L 399 668 L 399 599 L 410 587 Z M 711 586 L 733 588 L 733 603 L 736 613 L 752 643 L 742 657 L 741 674 L 745 683 L 752 690 L 753 882 L 751 886 L 733 886 L 732 975 L 722 974 L 722 635 L 711 635 L 709 633 L 709 588 Z M 698 586 L 706 586 L 708 588 L 708 636 L 720 637 L 719 975 L 709 974 L 709 832 L 686 832 L 684 830 L 684 820 L 686 818 L 709 818 L 709 650 L 684 648 L 685 637 L 696 636 L 696 588 Z M 686 586 L 693 586 L 695 588 L 695 633 L 693 635 L 685 634 L 684 588 Z M 576 598 L 587 586 L 661 587 L 662 633 L 660 635 L 653 633 L 652 603 L 577 603 Z M 467 633 L 468 587 L 541 586 L 553 599 L 551 603 L 477 603 L 476 634 Z M 447 586 L 466 587 L 466 713 L 474 721 L 477 730 L 475 746 L 466 755 L 466 815 L 464 817 L 447 817 L 445 815 L 445 755 L 438 749 L 434 741 L 435 725 L 445 713 L 445 588 Z M 438 586 L 444 588 L 443 635 L 437 633 Z M 434 586 L 436 588 L 436 636 L 444 637 L 444 648 L 423 649 L 423 818 L 442 818 L 444 820 L 444 831 L 423 832 L 423 974 L 413 976 L 411 974 L 412 637 L 424 636 L 424 588 L 426 586 Z M 1066 583 L 1072 582 L 1074 584 L 1073 590 L 1078 590 L 1074 589 L 1074 583 L 1082 582 L 1083 590 L 1080 591 L 1080 595 L 1070 596 L 1069 592 L 1071 591 L 1066 589 L 1067 586 L 1070 586 L 1067 586 Z M 1083 580 L 1082 582 L 1066 581 L 1070 576 L 1079 575 Z M 66 571 L 70 572 L 69 578 L 65 577 Z M 1069 571 L 1079 569 L 1080 574 L 1070 575 Z M 54 569 L 64 570 L 64 573 L 58 576 L 62 575 L 64 580 L 67 580 L 66 590 L 61 591 L 59 589 L 61 586 L 59 586 L 57 591 L 50 589 L 50 580 L 53 578 Z M 72 568 L 75 572 L 75 594 L 73 598 L 69 590 Z M 1083 565 L 1086 566 L 1085 574 L 1082 573 Z M 1066 557 L 1068 555 L 1082 555 L 1083 562 L 1080 563 L 1080 568 L 1070 569 L 1069 563 L 1066 561 L 1073 559 L 1067 559 Z M 152 555 L 204 556 L 204 599 L 221 600 L 220 633 L 151 632 Z M 50 557 L 56 555 L 57 560 L 58 555 L 67 555 L 68 562 L 64 564 L 63 569 L 54 569 L 53 564 L 50 562 Z M 71 551 L 74 552 L 74 567 L 69 562 Z M 50 552 L 53 551 L 54 545 L 63 545 L 63 550 L 68 554 L 51 555 Z M 709 545 L 731 544 L 733 548 L 733 562 L 710 563 Z M 697 544 L 708 545 L 708 562 L 706 564 L 696 563 Z M 425 544 L 436 545 L 436 562 L 434 564 L 426 564 L 424 562 Z M 399 545 L 421 544 L 422 562 L 410 564 L 399 552 Z M 765 544 L 850 543 L 851 596 L 766 597 L 764 584 Z M 875 629 L 877 631 L 877 648 L 875 650 L 859 650 L 850 653 L 815 675 L 784 677 L 782 682 L 774 688 L 774 778 L 770 780 L 774 781 L 774 887 L 796 887 L 797 906 L 755 907 L 754 997 L 584 997 L 582 1002 L 574 1008 L 573 1053 L 554 1052 L 554 1008 L 546 1002 L 544 997 L 366 997 L 366 1036 L 373 1042 L 377 1050 L 377 1064 L 373 1072 L 366 1078 L 366 1238 L 446 1238 L 457 1232 L 479 1213 L 490 1209 L 544 1209 L 546 1204 L 554 1197 L 555 1152 L 574 1153 L 574 1197 L 582 1204 L 584 1209 L 643 1209 L 656 1215 L 679 1235 L 686 1238 L 748 1238 L 758 1233 L 782 1213 L 798 1209 L 808 1198 L 808 1153 L 828 1152 L 829 1198 L 838 1209 L 882 1209 L 883 1228 L 839 1229 L 837 1235 L 830 1242 L 823 1245 L 807 1242 L 798 1230 L 788 1233 L 761 1255 L 749 1259 L 686 1259 L 672 1254 L 639 1228 L 584 1228 L 582 1233 L 574 1239 L 573 1277 L 554 1276 L 554 1240 L 547 1234 L 544 1228 L 494 1228 L 462 1253 L 448 1259 L 332 1259 L 331 1239 L 345 1238 L 345 1078 L 338 1072 L 334 1064 L 334 1050 L 338 1042 L 346 1035 L 346 915 L 348 913 L 364 913 L 366 915 L 366 977 L 445 977 L 446 817 L 464 817 L 466 819 L 466 977 L 544 977 L 546 972 L 554 965 L 554 915 L 561 913 L 572 913 L 574 915 L 574 966 L 582 972 L 584 977 L 663 977 L 663 818 L 676 817 L 665 817 L 663 815 L 663 755 L 657 750 L 652 740 L 653 725 L 656 719 L 663 713 L 664 586 L 683 587 L 683 712 L 691 719 L 695 729 L 695 741 L 691 749 L 683 756 L 683 816 L 680 817 L 683 818 L 683 977 L 735 977 L 735 888 L 754 887 L 754 781 L 762 780 L 754 779 L 754 688 L 747 683 L 742 672 L 744 656 L 754 644 L 736 609 L 734 585 L 585 585 L 574 597 L 572 604 L 558 604 L 554 602 L 554 597 L 543 585 L 425 585 L 424 566 L 544 565 L 547 559 L 554 554 L 555 546 L 573 546 L 574 554 L 579 557 L 584 565 L 734 565 L 734 545 L 736 543 L 752 543 L 754 545 L 754 599 L 757 608 L 770 629 L 774 646 L 781 651 L 784 657 L 807 656 L 817 652 L 848 632 L 861 629 Z M 396 543 L 398 545 L 398 554 L 408 565 L 423 566 L 423 584 L 408 585 L 406 590 L 398 597 L 398 666 L 390 690 L 390 699 L 384 701 L 390 702 L 390 767 L 397 773 L 402 785 L 401 797 L 398 803 L 390 810 L 390 911 L 388 913 L 328 913 L 328 893 L 370 893 L 371 811 L 364 805 L 361 799 L 360 781 L 371 764 L 371 687 L 378 665 L 378 597 L 370 590 L 367 584 L 366 571 L 370 561 L 378 554 L 378 545 L 380 543 Z M 1070 539 L 1078 539 L 1080 541 L 1079 546 L 1080 551 L 1083 553 L 1082 555 L 1074 555 L 1074 550 L 1072 555 L 1066 554 L 1069 551 L 1070 545 L 1076 545 L 1070 545 Z M 53 540 L 62 539 L 64 544 L 54 545 Z M 281 552 L 314 551 L 315 534 L 350 534 L 351 597 L 349 599 L 282 598 Z M 205 535 L 246 534 L 247 551 L 279 551 L 280 598 L 206 599 L 204 593 Z M 912 533 L 914 531 L 1009 531 L 1011 533 L 1011 590 L 913 591 Z M 1066 530 L 1082 529 L 1083 533 L 1080 534 L 1079 539 L 1070 539 Z M 50 530 L 56 529 L 58 534 L 59 529 L 67 529 L 68 533 L 64 535 L 63 539 L 54 539 L 53 535 L 50 534 Z M 531 542 L 538 519 L 591 519 L 597 544 L 532 545 Z M 1066 525 L 1076 524 L 1070 524 L 1070 518 L 1079 518 L 1083 528 L 1067 529 Z M 50 525 L 60 524 L 54 524 L 54 518 L 63 518 L 68 528 L 51 529 Z M 248 518 L 312 517 L 313 550 L 249 551 Z M 72 516 L 74 517 L 73 535 L 69 533 L 69 524 L 71 523 Z M 66 514 L 70 515 L 69 521 L 65 520 Z M 1064 513 L 1067 514 L 1066 521 L 1063 520 Z M 1069 513 L 1079 512 L 1081 516 L 1079 518 L 1070 518 Z M 53 514 L 62 511 L 64 517 L 54 518 Z M 1083 508 L 1087 510 L 1085 518 L 1082 517 Z M 405 508 L 436 509 L 436 541 L 434 543 L 404 542 Z M 373 508 L 403 509 L 403 541 L 401 543 L 374 543 L 372 541 Z M 438 508 L 462 507 L 467 509 L 467 541 L 465 543 L 437 542 L 436 523 Z M 1066 502 L 1072 501 L 1073 506 L 1076 506 L 1073 505 L 1075 501 L 1082 501 L 1083 505 L 1079 506 L 1079 512 L 1070 512 L 1070 506 L 1067 506 Z M 50 502 L 59 501 L 60 505 L 58 506 L 60 507 L 60 503 L 66 501 L 67 506 L 63 507 L 63 511 L 54 512 Z M 68 496 L 66 501 L 58 500 L 59 496 Z M 50 496 L 57 496 L 58 500 L 51 501 Z M 72 494 L 74 495 L 73 507 L 69 505 L 69 496 Z M 1073 491 L 1079 490 L 1080 495 L 1074 496 Z M 1066 496 L 1072 490 L 1073 497 L 1082 495 L 1083 500 L 1067 501 Z M 53 491 L 63 490 L 64 494 L 62 496 L 54 496 Z M 527 507 L 542 504 L 565 488 L 587 504 L 601 506 L 602 508 L 595 518 L 560 519 L 532 517 Z M 1013 485 L 1040 486 L 1039 591 L 1012 590 Z M 883 485 L 912 486 L 911 591 L 882 590 Z M 695 545 L 695 562 L 685 564 L 587 564 L 576 553 L 577 546 L 599 546 L 595 522 L 639 522 L 639 487 L 641 485 L 652 485 L 654 487 L 654 544 Z M 437 562 L 438 544 L 468 543 L 469 485 L 488 486 L 488 522 L 533 522 L 534 526 L 529 546 L 551 546 L 553 548 L 553 552 L 542 563 L 444 564 Z M 1069 485 L 1079 484 L 1080 489 L 1070 490 Z M 53 485 L 63 484 L 64 489 L 54 490 Z M 77 474 L 96 475 L 96 825 L 109 854 L 110 881 L 116 885 L 121 893 L 157 894 L 156 913 L 121 913 L 110 924 L 109 1027 L 90 1026 L 90 924 L 82 918 L 78 910 L 79 893 L 90 881 L 90 861 L 78 837 L 75 823 Z M 372 473 L 465 472 L 467 474 L 467 506 L 373 507 Z M 1066 471 L 1082 470 L 1083 478 L 1080 479 L 1080 483 L 1070 484 L 1069 478 L 1066 477 L 1070 475 Z M 639 472 L 641 470 L 653 470 L 654 482 L 652 484 L 640 484 Z M 468 471 L 487 470 L 489 472 L 489 482 L 487 484 L 469 484 Z M 50 471 L 67 470 L 68 477 L 64 479 L 63 484 L 54 484 L 53 478 L 50 476 L 56 475 L 58 478 L 58 475 L 51 475 Z M 248 468 L 312 467 L 313 496 L 249 497 L 247 489 Z M 72 464 L 75 470 L 74 479 L 69 477 L 69 468 Z M 1073 465 L 1079 463 L 1083 469 L 1074 470 Z M 1070 463 L 1073 464 L 1073 469 L 1067 470 L 1066 467 Z M 50 467 L 54 464 L 63 463 L 68 469 L 60 470 L 59 467 L 58 470 L 51 470 Z M 1069 456 L 1079 455 L 1080 462 L 1070 463 Z M 1064 455 L 1067 456 L 1066 463 L 1063 462 Z M 53 456 L 63 455 L 64 462 L 54 464 Z M 1083 452 L 1086 453 L 1085 462 L 1082 461 Z M 48 452 L 51 453 L 49 465 L 46 459 Z M 912 448 L 924 446 L 937 448 L 937 474 L 987 474 L 987 448 L 989 446 L 1009 446 L 1011 448 L 1011 530 L 913 531 Z M 1066 446 L 1073 445 L 1075 450 L 1076 446 L 1082 446 L 1083 449 L 1080 450 L 1079 455 L 1070 455 Z M 68 446 L 68 449 L 64 450 L 63 455 L 54 455 L 53 450 L 50 449 L 51 446 L 57 446 L 58 450 L 59 446 Z M 1083 441 L 1082 445 L 1066 444 L 1067 441 Z M 50 442 L 52 440 L 61 440 L 63 444 L 59 446 L 51 445 Z M 72 437 L 74 438 L 74 455 L 71 454 L 72 451 L 69 449 Z M 438 436 L 465 436 L 467 438 L 466 471 L 437 470 L 436 443 Z M 405 436 L 434 436 L 436 438 L 435 471 L 404 470 L 403 442 Z M 373 436 L 403 437 L 402 471 L 372 470 Z M 282 436 L 349 436 L 351 438 L 350 533 L 315 533 L 313 516 L 281 516 L 282 497 L 314 497 L 314 466 L 282 466 Z M 206 436 L 280 437 L 279 466 L 247 466 L 247 497 L 279 497 L 279 517 L 247 517 L 246 533 L 205 532 L 204 457 Z M 152 436 L 204 437 L 203 554 L 151 553 Z M 809 434 L 851 435 L 852 485 L 850 502 L 810 502 L 808 500 Z M 766 434 L 808 435 L 808 502 L 850 502 L 852 520 L 850 543 L 766 543 L 764 541 L 764 436 Z M 722 434 L 764 435 L 763 543 L 723 543 L 721 541 Z M 656 434 L 719 434 L 721 436 L 721 541 L 719 543 L 655 542 Z M 1070 427 L 1080 428 L 1079 434 L 1074 434 L 1073 432 L 1072 434 L 1079 434 L 1079 440 L 1068 440 Z M 1064 427 L 1067 428 L 1066 436 L 1063 435 Z M 1083 423 L 1086 424 L 1085 436 L 1082 435 Z M 66 423 L 70 424 L 69 431 L 65 429 Z M 47 423 L 51 424 L 49 432 L 47 431 Z M 336 421 L 409 422 L 408 435 L 371 435 L 371 544 L 377 545 L 377 552 L 367 563 L 365 583 L 368 590 L 377 599 L 377 607 L 375 609 L 352 608 L 352 435 L 326 435 L 325 433 Z M 190 422 L 291 421 L 302 434 L 191 435 Z M 54 421 L 64 422 L 64 434 L 59 435 L 57 431 L 58 435 L 64 436 L 63 440 L 52 439 L 53 428 L 58 427 L 53 425 Z M 939 418 L 987 419 L 987 472 L 985 474 L 938 473 Z M 1066 417 L 1082 416 L 1083 420 L 1079 421 L 1081 422 L 1079 426 L 1070 426 L 1069 422 L 1074 420 L 1067 421 Z M 555 407 L 574 408 L 574 435 L 581 441 L 585 449 L 585 462 L 582 468 L 574 475 L 573 492 L 564 486 L 555 492 L 554 475 L 546 468 L 543 462 L 544 446 L 554 435 Z M 1066 412 L 1074 411 L 1069 410 L 1070 406 L 1079 405 L 1083 415 L 1067 416 Z M 72 402 L 74 403 L 75 414 L 74 427 L 69 420 Z M 67 401 L 70 402 L 69 408 L 65 407 Z M 1069 401 L 1079 400 L 1081 404 L 1070 405 Z M 54 401 L 64 401 L 63 405 L 56 405 L 63 406 L 64 410 L 68 411 L 66 416 L 61 416 L 67 416 L 67 421 L 50 420 L 51 416 L 59 415 L 52 416 L 50 414 L 50 411 L 53 410 Z M 593 394 L 638 395 L 637 521 L 597 521 L 596 519 L 603 511 L 603 505 L 590 504 L 575 492 L 576 476 L 583 470 L 586 463 L 585 445 L 575 433 L 576 408 L 592 407 Z M 491 394 L 534 394 L 536 396 L 536 407 L 552 408 L 553 432 L 542 447 L 541 460 L 544 468 L 552 477 L 553 494 L 538 504 L 525 505 L 526 512 L 533 519 L 532 521 L 490 520 Z M 1066 390 L 1073 389 L 1074 393 L 1075 388 L 1082 388 L 1083 392 L 1080 393 L 1081 398 L 1079 400 L 1070 400 Z M 430 400 L 430 434 L 428 436 L 412 436 L 410 434 L 410 420 L 333 420 L 331 425 L 321 434 L 307 434 L 306 436 L 295 425 L 293 420 L 188 420 L 187 435 L 173 436 L 168 434 L 169 399 L 293 399 L 295 394 L 302 388 L 309 385 L 318 385 L 326 389 L 334 399 Z M 1066 385 L 1082 384 L 1083 387 L 1069 389 Z M 50 385 L 66 384 L 67 388 L 56 388 L 58 394 L 60 394 L 58 393 L 59 388 L 67 388 L 68 392 L 63 394 L 63 399 L 54 400 L 53 393 L 50 392 L 52 388 Z M 208 397 L 209 383 L 302 384 L 291 398 Z M 186 384 L 188 382 L 205 383 L 206 397 L 187 398 Z M 72 381 L 74 382 L 73 394 L 69 392 Z M 1066 382 L 1070 378 L 1080 379 L 1079 384 L 1067 384 Z M 50 382 L 54 378 L 63 378 L 67 383 L 51 384 Z M 1013 373 L 1040 374 L 1039 484 L 1012 483 Z M 912 375 L 914 373 L 1010 373 L 1011 445 L 987 445 L 987 418 L 937 418 L 937 445 L 913 446 Z M 884 373 L 912 374 L 911 484 L 882 483 L 882 375 Z M 536 374 L 590 373 L 591 405 L 537 406 Z M 66 373 L 70 374 L 69 380 L 65 378 Z M 53 373 L 63 372 L 64 377 L 54 378 Z M 950 368 L 950 372 L 881 372 L 881 592 L 949 592 L 951 594 L 951 627 L 854 629 L 837 636 L 810 654 L 787 656 L 775 644 L 772 630 L 756 602 L 755 545 L 763 545 L 763 598 L 853 598 L 853 433 L 757 433 L 755 431 L 755 407 L 767 395 L 788 395 L 799 392 L 826 372 L 836 368 Z M 1069 367 L 1079 366 L 1081 368 L 1080 376 L 1070 378 L 1069 373 L 1076 372 L 1070 372 Z M 1083 362 L 1080 366 L 1073 365 L 1074 362 Z M 1066 362 L 1072 361 L 1073 365 L 1069 366 Z M 50 363 L 57 361 L 59 363 L 58 366 L 61 366 L 59 365 L 60 362 L 68 362 L 64 366 L 63 372 L 54 372 L 53 367 L 55 366 Z M 1066 357 L 1082 356 L 1083 360 L 1074 361 L 1073 359 L 1072 361 L 1067 361 Z M 57 357 L 67 356 L 68 360 L 58 361 Z M 50 357 L 56 356 L 57 360 L 51 361 Z M 1066 354 L 1071 348 L 1073 350 L 1079 349 L 1083 355 L 1067 356 Z M 72 347 L 74 348 L 75 356 L 74 378 L 72 377 L 72 366 L 69 364 L 69 354 Z M 1083 342 L 1086 343 L 1085 352 L 1082 350 Z M 1069 343 L 1079 342 L 1080 348 L 1070 348 Z M 1064 342 L 1067 344 L 1066 352 L 1063 350 Z M 53 343 L 63 342 L 64 348 L 56 350 L 63 349 L 64 353 L 68 355 L 51 356 L 50 354 L 53 353 Z M 954 340 L 973 341 L 972 372 L 952 371 L 952 342 Z M 50 338 L 51 344 L 47 346 L 48 342 L 46 339 Z M 404 337 L 465 336 L 467 338 L 467 380 L 465 382 L 405 382 Z M 722 391 L 723 374 L 734 362 L 735 335 L 754 336 L 754 362 L 762 368 L 765 374 L 791 372 L 818 352 L 835 347 L 950 347 L 952 349 L 951 367 L 837 367 L 825 371 L 798 391 L 785 394 L 765 394 L 761 401 L 754 406 L 753 433 L 736 433 L 734 431 L 734 405 L 727 400 Z M 50 334 L 67 333 L 68 336 L 64 337 L 63 342 L 54 342 Z M 1066 334 L 1074 333 L 1074 328 L 1083 329 L 1082 332 L 1077 332 L 1083 334 L 1079 342 L 1070 342 Z M 50 329 L 56 328 L 57 332 L 51 333 Z M 564 349 L 592 348 L 593 326 L 637 326 L 638 392 L 593 393 L 591 372 L 564 371 Z M 490 327 L 535 326 L 536 348 L 564 349 L 564 371 L 536 372 L 535 393 L 491 393 Z M 243 328 L 245 326 L 299 326 L 300 381 L 245 382 L 243 380 Z M 1073 323 L 1079 322 L 1082 327 L 1075 328 Z M 61 322 L 68 326 L 67 332 L 57 332 L 58 328 L 62 328 L 59 327 Z M 1066 327 L 1069 324 L 1070 318 L 1080 319 L 1079 321 L 1072 322 L 1072 328 Z M 53 327 L 54 318 L 63 319 L 62 322 L 56 322 L 59 323 L 57 328 Z M 1069 314 L 1079 313 L 1080 317 L 1070 318 Z M 731 335 L 733 337 L 733 360 L 722 373 L 721 391 L 725 400 L 733 407 L 733 432 L 654 433 L 654 467 L 652 469 L 641 469 L 639 467 L 640 315 L 648 313 L 653 315 L 653 335 Z M 488 468 L 468 468 L 467 435 L 432 434 L 432 398 L 335 398 L 324 384 L 467 383 L 468 314 L 487 313 L 489 384 Z M 52 315 L 54 313 L 63 313 L 64 317 L 54 318 Z M 66 310 L 70 311 L 69 318 L 65 317 Z M 536 307 L 538 305 L 590 305 L 591 347 L 538 348 L 536 346 Z M 49 306 L 56 304 L 58 312 L 54 313 L 53 309 Z M 639 300 L 641 298 L 651 298 L 653 300 L 653 310 L 651 312 L 641 312 L 639 310 Z M 467 300 L 469 298 L 487 298 L 489 300 L 489 310 L 487 312 L 469 312 L 467 310 Z M 72 296 L 74 297 L 75 304 L 73 337 L 69 335 L 69 326 L 72 324 L 69 302 Z M 1070 293 L 1080 293 L 1084 297 L 1084 307 L 1079 313 L 1070 313 L 1069 309 L 1065 307 L 1068 304 L 1065 302 L 1066 300 L 1074 300 L 1073 298 L 1065 298 Z M 771 292 L 773 290 L 851 290 L 853 292 L 853 332 L 851 334 L 772 334 Z M 654 291 L 733 290 L 734 333 L 655 334 Z M 1083 284 L 1087 286 L 1086 294 L 1082 293 Z M 1069 286 L 1079 284 L 1081 291 L 1079 293 L 1070 292 Z M 54 285 L 64 285 L 64 296 L 67 297 L 68 303 L 62 304 L 67 304 L 68 308 L 64 308 L 63 312 L 58 311 L 58 304 L 50 303 L 53 294 L 60 293 L 53 292 Z M 243 282 L 299 281 L 300 325 L 244 326 Z M 48 281 L 51 283 L 50 292 L 46 291 L 46 283 Z M 1004 278 L 1040 279 L 1039 339 L 1003 338 Z M 883 278 L 906 277 L 925 279 L 924 339 L 882 338 Z M 736 276 L 771 277 L 770 334 L 735 333 Z M 1066 272 L 1082 271 L 1083 274 L 1078 275 L 1082 275 L 1083 278 L 1080 279 L 1081 282 L 1079 284 L 1070 284 L 1066 276 L 1072 275 L 1074 279 L 1074 274 L 1067 274 Z M 72 267 L 74 268 L 73 280 L 69 278 Z M 153 266 L 241 266 L 243 268 L 242 382 L 151 381 L 151 268 Z M 1066 268 L 1070 264 L 1079 264 L 1081 266 L 1080 270 L 1067 270 Z M 341 264 L 403 265 L 402 382 L 340 381 Z M 302 264 L 338 264 L 340 266 L 338 382 L 301 381 Z M 54 264 L 64 265 L 68 278 L 66 280 L 58 279 L 63 280 L 63 284 L 54 285 L 53 280 L 50 279 L 51 271 L 62 270 L 53 270 Z M 1069 260 L 1080 259 L 1081 262 L 1079 264 L 1070 264 Z M 53 260 L 63 259 L 64 263 L 54 264 Z M 927 254 L 1002 255 L 1001 339 L 926 338 Z M 593 251 L 638 252 L 637 326 L 593 326 L 592 305 L 564 304 L 565 285 L 592 285 Z M 536 252 L 590 251 L 591 284 L 538 285 L 536 283 Z M 490 252 L 535 251 L 536 285 L 563 285 L 564 304 L 536 305 L 535 326 L 491 326 L 489 311 Z M 771 242 L 773 240 L 851 240 L 853 242 L 853 288 L 851 290 L 773 290 L 771 288 Z M 654 241 L 733 240 L 734 289 L 655 290 Z M 71 239 L 74 240 L 75 260 L 73 262 L 71 261 L 72 252 L 69 250 L 69 241 Z M 1070 235 L 1079 234 L 1080 239 L 1083 241 L 1083 251 L 1079 259 L 1070 258 L 1069 252 L 1066 250 L 1065 245 L 1068 244 L 1066 240 L 1069 239 Z M 54 234 L 58 236 L 57 244 L 62 243 L 58 242 L 59 234 L 63 234 L 63 239 L 68 241 L 67 251 L 64 252 L 63 259 L 53 257 L 50 245 L 54 243 L 50 241 L 53 239 Z M 66 230 L 70 231 L 69 238 L 65 237 Z M 48 230 L 51 231 L 50 238 L 46 236 Z M 1083 229 L 1087 230 L 1085 238 L 1082 237 Z M 553 210 L 577 211 L 576 250 L 553 250 L 551 248 Z M 882 211 L 884 209 L 924 209 L 926 211 L 925 232 L 1003 232 L 1002 211 L 1004 209 L 1038 209 L 1040 211 L 1040 276 L 1004 277 L 1003 254 L 925 254 L 924 277 L 883 277 Z M 1070 207 L 1079 207 L 1083 212 L 1083 217 L 1078 218 L 1083 219 L 1080 227 L 1072 228 L 1079 228 L 1079 234 L 1069 233 L 1069 223 L 1066 222 L 1066 219 L 1074 218 L 1067 218 L 1066 215 L 1078 214 L 1075 214 L 1074 211 L 1072 214 L 1067 214 L 1066 212 L 1069 211 Z M 405 207 L 465 207 L 467 209 L 467 331 L 465 336 L 404 335 Z M 340 208 L 402 207 L 403 263 L 341 264 Z M 54 206 L 62 206 L 64 211 L 68 212 L 68 222 L 62 223 L 64 224 L 63 228 L 58 228 L 64 229 L 63 234 L 53 233 L 53 223 L 50 222 L 50 219 L 58 219 L 50 217 Z M 1064 202 L 1067 203 L 1066 210 L 1063 209 Z M 68 201 L 70 202 L 70 209 L 66 210 L 65 203 Z M 1069 201 L 1079 200 L 1080 205 L 1070 206 Z M 53 205 L 54 200 L 64 201 L 62 206 Z M 1083 197 L 1086 198 L 1085 206 L 1082 205 Z M 47 197 L 51 198 L 50 209 L 47 208 Z M 926 188 L 1001 187 L 1002 231 L 927 232 Z M 735 187 L 771 188 L 770 276 L 735 275 Z M 302 187 L 340 188 L 338 264 L 301 263 Z M 244 187 L 300 188 L 300 279 L 298 281 L 243 279 Z M 1070 178 L 1079 178 L 1080 183 L 1083 184 L 1082 194 L 1073 193 L 1080 195 L 1079 200 L 1070 200 L 1068 198 L 1069 195 L 1066 193 L 1066 190 L 1068 188 L 1073 190 L 1078 188 L 1074 187 L 1074 181 L 1072 188 L 1066 187 Z M 1083 171 L 1087 173 L 1086 181 L 1082 180 Z M 1069 172 L 1079 171 L 1080 177 L 1070 177 Z M 1064 171 L 1067 173 L 1066 181 L 1063 180 Z M 54 171 L 63 171 L 64 183 L 68 184 L 68 194 L 64 195 L 63 200 L 54 200 L 53 195 L 50 194 L 50 188 L 52 187 L 50 185 L 55 177 L 53 176 Z M 1069 166 L 1079 165 L 1080 170 L 1070 171 Z M 53 166 L 58 165 L 60 169 L 54 171 Z M 530 164 L 598 163 L 599 208 L 530 209 Z M 50 160 L 56 159 L 57 164 L 51 166 Z M 1074 159 L 1082 158 L 1083 164 L 1075 165 Z M 1066 159 L 1073 158 L 1074 164 L 1067 165 Z M 50 155 L 54 152 L 63 152 L 68 155 L 66 158 L 68 164 L 66 166 L 59 165 L 57 160 L 63 158 L 61 156 L 51 158 Z M 66 145 L 70 146 L 69 153 L 65 151 Z M 64 144 L 63 151 L 53 151 L 54 144 Z M 1064 140 L 1067 141 L 1067 148 L 1065 150 L 1063 149 Z M 47 140 L 51 141 L 50 152 L 46 150 Z M 1067 134 L 1073 134 L 1074 138 L 1075 134 L 1083 135 L 1080 138 L 1082 158 L 1066 157 L 1070 152 L 1075 152 L 1075 147 L 1073 152 L 1069 151 L 1069 145 L 1075 143 L 1069 142 L 1069 138 L 1066 137 Z M 926 131 L 1001 130 L 1002 165 L 927 166 Z M 882 132 L 884 130 L 924 130 L 925 166 L 1003 166 L 1003 131 L 1039 130 L 1040 208 L 1004 209 L 1002 186 L 926 186 L 924 209 L 883 209 Z M 852 130 L 853 238 L 851 240 L 773 240 L 771 238 L 771 188 L 816 187 L 816 131 Z M 780 130 L 814 130 L 816 132 L 815 186 L 780 186 L 778 184 L 778 132 Z M 728 130 L 778 131 L 777 186 L 727 185 Z M 691 130 L 726 131 L 725 186 L 690 185 L 689 132 Z M 655 130 L 689 131 L 690 187 L 734 188 L 733 240 L 654 239 Z M 427 130 L 467 131 L 467 205 L 465 207 L 426 206 Z M 383 130 L 425 131 L 424 207 L 382 206 Z M 341 130 L 381 131 L 380 207 L 340 206 Z M 243 132 L 245 130 L 338 130 L 339 185 L 244 186 Z M 152 130 L 243 131 L 242 266 L 151 265 Z M 50 132 L 52 130 L 62 131 L 61 134 L 51 134 Z M 1066 127 L 1069 126 L 1070 121 L 1079 121 L 1080 126 L 1083 127 L 1081 129 L 1083 132 L 1067 134 L 1066 131 L 1068 130 Z M 1069 116 L 1079 115 L 1080 119 L 1070 120 Z M 54 115 L 63 115 L 63 126 L 68 127 L 68 137 L 64 138 L 63 143 L 54 144 L 53 138 L 50 137 L 51 134 L 56 134 L 58 138 L 58 134 L 63 134 L 62 130 L 59 129 L 59 125 L 58 130 L 50 129 L 53 126 L 54 120 L 59 121 L 53 119 Z M 774 114 L 941 114 L 952 126 L 950 129 L 881 130 L 881 340 L 950 341 L 950 346 L 827 347 L 814 353 L 795 369 L 787 372 L 767 372 L 756 361 L 757 335 L 854 335 L 854 130 L 763 129 L 762 126 Z M 728 114 L 740 126 L 739 129 L 653 129 L 653 296 L 641 297 L 639 295 L 639 250 L 578 249 L 578 211 L 600 210 L 600 162 L 577 162 L 576 154 L 585 144 L 618 144 L 633 140 L 664 115 Z M 428 114 L 461 114 L 468 116 L 491 137 L 501 142 L 513 144 L 541 143 L 553 156 L 552 162 L 528 163 L 528 210 L 550 211 L 550 249 L 489 250 L 487 297 L 468 296 L 468 130 L 417 129 L 416 126 Z M 124 114 L 382 114 L 393 125 L 392 129 L 150 129 L 149 140 L 150 383 L 183 383 L 185 385 L 185 396 L 183 398 L 167 398 L 167 434 L 150 435 L 150 825 L 352 825 L 352 630 L 376 630 L 377 665 L 369 691 L 370 763 L 362 773 L 358 783 L 359 798 L 369 812 L 369 890 L 367 892 L 267 892 L 259 883 L 249 878 L 237 878 L 228 883 L 221 892 L 122 891 L 112 880 L 111 856 L 100 834 L 97 822 L 97 171 L 99 160 L 109 141 L 112 126 Z M 66 112 L 70 113 L 69 119 L 65 118 Z M 50 111 L 51 123 L 48 125 L 46 123 L 46 113 Z M 1066 106 L 1072 105 L 1073 110 L 1075 110 L 1075 105 L 1083 105 L 1084 108 L 1080 110 L 1079 115 L 1070 115 Z M 50 106 L 57 105 L 58 110 L 60 110 L 58 109 L 59 105 L 67 105 L 68 109 L 63 110 L 63 115 L 54 115 Z M 1066 99 L 1070 93 L 1079 94 L 1080 99 L 1075 100 L 1074 98 L 1072 101 L 1082 100 L 1084 103 L 1082 105 L 1067 105 Z M 68 99 L 66 105 L 50 104 L 54 94 L 58 95 L 58 99 L 54 100 L 61 100 L 58 99 L 60 93 L 64 95 L 64 98 Z M 445 92 L 464 91 L 480 97 L 502 118 L 510 121 L 544 121 L 554 110 L 554 103 L 556 101 L 572 101 L 574 103 L 574 111 L 584 121 L 619 121 L 628 117 L 649 97 L 666 91 L 684 92 L 684 112 L 663 114 L 657 117 L 638 135 L 623 142 L 584 142 L 581 148 L 574 153 L 573 162 L 555 162 L 554 154 L 546 147 L 544 142 L 506 142 L 492 136 L 468 115 L 446 113 Z M 1069 88 L 1079 87 L 1080 92 L 1070 93 Z M 53 88 L 63 87 L 64 92 L 54 93 Z M 48 84 L 51 85 L 50 93 L 46 91 Z M 1083 83 L 1087 89 L 1085 93 L 1082 92 Z M 1064 83 L 1067 84 L 1066 93 L 1063 92 Z M 66 83 L 70 84 L 70 91 L 68 93 L 65 92 Z M 987 98 L 985 113 L 973 125 L 972 129 L 954 129 L 953 124 L 945 118 L 943 113 L 834 112 L 835 91 L 942 91 L 950 81 L 959 77 L 968 77 L 978 82 L 982 86 Z M 684 92 L 730 91 L 739 80 L 746 77 L 755 77 L 766 82 L 772 91 L 833 91 L 834 112 L 772 113 L 761 124 L 760 129 L 742 129 L 741 124 L 730 113 L 685 113 Z M 445 92 L 445 111 L 443 113 L 426 113 L 415 124 L 414 129 L 396 129 L 395 125 L 384 113 L 263 112 L 264 91 L 384 91 L 391 81 L 401 77 L 409 77 L 417 80 L 426 91 Z M 262 91 L 262 113 L 141 113 L 140 108 L 138 113 L 122 113 L 111 124 L 109 137 L 96 167 L 96 473 L 77 474 L 76 165 L 80 150 L 91 126 L 80 113 L 78 106 L 79 93 L 89 80 L 97 77 L 112 79 L 120 86 L 122 91 L 138 91 L 140 97 L 141 91 Z M 50 78 L 63 77 L 63 82 L 57 82 L 63 82 L 64 86 L 54 87 L 53 81 Z M 611 67 L 614 69 L 630 69 L 631 67 L 659 69 L 662 66 L 673 69 L 689 69 L 691 66 L 696 66 L 702 69 L 718 69 L 720 66 L 731 66 L 732 69 L 749 69 L 750 67 L 761 67 L 762 69 L 778 69 L 779 67 L 807 69 L 808 67 L 819 66 L 821 69 L 836 69 L 838 67 L 865 69 L 867 66 L 877 66 L 879 69 L 895 69 L 907 66 L 909 69 L 925 69 L 926 66 L 937 66 L 939 69 L 954 69 L 955 67 L 966 67 L 968 69 L 983 69 L 985 67 L 1013 69 L 1014 67 L 1024 66 L 1026 69 L 1042 69 L 1044 66 L 1053 66 L 1055 69 L 1064 70 L 1064 81 L 1061 86 L 1061 96 L 1064 99 L 1064 108 L 1061 116 L 1062 126 L 1064 127 L 1061 153 L 1064 155 L 1064 165 L 1061 167 L 1061 182 L 1064 188 L 1064 194 L 1061 196 L 1062 211 L 1064 212 L 1061 238 L 1064 240 L 1064 250 L 1061 255 L 1061 267 L 1064 269 L 1064 278 L 1061 281 L 1061 295 L 1064 298 L 1064 307 L 1061 310 L 1062 324 L 1064 326 L 1061 348 L 1064 355 L 1064 364 L 1062 365 L 1064 392 L 1061 394 L 1061 409 L 1064 411 L 1064 421 L 1061 427 L 1061 437 L 1064 439 L 1064 449 L 1061 453 L 1062 466 L 1064 467 L 1064 477 L 1061 481 L 1061 493 L 1064 496 L 1064 505 L 1061 507 L 1061 522 L 1064 524 L 1064 534 L 1062 535 L 1061 550 L 1064 552 L 1061 577 L 1064 581 L 1064 590 L 1061 593 L 1061 607 L 1064 609 L 1064 619 L 1061 623 L 1062 636 L 1064 638 L 1064 647 L 1061 649 L 1062 664 L 1064 666 L 1064 675 L 1061 679 L 1062 692 L 1064 694 L 1061 720 L 1064 722 L 1064 732 L 1061 738 L 1061 749 L 1064 750 L 1064 760 L 1061 763 L 1061 777 L 1064 779 L 1064 789 L 1062 790 L 1064 817 L 1062 819 L 1061 833 L 1064 836 L 1064 845 L 1062 847 L 1061 862 L 1064 865 L 1064 874 L 1062 875 L 1061 890 L 1064 893 L 1064 903 L 1062 904 L 1062 918 L 1060 920 L 1049 919 L 1049 886 L 979 886 L 968 875 L 968 811 L 1013 810 L 1012 663 L 878 664 L 878 810 L 945 811 L 945 875 L 935 886 L 864 886 L 853 875 L 853 833 L 865 832 L 865 682 L 817 682 L 817 831 L 829 833 L 829 875 L 819 886 L 777 886 L 775 884 L 775 690 L 785 679 L 807 678 L 821 674 L 851 654 L 861 651 L 974 651 L 974 594 L 976 592 L 1041 592 L 1041 372 L 976 372 L 974 368 L 974 344 L 976 340 L 1041 341 L 1041 129 L 976 129 L 975 126 L 983 119 L 987 111 L 988 98 L 982 84 L 971 76 L 954 77 L 941 90 L 774 90 L 761 77 L 744 76 L 736 80 L 728 90 L 689 89 L 660 91 L 645 98 L 623 118 L 617 120 L 586 120 L 575 108 L 576 102 L 617 101 L 611 77 Z M 69 222 L 72 196 L 69 194 L 71 183 L 71 166 L 69 162 L 72 153 L 72 139 L 69 137 L 69 127 L 72 121 L 72 110 L 69 109 L 69 99 L 71 97 L 69 76 L 71 67 L 95 69 L 97 66 L 107 66 L 109 69 L 125 69 L 127 66 L 137 66 L 139 69 L 155 69 L 156 67 L 167 67 L 168 69 L 184 69 L 185 67 L 213 69 L 215 66 L 223 66 L 227 69 L 242 69 L 244 66 L 255 66 L 257 69 L 272 69 L 274 66 L 286 69 L 301 69 L 303 66 L 314 66 L 315 69 L 331 69 L 333 66 L 343 66 L 345 69 L 361 69 L 362 67 L 373 67 L 375 69 L 391 69 L 392 67 L 420 69 L 421 66 L 426 66 L 433 69 L 450 69 L 454 66 L 462 67 L 463 69 L 479 69 L 480 67 L 509 69 L 510 66 L 520 66 L 520 76 L 514 101 L 551 102 L 553 104 L 553 108 L 542 120 L 511 120 L 502 116 L 485 99 L 473 92 L 465 90 L 428 90 L 421 81 L 411 76 L 395 77 L 382 90 L 124 90 L 111 77 L 95 76 L 83 83 L 77 96 L 78 112 L 89 125 L 89 129 L 76 158 L 74 170 L 74 223 Z M 1001 64 L 1009 62 L 1011 66 L 1009 67 L 1008 65 L 1004 68 Z M 969 64 L 978 62 L 982 66 L 970 68 Z M 823 67 L 826 62 L 832 63 L 830 67 Z M 793 64 L 804 62 L 805 66 L 803 67 L 802 65 L 798 68 L 794 67 Z M 763 64 L 772 62 L 776 64 L 776 67 L 764 67 Z M 741 63 L 746 62 L 747 66 L 743 68 Z M 704 64 L 710 62 L 711 66 L 706 68 Z M 622 64 L 627 62 L 629 66 L 624 68 Z M 616 63 L 620 62 L 622 66 L 617 68 Z M 501 64 L 506 62 L 507 67 L 503 68 Z M 435 64 L 443 62 L 445 66 L 436 67 Z M 415 63 L 412 68 L 406 67 L 407 63 Z M 376 64 L 388 62 L 389 67 L 385 68 L 383 65 L 381 68 L 378 68 Z M 347 63 L 355 62 L 359 66 L 355 68 L 353 65 L 348 68 Z M 317 63 L 323 62 L 324 66 L 318 67 Z M 288 63 L 298 62 L 299 66 L 297 68 L 289 67 Z M 239 63 L 237 67 L 229 66 L 230 63 Z M 116 64 L 122 62 L 123 67 L 119 68 Z M 81 64 L 93 62 L 94 67 L 82 67 Z M 926 62 L 937 61 L 938 64 L 927 65 Z M 1013 64 L 1014 60 L 1020 61 L 1018 65 Z M 807 62 L 812 60 L 814 64 L 808 65 Z M 778 62 L 782 60 L 786 61 L 787 64 L 779 65 Z M 509 61 L 513 60 L 515 62 L 520 60 L 521 64 L 510 65 Z M 361 62 L 363 60 L 368 60 L 369 62 L 373 60 L 374 64 L 362 65 Z M 525 56 L 605 55 L 615 99 L 612 101 L 518 101 L 516 98 Z M 807 55 L 820 54 L 821 59 L 808 60 Z M 610 54 L 615 55 L 613 65 L 609 64 L 608 56 Z M 953 54 L 966 53 L 968 58 L 964 58 L 963 61 L 966 61 L 967 64 L 960 65 L 960 61 L 953 61 Z M 924 54 L 939 53 L 942 59 L 940 61 L 925 61 Z M 864 55 L 866 53 L 878 53 L 879 64 L 872 65 L 871 59 L 871 64 L 867 65 Z M 837 54 L 849 53 L 850 59 L 846 60 L 850 64 L 844 65 L 844 61 L 837 59 Z M 688 54 L 702 53 L 703 60 L 701 62 L 703 64 L 690 65 L 690 62 L 698 62 L 694 57 L 693 62 L 689 61 Z M 658 55 L 660 53 L 673 53 L 673 64 L 667 65 L 667 61 L 660 60 Z M 629 54 L 643 53 L 644 60 L 642 61 L 641 59 L 644 64 L 631 65 L 631 60 L 636 60 L 637 62 L 638 60 L 630 60 Z M 479 54 L 492 53 L 492 59 L 488 60 L 492 64 L 480 65 Z M 464 60 L 465 53 L 478 54 L 476 61 Z M 419 54 L 433 53 L 434 56 L 431 61 L 433 64 L 428 65 L 428 61 L 425 61 L 426 64 L 421 65 L 421 61 L 418 60 Z M 376 54 L 404 53 L 405 60 L 377 61 Z M 360 55 L 362 53 L 374 54 L 375 59 L 361 60 Z M 300 55 L 302 53 L 315 53 L 316 60 L 308 61 L 308 65 L 303 65 Z M 242 54 L 251 53 L 253 57 L 251 60 L 243 60 Z M 213 54 L 225 53 L 227 55 L 225 61 L 227 64 L 214 65 L 214 61 L 219 61 L 213 60 Z M 169 54 L 181 53 L 182 60 L 170 61 Z M 152 55 L 154 53 L 166 53 L 167 58 L 157 59 L 161 59 L 162 64 L 155 65 Z M 943 50 L 951 51 L 950 61 L 943 60 L 941 56 Z M 979 49 L 982 54 L 981 60 L 977 61 L 976 58 L 974 61 L 970 61 L 969 54 L 975 53 Z M 762 54 L 764 49 L 767 49 L 769 53 L 771 50 L 776 50 L 777 52 L 773 53 L 777 57 L 779 53 L 791 53 L 792 59 L 790 61 L 785 61 L 783 58 L 779 61 L 763 61 Z M 688 50 L 686 61 L 674 60 L 675 53 L 682 53 L 683 49 Z M 615 52 L 621 49 L 622 52 L 620 53 L 623 53 L 622 51 L 627 49 L 628 60 L 617 61 Z M 427 50 L 440 49 L 442 53 L 448 54 L 448 60 L 439 61 L 437 58 L 438 60 L 434 61 L 435 53 L 428 53 Z M 280 54 L 287 53 L 288 49 L 292 49 L 294 53 L 294 50 L 297 49 L 299 51 L 299 60 L 290 61 L 289 58 L 287 61 L 281 61 Z M 140 51 L 151 49 L 152 60 L 141 61 L 139 59 L 140 54 L 146 53 L 141 53 Z M 88 51 L 102 50 L 101 53 L 89 53 Z M 667 49 L 680 49 L 681 52 L 668 53 Z M 524 55 L 522 60 L 509 61 L 507 57 L 506 61 L 495 61 L 493 56 L 495 49 L 500 50 L 500 53 L 502 53 L 502 50 L 508 50 L 510 46 L 515 52 L 506 54 L 519 53 Z M 153 51 L 156 46 L 161 47 L 160 53 L 154 53 Z M 1076 51 L 1077 45 L 1085 46 L 1082 51 Z M 1051 45 L 1055 46 L 1055 53 L 1048 52 Z M 1043 45 L 1048 46 L 1046 54 L 1057 54 L 1058 49 L 1061 49 L 1063 54 L 1066 54 L 1064 53 L 1065 49 L 1073 49 L 1074 53 L 1068 53 L 1079 55 L 1078 68 L 1080 71 L 1078 72 L 1078 78 L 1084 78 L 1080 82 L 1079 87 L 1070 87 L 1069 82 L 1066 81 L 1067 77 L 1074 78 L 1073 76 L 1066 76 L 1067 73 L 1074 73 L 1066 71 L 1069 69 L 1070 64 L 1074 64 L 1064 61 L 1063 57 L 1062 61 L 1054 61 L 1054 65 L 1048 64 L 1050 60 L 1041 60 Z M 1013 55 L 1022 54 L 1020 53 L 1021 45 L 1025 45 L 1027 50 L 1033 49 L 1034 53 L 1035 49 L 1040 51 L 1038 61 L 1033 61 L 1032 58 L 1028 61 L 1027 54 L 1025 54 L 1025 65 L 1020 64 L 1020 61 L 1023 60 L 1014 60 Z M 1014 45 L 1019 46 L 1018 54 L 1012 53 Z M 981 51 L 985 45 L 996 45 L 997 49 L 1001 50 L 1002 53 L 1004 50 L 1010 50 L 1011 56 L 1008 57 L 1011 60 L 1000 61 L 998 54 L 995 60 L 983 60 L 983 53 Z M 961 46 L 966 45 L 968 52 L 963 53 Z M 952 50 L 955 49 L 955 45 L 961 46 L 960 53 L 953 53 Z M 924 50 L 928 46 L 936 45 L 940 52 L 934 53 L 933 48 L 932 53 L 925 53 Z M 895 50 L 897 46 L 902 45 L 903 48 L 905 45 L 908 45 L 910 52 L 896 53 Z M 871 49 L 873 45 L 878 45 L 878 49 L 886 49 L 887 53 L 889 49 L 892 49 L 894 54 L 910 54 L 912 50 L 916 50 L 917 53 L 921 49 L 923 51 L 923 60 L 908 61 L 908 65 L 897 65 L 896 62 L 905 61 L 905 57 L 903 61 L 896 61 L 895 57 L 892 58 L 892 61 L 881 61 L 880 52 L 873 53 Z M 867 45 L 871 47 L 870 53 L 864 52 Z M 843 46 L 849 45 L 850 49 L 856 49 L 857 53 L 861 49 L 863 51 L 863 60 L 853 61 L 851 53 L 843 52 Z M 806 51 L 809 45 L 819 45 L 821 50 L 828 50 L 829 53 L 831 49 L 843 49 L 842 53 L 835 54 L 834 61 L 824 61 L 824 53 L 815 53 L 814 49 L 813 53 L 807 53 Z M 783 46 L 790 45 L 791 49 L 797 49 L 798 53 L 800 53 L 800 50 L 805 50 L 806 60 L 800 61 L 799 59 L 794 61 L 793 54 L 787 53 Z M 778 46 L 782 45 L 785 52 L 778 53 Z M 763 50 L 760 53 L 754 51 L 746 53 L 760 53 L 759 61 L 754 60 L 754 57 L 752 61 L 749 61 L 747 57 L 746 61 L 737 61 L 736 58 L 738 57 L 733 57 L 736 58 L 735 61 L 729 60 L 730 53 L 734 54 L 737 49 L 742 53 L 741 50 L 748 50 L 750 45 L 754 48 L 755 45 L 760 45 Z M 724 46 L 731 45 L 734 52 L 726 53 Z M 720 45 L 725 49 L 723 53 L 729 55 L 729 61 L 732 62 L 731 65 L 719 64 L 718 55 L 720 53 L 718 50 Z M 689 46 L 701 45 L 701 49 L 710 50 L 711 53 L 712 49 L 716 49 L 718 51 L 717 60 L 712 61 L 711 58 L 710 61 L 705 61 L 704 54 L 708 53 L 698 53 L 697 48 L 696 53 L 690 53 Z M 666 47 L 665 53 L 658 53 L 656 61 L 646 60 L 646 53 L 653 53 L 654 49 L 659 50 L 661 45 Z M 638 47 L 642 45 L 644 50 L 651 50 L 652 52 L 639 53 Z M 631 46 L 637 45 L 638 52 L 630 53 Z M 485 46 L 491 45 L 494 52 L 486 53 Z M 485 47 L 484 53 L 471 52 L 473 49 L 479 50 L 480 45 Z M 451 45 L 462 45 L 463 47 L 461 48 L 471 51 L 470 53 L 463 53 L 462 65 L 458 65 L 457 61 L 449 59 L 449 50 L 453 49 L 450 48 Z M 398 46 L 403 45 L 404 50 L 409 49 L 412 51 L 410 53 L 414 53 L 414 49 L 419 50 L 424 45 L 426 52 L 418 53 L 416 61 L 407 61 L 406 53 L 399 53 Z M 397 46 L 396 53 L 382 52 L 383 50 L 391 50 L 392 45 Z M 382 51 L 381 53 L 370 53 L 369 50 L 367 53 L 359 53 L 360 56 L 357 61 L 353 60 L 353 56 L 353 60 L 345 61 L 344 65 L 331 64 L 333 60 L 340 62 L 343 60 L 332 59 L 332 53 L 345 53 L 346 57 L 349 50 L 352 50 L 354 53 L 355 50 L 361 50 L 362 45 L 373 45 L 375 50 L 380 49 Z M 342 45 L 345 47 L 345 53 L 340 52 Z M 340 46 L 339 53 L 330 53 L 329 61 L 317 60 L 318 50 L 323 49 L 323 53 L 325 53 L 324 51 L 326 49 L 331 50 L 333 45 Z M 308 46 L 314 45 L 317 52 L 310 53 Z M 303 45 L 308 47 L 307 53 L 300 52 Z M 280 46 L 285 45 L 287 52 L 281 53 Z M 279 45 L 279 53 L 268 53 L 279 53 L 280 56 L 276 57 L 279 60 L 265 61 L 265 50 L 271 50 L 274 45 Z M 264 50 L 264 56 L 261 57 L 260 61 L 256 61 L 255 65 L 243 64 L 244 60 L 252 61 L 253 55 L 259 53 L 250 53 L 251 45 L 255 45 L 258 50 Z M 220 52 L 221 45 L 225 45 L 228 50 L 232 49 L 234 53 L 236 49 L 242 50 L 244 45 L 249 46 L 247 53 L 241 53 L 240 61 L 229 61 L 228 54 L 231 53 Z M 215 45 L 220 47 L 219 53 L 213 52 L 217 48 L 214 47 Z M 183 54 L 198 54 L 192 53 L 190 49 L 191 45 L 196 45 L 197 49 L 203 49 L 204 53 L 207 49 L 211 49 L 212 60 L 207 61 L 205 58 L 204 61 L 197 60 L 196 65 L 185 65 L 184 62 L 187 60 L 190 62 L 190 60 L 184 60 Z M 189 46 L 189 53 L 176 52 L 177 50 L 184 50 L 186 45 Z M 161 49 L 163 45 L 166 45 L 167 49 L 174 49 L 175 52 L 163 53 Z M 134 45 L 138 46 L 137 53 L 132 52 Z M 127 45 L 132 48 L 131 53 L 124 52 L 128 48 L 126 47 Z M 105 45 L 108 46 L 109 53 L 104 52 Z M 50 72 L 53 69 L 53 58 L 60 57 L 58 56 L 61 53 L 58 52 L 60 49 L 70 49 L 70 54 L 82 54 L 74 52 L 75 45 L 78 45 L 81 50 L 87 50 L 87 54 L 110 54 L 111 49 L 115 49 L 115 53 L 118 53 L 116 52 L 118 49 L 122 49 L 123 53 L 138 54 L 136 61 L 124 61 L 124 57 L 122 61 L 112 61 L 110 57 L 108 65 L 104 64 L 104 60 L 99 61 L 97 65 L 95 60 L 89 61 L 88 57 L 86 61 L 64 61 L 63 64 L 57 64 L 64 65 L 63 77 L 52 77 L 52 73 L 58 72 Z M 1028 45 L 1036 44 L 1037 47 L 1029 48 Z M 1000 45 L 1006 43 L 1008 47 L 1001 48 Z M 881 45 L 890 43 L 894 47 L 882 48 Z M 793 44 L 802 44 L 803 47 L 794 48 Z M 704 45 L 709 43 L 711 47 L 705 48 Z M 494 46 L 498 43 L 507 45 L 506 48 L 495 48 Z M 465 47 L 466 43 L 476 44 L 474 48 Z M 406 44 L 414 44 L 415 47 L 407 48 Z M 289 45 L 291 43 L 298 44 L 299 47 L 290 48 Z M 123 44 L 122 48 L 111 47 L 112 44 Z M 80 46 L 84 43 L 88 45 L 87 48 L 81 48 Z M 58 45 L 61 43 L 66 47 L 59 48 Z M 510 36 L 533 31 L 565 7 L 603 33 L 622 35 L 620 45 L 614 51 L 607 54 L 525 54 L 519 52 L 512 45 Z M 568 3 L 1152 4 L 1151 1105 L 1091 1122 L 1088 1121 L 1086 1113 L 1088 1086 L 1085 1080 L 1088 1072 L 1088 1058 L 1086 1056 L 1088 1030 L 1085 1028 L 1085 1022 L 1088 1017 L 1088 1007 L 1083 1011 L 1082 1004 L 1087 1002 L 1086 998 L 1088 996 L 1088 988 L 1086 987 L 1086 977 L 1088 976 L 1088 961 L 1086 960 L 1086 949 L 1088 948 L 1088 933 L 1086 932 L 1086 921 L 1088 920 L 1088 904 L 1086 903 L 1086 892 L 1088 891 L 1088 876 L 1086 875 L 1086 864 L 1088 863 L 1088 848 L 1086 846 L 1086 835 L 1088 834 L 1088 819 L 1086 818 L 1088 791 L 1085 789 L 1088 777 L 1088 762 L 1085 757 L 1085 750 L 1088 748 L 1088 734 L 1086 733 L 1086 722 L 1088 720 L 1088 705 L 1086 704 L 1088 677 L 1085 675 L 1085 666 L 1088 664 L 1088 649 L 1086 648 L 1086 637 L 1088 635 L 1088 621 L 1086 620 L 1086 608 L 1088 607 L 1088 592 L 1086 591 L 1086 580 L 1088 578 L 1088 564 L 1086 563 L 1088 535 L 1086 534 L 1085 525 L 1088 522 L 1088 508 L 1086 506 L 1086 495 L 1088 494 L 1088 479 L 1086 478 L 1086 467 L 1088 465 L 1088 451 L 1086 450 L 1086 438 L 1088 437 L 1088 422 L 1086 421 L 1086 410 L 1088 409 L 1088 394 L 1086 393 L 1086 382 L 1088 381 L 1088 366 L 1086 365 L 1086 354 L 1088 353 L 1088 338 L 1086 336 L 1088 309 L 1085 307 L 1085 297 L 1088 295 L 1088 281 L 1086 279 L 1086 268 L 1088 267 L 1088 253 L 1086 251 L 1086 240 L 1088 239 L 1088 224 L 1086 223 L 1086 212 L 1088 210 L 1088 196 L 1086 194 L 1086 184 L 1088 182 L 1088 167 L 1086 166 L 1086 155 L 1088 154 L 1088 139 L 1086 138 L 1086 127 L 1088 126 L 1088 111 L 1086 109 L 1088 82 L 1085 80 L 1086 69 L 1088 68 L 1085 63 L 1087 44 L 1072 45 L 1070 42 L 1056 42 L 1049 45 L 1044 45 L 1041 42 L 1027 42 L 1026 44 L 997 42 L 996 45 L 985 45 L 983 42 L 968 42 L 967 44 L 959 45 L 940 42 L 937 45 L 925 44 L 924 42 L 909 42 L 905 45 L 897 45 L 895 42 L 880 42 L 879 44 L 851 42 L 845 45 L 838 45 L 835 42 L 821 42 L 820 44 L 792 42 L 790 45 L 780 45 L 776 42 L 763 42 L 760 45 L 752 45 L 748 42 L 733 42 L 731 45 L 722 45 L 718 42 L 703 42 L 702 44 L 690 44 L 688 42 L 674 42 L 672 44 L 644 42 L 643 44 L 631 44 L 630 42 L 624 43 L 622 41 L 623 33 L 610 34 L 600 30 L 567 5 Z M 564 3 L 565 5 L 534 29 L 521 34 L 509 33 L 508 42 L 493 42 L 492 44 L 480 44 L 478 42 L 464 42 L 458 45 L 450 44 L 449 42 L 434 42 L 433 44 L 405 42 L 402 45 L 391 44 L 390 42 L 375 42 L 369 45 L 363 45 L 360 42 L 346 42 L 344 45 L 333 45 L 331 42 L 316 42 L 315 44 L 287 42 L 285 45 L 273 44 L 271 42 L 257 42 L 256 44 L 245 45 L 242 42 L 228 42 L 217 45 L 212 42 L 198 42 L 194 45 L 188 45 L 183 42 L 169 42 L 167 44 L 139 42 L 138 44 L 127 45 L 124 42 L 110 42 L 108 44 L 80 42 L 70 45 L 66 42 L 51 42 L 46 44 L 46 53 L 51 55 L 45 63 L 47 70 L 47 81 L 45 83 L 45 97 L 47 98 L 47 109 L 45 111 L 45 125 L 47 127 L 47 137 L 45 139 L 45 154 L 47 155 L 45 182 L 47 183 L 47 195 L 45 196 L 45 210 L 47 212 L 47 223 L 45 224 L 45 239 L 47 240 L 47 251 L 45 253 L 45 267 L 47 268 L 47 279 L 45 281 L 45 295 L 47 297 L 47 308 L 45 309 L 45 324 L 47 325 L 47 336 L 45 338 L 45 352 L 47 354 L 47 365 L 45 366 L 45 380 L 47 382 L 47 393 L 45 394 L 45 409 L 47 410 L 47 421 L 45 423 L 45 437 L 47 438 L 47 450 L 45 451 L 45 465 L 47 467 L 47 478 L 45 479 L 47 506 L 45 509 L 45 521 L 47 523 L 47 534 L 45 536 L 45 550 L 47 552 L 47 591 L 45 592 L 47 608 L 45 636 L 47 637 L 45 658 L 47 676 L 45 691 L 47 693 L 47 704 L 45 706 L 45 720 L 47 722 L 47 732 L 45 734 L 45 748 L 48 753 L 47 761 L 45 762 L 45 777 L 47 779 L 47 790 L 45 791 L 45 805 L 47 807 L 47 818 L 45 820 L 45 834 L 47 835 L 47 846 L 45 848 L 45 862 L 47 864 L 47 874 L 45 876 L 45 891 L 47 892 L 47 903 L 45 905 L 45 919 L 47 921 L 47 932 L 45 934 L 45 947 L 47 949 L 47 960 L 45 961 L 45 976 L 47 977 L 47 987 L 45 989 L 47 998 L 45 1001 L 45 1016 L 47 1017 L 47 1028 L 45 1030 L 45 1044 L 47 1045 L 47 1056 L 45 1058 L 45 1072 L 47 1074 L 45 1100 L 48 1104 L 43 1122 L 3 1111 L 2 3 Z",
  "regions": [
    {
      "id": "r01",
      "name": "Gate of Divine Might",
      "bonus": 1,
      "territoryIds": [
        "t001",
        "t002"
      ],
      "shape": "M 513.0 43.0 L 518.0 48.0 L 526.82 51.78 L 518.0 97.0 L 611.0 97.0 L 610.0 87.0 L 608.0 82.0 L 608.0 77.0 L 606.0 73.0 L 602.17 51.28 L 612.0 48.0 L 617.0 43.0 L 618.0 36.0 L 604.0 35.0 L 597.0 32.0 L 566.0 9.0 L 562.0 10.0 L 558.0 14.0 L 533.0 32.0 L 521.0 36.0 L 512.0 36.0 L 513.0 43.0 Z",
      "bonusAnchor": {
        "x": 565.33,
        "y": 57.58
      },
      "color": "#B8F000"
    },
    {
      "id": "r02",
      "name": "Six Western Palaces",
      "bonus": 7,
      "territoryIds": [
        "t003",
        "t004",
        "t005",
        "t006",
        "t007",
        "t016",
        "t017",
        "t020",
        "t021",
        "t029",
        "t030",
        "t031",
        "t035",
        "t039",
        "t042"
      ],
      "shape": "M 152.0 131.0 L 152.0 380.0 L 464.0 380.0 L 464.0 131.0 L 152.0 131.0 Z",
      "color": "#00D4E8"
    },
    {
      "id": "r03",
      "name": "Six Eastern Palaces",
      "bonus": 5,
      "territoryIds": [
        "t008",
        "t009",
        "t010",
        "t011",
        "t012",
        "t018",
        "t023",
        "t024",
        "t032",
        "t036",
        "t037"
      ],
      "shape": "M 655.0 131.0 L 655.0 332.0 L 851.0 332.0 L 851.0 241.0 L 850.05 241.0 L 849.0 131.0 L 655.0 131.0 Z",
      "bonusAnchor": {
        "x": 752.29,
        "y": 227.91
      },
      "color": "#4A148C"
    },
    {
      "id": "r04",
      "name": "Palace of Tranquil Longevity",
      "bonus": 4,
      "territoryIds": [
        "t013a",
        "t013b",
        "t014",
        "t019",
        "t022a",
        "t022b",
        "t028",
        "t033",
        "t034"
      ],
      "shape": "M 883.0 147.0 L 884.0 150.0 L 884.0 279.0 L 883.0 279.0 L 883.0 337.0 L 1038.0 337.0 L 1038.0 279.0 L 1037.0 279.0 L 1037.0 131.0 L 884.0 131.0 L 884.0 146.0 L 883.0 147.0 Z",
      "color": "#1B5E20"
    },
    {
      "id": "r05",
      "name": "Imperial Garden",
      "bonus": 1,
      "territoryIds": [
        "t015"
      ],
      "shape": "M 531.0 164.0 L 531.0 207.0 L 597.0 207.0 L 597.0 164.0 L 531.0 164.0 Z",
      "bonusAnchor": {
        "x": 564.23,
        "y": 185.27
      },
      "color": "#F48FB1"
    },
    {
      "id": "r06",
      "name": "Inner Court Three Palaces",
      "bonus": 3,
      "territoryIds": [
        "t025",
        "t026",
        "t027",
        "t038",
        "t040",
        "t041",
        "t043"
      ],
      "shape": "M 491.0 252.0 L 491.0 390.0 L 537.0 390.0 L 537.0 404.0 L 589.0 404.0 L 589.0 390.0 L 635.0 390.0 L 635.0 252.0 L 491.0 252.0 Z",
      "color": "#A08000"
    },
    {
      "id": "r07",
      "name": "Hall of Worshipping Ancestors",
      "bonus": 4,
      "territoryIds": [
        "t044",
        "t045",
        "t046",
        "t047",
        "t058",
        "t061",
        "t062",
        "t069"
      ],
      "shape": "M 910.0 374.0 L 883.0 374.0 L 883.0 589.0 L 1038.0 589.0 L 1038.0 374.0 L 1008.0 374.0 L 910.0 375.03 L 910.0 374.0 Z",
      "color": "#1A237E"
    },
    {
      "id": "r08",
      "name": "Hall of Abstinence",
      "bonus": 2,
      "territoryIds": [
        "t048",
        "t049",
        "t050",
        "t051",
        "t072"
      ],
      "color": "#E0E0E0",
      "shape": "M 849.0 435.0 L 656.0 435.0 L 656.0 541.0 L 766.0 541.0 L 766.0 595.0 L 849.0 595.0 L 849.0 544.0 L 848.0 544.0 L 848.0 500.0 L 849.0 500.0 L 849.0 435.0 Z",
      "bonusAnchor": {
        "x": 766.6,
        "y": 481.95
      }
    },
    {
      "id": "r09",
      "name": "Hall of Mental Cultivation",
      "bonus": 6,
      "territoryIds": [
        "t052",
        "t053",
        "t054",
        "t059",
        "t067",
        "t070",
        "t071",
        "t073",
        "t074",
        "t079",
        "t080",
        "t081"
      ],
      "shape": "M 152.0 437.0 L 152.0 821.0 L 297.0 821.0 L 297.0 822.0 L 349.0 822.0 L 349.0 600.0 L 347.0 600.0 L 347.0 585.0 L 348.0 584.0 L 348.0 567.0 L 347.0 566.0 L 348.0 554.0 L 347.0 553.0 L 347.0 545.0 L 348.0 544.0 L 348.0 535.0 L 346.95 535.0 L 348.0 438.0 L 282.0 437.0 L 152.0 437.0 Z",
      "bonusAnchor": {
        "x": 254.74,
        "y": 597.66
      },
      "color": "#880E4F"
    },
    {
      "id": "r10",
      "name": "Palace of Compassion and Tranquility",
      "bonus": 3,
      "territoryIds": [
        "t055",
        "t056",
        "t057",
        "t060",
        "t064",
        "t065",
        "t066"
      ],
      "shape": "M 379.0 540.0 L 395.0 540.0 L 396.0 539.0 L 424.0 539.0 L 425.0 540.0 L 432.0 540.0 L 433.0 539.0 L 444.0 539.0 L 445.0 540.0 L 449.0 540.0 L 450.0 539.0 L 457.0 539.0 L 458.0 540.0 L 462.0 540.0 L 463.0 539.0 L 463.0 505.0 L 464.0 505.0 L 464.0 473.0 L 463.0 473.0 L 463.0 437.0 L 442.0 437.0 L 441.0 438.0 L 434.0 438.0 L 434.0 437.0 L 373.0 437.0 L 373.0 539.0 L 378.0 539.0 L 379.0 540.0 Z",
      "bonusAnchor": {
        "x": 417.31,
        "y": 490.28
      },
      "color": "#D2B48C"
    },
    {
      "id": "r11",
      "name": "Gate of Heavenly Purity",
      "bonus": 1,
      "territoryIds": [
        "t063",
        "t068"
      ],
      "shape": "M 529.0 510.0 L 530.0 512.0 L 540.67 517.33 L 537.0 521.0 L 537.0 525.0 L 536.0 526.0 L 536.0 529.0 L 535.0 530.0 L 535.0 533.0 L 534.0 534.0 L 534.0 537.0 L 533.0 538.0 L 533.0 542.0 L 593.0 542.0 L 593.0 538.0 L 592.0 537.0 L 592.0 533.0 L 591.0 532.0 L 591.0 529.0 L 590.0 528.0 L 590.0 524.0 L 589.0 523.0 L 589.0 515.0 L 593.0 515.0 L 597.0 511.0 L 598.0 509.0 L 598.0 507.0 L 589.0 507.0 L 585.0 505.0 L 564.0 490.0 L 562.0 490.0 L 559.0 493.0 L 558.0 493.0 L 556.0 495.0 L 552.0 497.0 L 549.0 500.0 L 548.0 500.0 L 545.0 503.0 L 544.0 503.0 L 540.0 506.0 L 538.0 506.0 L 537.0 507.0 L 529.0 507.0 L 529.0 510.0 Z",
      "bonusAnchor": {
        "x": 563.97,
        "y": 519.29
      },
      "color": "#6B9E00"
    },
    {
      "id": "r12",
      "name": "Three Great Halls of the Outer Court",
      "bonus": 8,
      "territoryIds": [
        "t075",
        "t076",
        "t077",
        "t078",
        "t082",
        "t083",
        "t084",
        "t089",
        "t090",
        "t091",
        "t092",
        "t094",
        "t095",
        "t096",
        "t097",
        "t098",
        "t099"
      ],
      "shape": "M 479.0 605.0 L 479.0 708.0 L 522.0 709.0 L 523.13 728.24 L 522.0 752.0 L 479.0 752.0 L 479.0 867.0 L 506.0 868.0 L 506.0 910.0 L 539.0 910.0 L 539.0 911.0 L 589.0 911.0 L 589.0 910.0 L 620.0 910.0 L 621.0 868.0 L 648.0 867.0 L 648.0 752.0 L 605.0 752.0 L 603.87 728.31 L 605.0 708.0 L 648.0 708.0 L 648.0 605.0 L 565.0 605.0 L 565.0 606.05 L 479.0 605.0 Z",
      "bonusAnchor": {
        "x": 563.59,
        "y": 730.85
      },
      "color": "#FF6B6B"
    },
    {
      "id": "r13",
      "name": "Belvedere of Pleasant Sounds",
      "bonus": 2,
      "territoryIds": [
        "t085",
        "t086",
        "t087",
        "t093"
      ],
      "shape": "M 921.0 665.0 L 880.0 665.0 L 880.0 807.0 L 1010.0 807.0 L 1010.0 665.0 L 969.0 665.0 L 969.0 666.0 L 921.0 666.0 L 921.0 665.0 Z",
      "color": "#66BB6A"
    },
    {
      "id": "r14",
      "name": "Pavilion of Floating Jade",
      "bonus": 1,
      "territoryIds": [
        "t088"
      ],
      "shape": "M 819.0 684.0 L 819.0 829.0 L 862.0 829.0 L 862.0 684.0 L 819.0 684.0 Z",
      "color": "#5E4800"
    },
    {
      "id": "r15",
      "name": "Pavilion of Crimson Snow",
      "bonus": 1,
      "territoryIds": [
        "t100"
      ],
      "shape": "M 1015.0 922.0 L 1015.0 958.0 L 992.0 958.0 L 993.0 1006.0 L 1057.0 1006.0 L 1057.0 922.0 L 1015.0 922.0 Z",
      "bonusAnchor": {
        "x": 971.7,
        "y": 970.51
      },
      "color": "#00695C"
    },
    {
      "id": "r16",
      "name": "Garden of Compassion and Tranquility",
      "bonus": 2,
      "territoryIds": [
        "t101",
        "t102",
        "t105",
        "t108",
        "t110"
      ],
      "shape": "M 180.0 1004.0 L 180.0 1144.0 L 213.0 1199.0 L 307.0 1199.0 L 305.97 1069.0 L 307.0 1069.0 L 307.0 1004.0 L 321.0 1004.0 L 321.0 958.0 L 166.0 958.0 L 166.0 1004.0 L 180.0 1004.0 Z",
      "bonusAnchor": {
        "x": 246.48,
        "y": 1072.05
      },
      "color": "#00E5CC"
    },
    {
      "id": "r17",
      "name": "Southern Three Treasuries",
      "bonus": 2,
      "territoryIds": [
        "t103",
        "t104",
        "t106",
        "t107"
      ],
      "shape": "M 902.0 961.0 L 771.0 961.0 L 771.0 1149.0 L 893.0 1149.0 L 893.0 1007.0 L 902.0 1007.0 L 902.0 961.0 Z",
      "color": "#EC407A"
    },
    {
      "id": "r18",
      "name": "Gate of Supreme Harmony",
      "bonus": 1,
      "territoryIds": [
        "t109",
        "t112"
      ],
      "shape": "M 508.0 1088.0 L 513.0 1094.0 L 516.0 1096.0 L 527.76 1098.94 L 524.0 1119.0 L 522.0 1124.0 L 522.0 1129.0 L 520.0 1134.0 L 518.0 1148.0 L 608.0 1148.0 L 598.0 1098.0 L 603.0 1098.0 L 613.0 1094.0 L 617.0 1090.0 L 619.0 1085.0 L 619.0 1081.0 L 607.0 1081.0 L 597.0 1077.0 L 568.0 1054.0 L 557.0 1054.0 L 532.0 1074.0 L 531.0 1076.0 L 525.0 1079.0 L 518.0 1081.0 L 506.0 1081.0 L 508.0 1088.0 Z",
      "bonusAnchor": {
        "x": 562.01,
        "y": 1103.97
      },
      "color": "#CE93D8"
    },
    {
      "id": "r19",
      "name": "West Glorious Gate",
      "bonus": 1,
      "territoryIds": [
        "t111",
        "t115"
      ],
      "shape": "M 44.2 1124.8 L 17.0 1118.0 L 7.0 1114.0 L 3.0 1114.0 L 3.0 1209.0 L 23.0 1204.0 L 26.0 1202.0 L 45.79 1198.04 L 48.0 1208.0 L 53.0 1216.0 L 60.0 1219.0 L 63.0 1219.0 L 64.0 1203.0 L 70.0 1193.0 L 87.0 1171.0 L 89.0 1167.0 L 89.0 1154.0 L 65.0 1122.0 L 63.0 1116.0 L 63.0 1104.0 L 58.0 1104.0 L 51.0 1109.0 L 47.0 1117.0 L 47.0 1122.0 L 44.2 1124.8 Z",
      "color": "#4E1700"
    },
    {
      "id": "r20",
      "name": "East Glorious Gate",
      "bonus": 1,
      "territoryIds": [
        "t113",
        "t114"
      ],
      "shape": "M 1129.0 1210.0 L 1148.0 1214.0 L 1148.0 1108.0 L 1084.0 1125.66 L 1084.0 1119.0 L 1081.0 1111.0 L 1074.0 1104.0 L 1068.0 1104.0 L 1068.0 1117.0 L 1064.0 1125.0 L 1042.0 1154.0 L 1042.0 1168.0 L 1065.0 1199.0 L 1068.0 1207.0 L 1068.0 1219.0 L 1074.0 1218.0 L 1080.0 1213.0 L 1085.82 1196.71 L 1129.0 1210.0 Z",
      "color": "#8B7355",
      "bonusAnchor": {
        "x": 1091.28,
        "y": 1161.79
      }
    },
    {
      "id": "r21",
      "name": "Hall of Military Eminence",
      "bonus": 4,
      "territoryIds": [
        "t116",
        "t117",
        "t118",
        "t119",
        "t120",
        "t121",
        "t123",
        "t127",
        "t130"
      ],
      "shape": "M 185.0 1274.0 L 185.0 1247.0 L 113.0 1247.0 L 113.0 1227.0 L 74.0 1227.0 L 74.0 1352.0 L 185.0 1352.0 L 185.0 1351.0 L 336.0 1351.0 L 336.0 1352.0 L 384.0 1352.0 L 384.0 1284.0 L 332.0 1284.0 L 332.0 1274.0 L 185.0 1274.0 Z",
      "color": "#B0003A"
    },
    {
      "id": "r22",
      "name": "Meridian Gate",
      "bonus": 2,
      "territoryIds": [
        "t122",
        "t129",
        "t131"
      ],
      "shape": "M 436.0 1348.0 L 431.0 1348.0 L 432.0 1355.0 L 434.0 1356.0 L 447.0 1356.0 L 449.0 1352.0 L 452.0 1355.0 L 463.0 1354.0 L 465.0 1356.0 L 476.0 1356.0 L 477.0 1354.0 L 531.0 1354.0 L 531.0 1345.73 L 539.0 1354.0 L 586.0 1354.0 L 594.0 1345.48 L 594.0 1354.0 L 651.0 1354.0 L 652.0 1356.0 L 655.0 1355.0 L 664.0 1356.0 L 666.0 1354.0 L 680.0 1354.0 L 682.0 1356.0 L 694.0 1356.0 L 698.0 1355.0 L 698.0 1348.0 L 693.0 1348.0 L 692.0 1349.0 L 672.0 1349.0 L 671.0 1348.0 L 662.0 1347.0 L 643.0 1339.0 L 629.0 1330.0 L 622.0 1324.0 L 617.0 1324.0 L 617.0 1319.0 L 572.0 1279.0 L 554.0 1279.0 L 509.0 1319.0 L 509.0 1325.0 L 503.0 1325.0 L 493.0 1333.0 L 483.0 1339.0 L 468.0 1346.0 L 460.0 1347.0 L 455.0 1349.0 L 437.0 1349.0 L 436.0 1348.0 Z",
      "bonusAnchor": {
        "x": 561.27,
        "y": 1320.46
      },
      "color": "#5D4037"
    },
    {
      "id": "r23",
      "name": "Hall of Literary Glory",
      "bonus": 2,
      "territoryIds": [
        "t124",
        "t125",
        "t126",
        "t128"
      ],
      "shape": "M 814.0 1352.0 L 814.0 1349.97 L 919.0 1351.0 L 947.0 1351.0 L 948.0 1350.0 L 948.0 1284.0 L 748.0 1284.0 L 748.0 1352.0 L 814.0 1352.0 Z",
      "color": "#00E5CC"
    },
    {
      "id": "roads",
      "name": "Imperial Way",
      "bonus": 15,
      "territoryIds": [
        "tr002",
        "tr008",
        "tr013",
        "tr019",
        "tr025",
        "tr026",
        "tr001",
        "tr003",
        "tr004",
        "tr006",
        "tr007",
        "tr010",
        "tr011",
        "tr012",
        "tr014",
        "tr015",
        "tr016",
        "tr017",
        "tr032",
        "tr020",
        "tr021",
        "tr022",
        "tr023",
        "tr033",
        "tr027"
      ],
      "color": "#A1887F",
      "shape": "M 77.0 165.0 L 77.0 826.0 L 81.0 839.0 L 89.0 852.0 L 91.0 859.0 L 91.0 882.0 L 88.0 883.0 L 83.0 888.0 L 79.0 896.0 L 79.0 907.0 L 83.0 916.0 L 91.0 922.0 L 91.0 1040.0 L 95.0 1054.0 L 153.18 1153.0 L 94.0 1153.0 L 94.0 1170.0 L 162.0 1170.0 L 173.0 1187.0 L 214.0 1258.0 L 241.0 1258.0 L 244.0 1263.0 L 254.0 1271.0 L 268.0 1271.0 L 274.0 1268.0 L 282.0 1258.0 L 329.0 1258.0 L 331.0 1256.0 L 445.0 1256.0 L 458.0 1251.0 L 483.0 1230.0 L 492.0 1225.0 L 544.0 1225.0 L 548.0 1232.0 L 555.0 1238.0 L 555.0 1274.0 L 571.0 1274.0 L 571.0 1237.0 L 578.0 1232.0 L 582.0 1225.0 L 640.0 1225.0 L 672.0 1251.0 L 678.0 1254.0 L 686.0 1256.0 L 747.0 1256.0 L 748.0 1255.0 L 751.0 1255.0 L 752.0 1254.0 L 754.0 1254.0 L 757.0 1252.0 L 759.0 1252.0 L 761.0 1250.0 L 762.0 1250.0 L 766.0 1246.0 L 767.0 1246.0 L 772.0 1241.0 L 773.0 1241.0 L 778.0 1236.0 L 779.0 1236.0 L 782.0 1233.0 L 783.0 1233.0 L 786.0 1230.0 L 787.0 1230.0 L 790.0 1228.0 L 792.0 1228.0 L 793.0 1227.0 L 797.0 1227.0 L 800.0 1230.0 L 801.0 1233.0 L 806.0 1238.0 L 807.0 1238.0 L 809.0 1240.0 L 811.0 1240.0 L 812.0 1241.0 L 814.0 1241.0 L 815.0 1242.0 L 821.0 1242.0 L 822.0 1241.0 L 824.0 1241.0 L 825.0 1240.0 L 828.0 1239.0 L 833.0 1234.0 L 833.0 1233.0 L 834.0 1232.0 L 834.0 1231.0 L 837.0 1226.0 L 884.0 1226.0 L 884.0 1228.0 L 897.0 1228.0 L 897.0 1281.0 L 915.0 1281.0 L 915.0 1228.0 L 965.0 1228.0 L 965.0 1183.0 L 969.0 1181.0 L 974.0 1176.0 L 977.0 1170.0 L 1039.0 1170.0 L 1039.0 1153.0 L 977.0 1153.0 L 975.0 1151.0 L 974.0 1148.0 L 965.0 1140.0 L 965.0 1058.0 L 963.0 1058.0 L 963.0 917.0 L 965.0 915.0 L 968.0 914.0 L 972.0 910.0 L 975.0 904.0 L 1029.0 904.0 L 1029.0 917.0 L 1044.0 917.0 L 1044.0 888.0 L 975.0 888.0 L 973.0 886.0 L 972.0 883.0 L 967.0 878.0 L 963.0 876.0 L 963.0 811.0 L 947.0 811.0 L 947.0 876.0 L 940.0 882.0 L 936.0 888.0 L 860.0 888.0 L 857.0 885.0 L 857.0 884.0 L 855.0 882.0 L 855.0 881.0 L 854.0 881.0 L 851.0 878.0 L 848.0 878.0 L 848.0 833.0 L 846.0 833.0 L 845.0 832.0 L 837.0 832.0 L 836.0 833.0 L 832.0 833.0 L 832.0 878.0 L 829.0 878.0 L 824.0 883.0 L 824.0 884.0 L 820.0 888.0 L 772.0 888.0 L 770.0 884.0 L 771.03 778.12 L 773.0 778.0 L 773.0 688.0 L 781.0 682.0 L 784.0 676.0 L 802.0 676.0 L 815.0 674.0 L 827.0 668.0 L 832.0 663.0 L 848.0 653.0 L 862.0 648.0 L 972.0 648.0 L 972.0 593.0 L 953.0 593.0 L 952.0 630.0 L 859.0 630.0 L 850.0 632.0 L 838.0 638.0 L 812.0 656.0 L 804.0 658.0 L 784.0 658.0 L 782.0 654.0 L 772.0 645.0 L 771.0 634.0 L 754.0 603.0 L 753.0 545.0 L 735.0 545.0 L 734.0 566.0 L 583.0 566.0 L 579.0 562.0 L 579.0 561.0 L 571.0 553.0 L 571.0 547.0 L 555.0 547.0 L 555.0 554.0 L 548.0 559.0 L 548.0 560.0 L 546.0 562.0 L 546.0 563.0 L 544.0 566.0 L 422.0 566.0 L 421.0 565.0 L 408.0 565.0 L 406.0 563.0 L 405.0 560.0 L 400.0 555.0 L 399.0 555.0 L 396.0 552.0 L 396.0 543.0 L 382.0 543.0 L 381.0 544.0 L 378.0 544.0 L 378.0 552.0 L 370.0 560.0 L 370.0 561.0 L 367.0 566.0 L 367.0 570.0 L 366.0 571.0 L 366.0 579.0 L 367.0 580.0 L 367.0 583.0 L 368.0 584.0 L 368.0 586.0 L 369.0 587.0 L 370.0 590.0 L 374.0 594.0 L 375.0 594.0 L 378.0 597.0 L 378.0 610.0 L 352.0 610.0 L 352.0 627.0 L 378.0 627.0 L 378.0 667.0 L 377.0 668.0 L 377.0 670.0 L 376.0 671.0 L 376.0 673.0 L 374.0 676.0 L 374.0 678.0 L 373.0 679.0 L 373.0 681.0 L 372.0 682.0 L 372.0 687.0 L 371.0 688.0 L 371.0 699.0 L 372.0 699.0 L 372.0 767.0 L 365.0 773.0 L 365.0 774.0 L 363.0 776.0 L 362.0 782.0 L 361.0 783.0 L 361.0 785.0 L 362.0 786.0 L 362.0 798.0 L 363.0 799.0 L 363.0 801.0 L 364.0 803.0 L 372.0 811.0 L 372.0 894.0 L 263.0 894.0 L 259.0 890.0 L 259.0 889.0 L 253.0 883.0 L 252.0 883.0 L 249.0 881.0 L 246.0 881.0 L 245.0 880.0 L 239.0 880.0 L 238.0 881.0 L 236.0 881.0 L 235.0 882.0 L 234.0 882.0 L 233.0 883.0 L 232.0 883.0 L 226.0 889.0 L 226.0 890.0 L 222.0 894.0 L 119.0 894.0 L 116.0 889.0 L 107.0 881.0 L 106.0 854.0 L 93.0 827.0 L 92.0 821.0 L 93.0 818.0 L 93.0 165.0 L 97.0 152.0 L 105.0 137.0 L 108.0 126.0 L 108.0 122.0 L 112.0 120.0 L 118.0 114.0 L 120.0 110.0 L 141.0 110.0 L 141.0 112.0 L 384.0 112.0 L 386.0 114.0 L 387.0 117.0 L 392.0 122.0 L 396.0 124.0 L 396.0 128.0 L 414.0 128.0 L 414.0 124.0 L 419.0 121.0 L 426.0 112.0 L 443.0 112.0 L 443.0 110.0 L 463.0 110.0 L 464.0 111.0 L 467.0 111.0 L 471.0 114.0 L 472.0 114.0 L 477.0 119.0 L 478.0 119.0 L 490.0 131.0 L 491.0 131.0 L 494.0 134.0 L 500.0 137.0 L 502.0 137.0 L 503.0 138.0 L 506.0 138.0 L 507.0 139.0 L 544.0 139.0 L 547.0 145.0 L 551.0 149.0 L 555.0 151.0 L 555.0 159.0 L 571.0 159.0 L 571.0 151.0 L 578.0 146.0 L 579.0 143.0 L 582.0 139.0 L 621.0 139.0 L 622.0 138.0 L 627.0 137.0 L 633.0 134.0 L 636.0 131.0 L 637.0 131.0 L 653.0 115.0 L 656.0 114.0 L 660.0 111.0 L 663.0 111.0 L 664.0 110.0 L 732.0 110.0 L 732.0 113.0 L 735.0 116.0 L 735.0 117.0 L 737.0 119.0 L 738.0 119.0 L 742.0 123.0 L 742.0 126.0 L 758.0 126.0 L 758.0 123.0 L 762.0 119.0 L 763.0 119.0 L 766.0 116.0 L 766.0 115.0 L 768.0 113.0 L 768.0 110.0 L 942.0 110.0 L 945.0 113.0 L 945.0 114.0 L 951.0 120.0 L 954.0 120.0 L 954.0 126.0 L 970.0 126.0 L 970.0 123.0 L 973.0 120.0 L 974.0 120.0 L 980.0 114.0 L 980.0 113.0 L 982.0 110.0 L 982.0 108.0 L 983.0 107.0 L 983.0 104.0 L 984.0 103.0 L 984.0 98.0 L 983.0 97.0 L 983.0 95.0 L 982.0 94.0 L 982.0 92.0 L 981.0 91.0 L 981.0 90.0 L 980.0 89.0 L 980.0 88.0 L 973.0 81.0 L 972.0 81.0 L 969.0 79.0 L 967.0 79.0 L 966.0 78.0 L 959.0 78.0 L 958.0 79.0 L 956.0 79.0 L 955.0 80.0 L 954.0 80.0 L 953.0 81.0 L 952.0 81.0 L 951.0 82.0 L 950.0 82.0 L 946.0 86.0 L 946.0 87.0 L 945.0 88.0 L 945.0 89.0 L 942.0 92.0 L 768.0 92.0 L 768.0 89.0 L 767.0 88.0 L 767.0 87.0 L 761.0 81.0 L 760.0 81.0 L 759.0 80.0 L 757.0 80.0 L 756.0 79.0 L 754.0 79.0 L 753.0 78.0 L 746.0 78.0 L 745.0 79.0 L 743.0 79.0 L 742.0 80.0 L 741.0 80.0 L 740.0 81.0 L 739.0 81.0 L 733.0 87.0 L 733.0 88.0 L 729.0 92.0 L 666.0 92.0 L 665.0 93.0 L 662.0 93.0 L 661.0 94.0 L 658.0 94.0 L 657.0 95.0 L 655.0 95.0 L 651.0 97.0 L 649.0 99.0 L 648.0 99.0 L 645.0 102.0 L 644.0 102.0 L 640.0 106.0 L 640.0 107.0 L 638.0 108.0 L 632.0 114.0 L 632.0 117.0 L 629.0 117.0 L 627.0 119.0 L 625.0 119.0 L 619.0 122.0 L 581.5 122.0 L 580.0 119.0 L 571.0 110.0 L 571.0 103.0 L 555.0 103.0 L 555.0 111.0 L 551.0 113.0 L 547.0 117.0 L 547.0 118.0 L 542.11 124.11 L 540.0 122.0 L 538.0 122.0 L 537.0 123.0 L 528.0 123.0 L 527.0 122.0 L 508.0 122.0 L 507.0 121.0 L 504.0 121.0 L 500.0 119.0 L 497.0 116.0 L 494.0 116.0 L 494.0 113.0 L 492.0 111.0 L 491.0 111.0 L 487.0 106.0 L 486.0 106.0 L 479.0 99.0 L 478.0 99.0 L 476.0 97.0 L 472.0 95.0 L 470.0 95.0 L 469.0 94.0 L 466.0 94.0 L 465.0 93.0 L 463.0 93.0 L 462.0 92.0 L 426.0 92.0 L 423.0 87.0 L 418.0 82.0 L 413.0 79.0 L 410.0 79.0 L 409.0 78.0 L 401.0 78.0 L 400.0 79.0 L 397.0 79.0 L 393.0 81.0 L 389.0 85.0 L 388.0 85.0 L 384.0 92.0 L 120.0 92.0 L 117.0 86.0 L 114.0 83.0 L 104.0 78.0 L 98.0 78.0 L 91.0 80.0 L 83.0 87.0 L 80.0 93.0 L 80.0 97.0 L 79.0 98.0 L 79.0 104.0 L 81.0 111.0 L 89.0 120.0 L 94.0 122.5 L 91.0 127.0 L 91.0 130.0 L 88.0 138.0 L 80.0 153.0 L 78.0 160.0 L 78.0 164.0 L 77.0 165.0 Z M 735.0 342.0 L 735.0 362.0 L 732.0 364.0 L 725.0 372.0 L 724.0 378.0 L 723.0 379.0 L 723.0 389.0 L 724.0 390.0 L 725.0 395.0 L 728.0 400.0 L 735.0 405.0 L 735.0 418.0 L 736.0 419.0 L 735.0 431.0 L 736.0 432.0 L 753.0 432.0 L 753.0 406.0 L 762.0 398.0 L 763.0 395.0 L 765.0 393.0 L 785.0 393.0 L 786.0 392.0 L 792.0 392.0 L 793.0 391.0 L 798.0 390.0 L 805.0 386.0 L 818.0 375.0 L 822.0 373.0 L 826.0 369.0 L 831.0 367.0 L 835.0 367.0 L 836.0 366.0 L 954.25 366.0 L 953.0 371.0 L 972.0 371.0 L 972.0 341.0 L 954.0 341.0 L 953.0 342.0 L 953.0 348.0 L 835.0 348.0 L 834.0 349.0 L 829.0 349.0 L 817.0 354.0 L 805.0 364.0 L 804.0 364.0 L 803.0 366.0 L 800.0 367.0 L 798.0 370.0 L 796.0 370.0 L 794.0 372.0 L 792.0 372.0 L 788.0 374.0 L 785.0 374.0 L 784.0 375.0 L 765.0 375.0 L 763.0 373.0 L 760.0 367.0 L 753.0 362.0 L 753.0 336.0 L 736.0 336.0 L 736.0 341.0 L 735.0 342.0 Z M 548.0 441.0 L 548.0 442.0 L 547.0 443.0 L 547.0 444.0 L 546.0 445.0 L 546.0 446.0 L 545.0 447.0 L 545.0 449.0 L 544.0 450.0 L 544.0 459.0 L 545.0 460.0 L 545.0 462.0 L 546.0 463.0 L 546.0 464.0 L 547.0 465.0 L 547.0 466.0 L 555.0 474.0 L 555.0 488.0 L 556.0 488.0 L 558.0 486.0 L 559.0 486.0 L 563.0 482.0 L 566.0 485.0 L 567.0 485.0 L 569.0 487.0 L 570.0 487.0 L 571.0 488.0 L 571.0 474.0 L 579.0 466.0 L 579.0 465.0 L 580.0 464.0 L 580.0 462.0 L 581.0 461.0 L 581.0 459.0 L 582.0 458.0 L 582.0 449.0 L 581.0 448.0 L 581.0 447.0 L 580.0 446.0 L 580.0 445.0 L 579.0 444.0 L 579.0 443.0 L 578.0 442.0 L 578.0 441.0 L 574.0 437.0 L 571.0 437.0 L 571.0 408.0 L 555.0 408.0 L 555.0 437.0 L 552.0 437.0 L 548.0 441.0 Z M 553.0 247.0 L 574.0 247.0 L 574.0 211.0 L 553.0 211.0 L 553.0 247.0 Z M 169.0 380.0 L 169.0 437.0 L 185.0 437.0 L 185.0 417.0 L 293.0 417.0 L 298.0 425.0 L 299.0 425.0 L 302.0 428.0 L 309.0 432.0 L 316.0 432.0 L 323.0 427.0 L 324.0 427.0 L 328.0 423.0 L 331.0 417.0 L 411.0 417.0 L 411.0 432.0 L 427.0 432.0 L 427.0 400.0 L 332.0 400.0 L 326.0 392.0 L 325.0 392.0 L 322.0 389.0 L 318.0 387.0 L 316.0 387.0 L 315.0 386.0 L 309.0 386.0 L 308.0 387.0 L 304.0 388.0 L 298.0 393.0 L 297.0 393.0 L 293.0 400.0 L 185.0 400.0 L 185.0 380.0 L 169.0 380.0 Z",
      "bonusAnchor": {
        "x": 562.95,
        "y": 986.47
      }
    }
  ],
  "territories": [
    {
      "id": "t001",
      "name": "Gate of Divine Might – Watchtower",
      "regionId": "r01",
      "adjacencies": [
        "t002"
      ],
      "shape": "M 512 36 L 513 43 L 518 48 L 525 51 L 603 51 L 612 48 L 617 43 L 618 36 L 604 35 L 597 32 L 566 9 L 562 10 L 558 14 L 533 32 L 521 36 Z",
      "position": {
        "x": 563.9,
        "y": 34.9
      },
      "badgeAnchor": {
        "x": 554.68,
        "y": 31.97
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t002",
      "name": "Gate of Divine Might – Inner Hall",
      "regionId": "r01",
      "adjacencies": [
        "t001",
        "tr006"
      ],
      "shape": "M 526 56 L 518 97 L 611 97 L 610 87 L 608 82 L 608 77 L 606 73 L 603 56 Z",
      "position": {
        "x": 564.09,
        "y": 78.76
      },
      "badgeAnchor": {
        "x": 564.09,
        "y": 78.76
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t003",
      "name": "Palace of Universal Happiness",
      "regionId": "r02",
      "adjacencies": [
        "t004",
        "t016",
        "t031"
      ],
      "shape": "M 152 131 L 241 131 L 241 264 L 152 264 Z",
      "position": {
        "x": 196.5,
        "y": 197.5
      },
      "badgeAnchor": {
        "x": 195.11,
        "y": 174.64
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t004",
      "name": "Palace of Eternal Longevity",
      "regionId": "r02",
      "adjacencies": [
        "t003",
        "t005",
        "t016",
        "t017"
      ],
      "shape": "M 244 131 L 337 131 L 337 184 L 244 184 Z",
      "position": {
        "x": 290.5,
        "y": 157.5
      },
      "badgeAnchor": {
        "x": 271.61,
        "y": 156.67
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t005",
      "name": "Palace of Lasting Happiness",
      "regionId": "r02",
      "adjacencies": [
        "t004",
        "t006",
        "t017",
        "t020"
      ],
      "shape": "M 341 131 L 379 131 L 379 205 L 341 205 Z",
      "position": {
        "x": 360,
        "y": 168
      },
      "badgeAnchor": {
        "x": 359.41,
        "y": 150.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t006",
      "name": "Palace of Earthly Honour",
      "regionId": "r02",
      "adjacencies": [
        "t005",
        "t007",
        "t020",
        "t021",
        "tr002"
      ],
      "shape": "M 383 131 L 423 131 L 423 205 L 383 205 Z",
      "position": {
        "x": 403,
        "y": 168
      },
      "badgeAnchor": {
        "x": 402.38,
        "y": 150.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t007",
      "name": "Palace of Gathering Essence",
      "regionId": "r02",
      "adjacencies": [
        "t006",
        "t021"
      ],
      "shape": "M 427 131 L 464 131 L 464 205 L 427 205 Z",
      "position": {
        "x": 445.5,
        "y": 168
      },
      "badgeAnchor": {
        "x": 444.92,
        "y": 150.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t008",
      "name": "Palace of Accumulated Purity",
      "regionId": "r03",
      "adjacencies": [
        "t009",
        "t010",
        "t018",
        "t023"
      ],
      "shape": "M 655 131 L 655 237 L 731 237 L 731 188 L 687 188 L 686 131 Z",
      "position": {
        "x": 683.56,
        "y": 209.55
      },
      "badgeAnchor": {
        "x": 690.64,
        "y": 211.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t009",
      "name": "Palace of Prolonged Happiness",
      "regionId": "r03",
      "adjacencies": [
        "t008",
        "t010"
      ],
      "shape": "M 691 131 L 724 131 L 724 184 L 691 184 Z",
      "position": {
        "x": 707.5,
        "y": 157.5
      },
      "badgeAnchor": {
        "x": 706.98,
        "y": 148.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t010",
      "name": "Palace of Great Benevolence",
      "regionId": "r03",
      "adjacencies": [
        "t008",
        "t009",
        "t011",
        "t012",
        "t018",
        "tr003"
      ],
      "shape": "M 728 131 L 776 131 L 776 184 L 728 184 Z",
      "position": {
        "x": 752,
        "y": 157.5
      },
      "badgeAnchor": {
        "x": 751.98,
        "y": 148.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t011",
      "name": "Palace of Eternal Harmony",
      "regionId": "r03",
      "adjacencies": [
        "t010",
        "t012",
        "t018",
        "t024"
      ],
      "shape": "M 849 131 L 817 131 L 816 188 L 773 188 L 773 237 L 850 236 Z",
      "position": {
        "x": 821.66,
        "y": 209.15
      },
      "badgeAnchor": {
        "x": 811.6,
        "y": 208.24
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t012",
      "name": "Palace of Heavenly Grace",
      "regionId": "r03",
      "adjacencies": [
        "t010",
        "t011"
      ],
      "shape": "M 780 131 L 814 131 L 814 184 L 780 184 Z",
      "position": {
        "x": 797,
        "y": 157.5
      },
      "badgeAnchor": {
        "x": 796.47,
        "y": 148.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t013a",
      "name": "Hall of Imperial Supremacy",
      "regionId": "r04",
      "adjacencies": [
        "t013b",
        "t014",
        "t019",
        "t022a",
        "t022b"
      ],
      "shape": "M 884 131 L 884 146 L 883 147 L 884 150 L 884 206 L 922 206 L 922 185 L 924 183 L 958 183 L 958 167 L 923 167 L 922 166 L 922 131 Z",
      "position": {
        "x": 903.57,
        "y": 171.45
      },
      "badgeAnchor": {
        "x": 903.57,
        "y": 171.45
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t013b",
      "name": "Hall of Imperial Zenith",
      "regionId": "r04",
      "adjacencies": [
        "t013a",
        "t014",
        "t019",
        "t022a",
        "t022b"
      ],
      "shape": "M 963 167 L 963 183 L 1002 183 L 1004 185 L 1004 206 L 1037 206 L 1037 131 L 1004 131 L 1004 166 L 1003 167 Z",
      "position": {
        "x": 1021.17,
        "y": 169.81
      },
      "badgeAnchor": {
        "x": 1021.17,
        "y": 169.81
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t014",
      "name": "Palace of Tranquil Longevity – Main Hall",
      "regionId": "r04",
      "adjacencies": [
        "t013a",
        "t013b",
        "tr004"
      ],
      "shape": "M 927 131 L 1000 131 L 1000 164 L 927 164 Z",
      "position": {
        "x": 963.5,
        "y": 147.5
      },
      "badgeAnchor": {
        "x": 944.11,
        "y": 146.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t015",
      "name": "Imperial Garden",
      "regionId": "r05",
      "adjacencies": [
        "tr006",
        "tr007"
      ],
      "shape": "M 531 164 L 597 164 L 597 207 L 531 207 Z",
      "position": {
        "x": 564,
        "y": 185.5
      },
      "badgeAnchor": {
        "x": 552.66,
        "y": 184.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t016",
      "name": "West Six – Northern Courtyard",
      "regionId": "r02",
      "adjacencies": [
        "t003",
        "t004",
        "t017",
        "t029",
        "t031",
        "t035"
      ],
      "shape": "M 244 188 L 298 188 L 298 278 L 244 278 Z",
      "position": {
        "x": 271,
        "y": 233
      },
      "badgeAnchor": {
        "x": 270.16,
        "y": 214.72
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t017",
      "name": "Palace of Eternal Spring",
      "regionId": "r02",
      "adjacencies": [
        "t004",
        "t005",
        "t016",
        "t020",
        "t029",
        "t030"
      ],
      "shape": "M 302 188 L 337 188 L 337 262 L 302 262 Z",
      "position": {
        "x": 319.5,
        "y": 225
      },
      "badgeAnchor": {
        "x": 318.95,
        "y": 205.34
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t018",
      "name": "Palace of Great Brilliance",
      "regionId": "r03",
      "adjacencies": [
        "t008",
        "t010",
        "t011",
        "t023",
        "t024",
        "t032"
      ],
      "shape": "M 736 188 L 769 188 L 769 274 L 736 274 Z",
      "position": {
        "x": 752.5,
        "y": 231
      },
      "badgeAnchor": {
        "x": 751.98,
        "y": 205.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t019",
      "name": "Pavilion of Cheerful Melodies",
      "regionId": "r04",
      "adjacencies": [
        "t013a",
        "t013b",
        "t022a",
        "t022b"
      ],
      "shape": "M 927 188 L 1000 188 L 1000 230 L 927 230 Z",
      "position": {
        "x": 963.5,
        "y": 209
      },
      "badgeAnchor": {
        "x": 948.67,
        "y": 208.34
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t020",
      "name": "West Six – Central Pathway",
      "regionId": "r02",
      "adjacencies": [
        "t005",
        "t006",
        "t017",
        "t021",
        "t029",
        "t030"
      ],
      "shape": "M 341 208 L 401 208 L 401 262 L 341 262 Z",
      "position": {
        "x": 371,
        "y": 235
      },
      "badgeAnchor": {
        "x": 369.13,
        "y": 234.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t021",
      "name": "West Six – East Courtyard",
      "regionId": "r02",
      "adjacencies": [
        "t006",
        "t007",
        "t020",
        "t030",
        "t042"
      ],
      "shape": "M 405 208 L 464 208 L 464 334 L 405 334 Z",
      "position": {
        "x": 434.5,
        "y": 271
      },
      "badgeAnchor": {
        "x": 429.89,
        "y": 237.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t022a",
      "name": "Lodge of Retirement",
      "regionId": "r04",
      "adjacencies": [
        "t013a",
        "t013b",
        "t019",
        "t022b",
        "t028",
        "t033",
        "t034"
      ],
      "shape": "M 884 211 L 884 274 L 922 274 L 922 252 L 923 251 L 958 251 L 958 233 L 923 233 L 922 232 L 922 210 L 916 211 L 912 210 Z",
      "position": {
        "x": 902.32,
        "y": 240.08
      },
      "badgeAnchor": {
        "x": 902.32,
        "y": 240.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t022b",
      "name": "Pavilion of Pleasant Sounds",
      "regionId": "r04",
      "adjacencies": [
        "t013a",
        "t013b",
        "t019",
        "t022a",
        "t028",
        "t033",
        "t034"
      ],
      "shape": "M 964 233 L 964 251 L 1003 251 L 1004 252 L 1004 274 L 1037 274 L 1037 211 L 1036 210 L 1035 211 L 1032 210 L 1004 210 L 1004 232 L 1003 233 Z",
      "position": {
        "x": 1020.48,
        "y": 237.88
      },
      "badgeAnchor": {
        "x": 1020.48,
        "y": 237.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t023",
      "name": "East Six – Northern Court",
      "regionId": "r03",
      "adjacencies": [
        "t008",
        "t018",
        "t032",
        "t036"
      ],
      "shape": "M 655 241 L 732 241 L 732 288 L 655 288 Z",
      "position": {
        "x": 693.5,
        "y": 264.5
      },
      "badgeAnchor": {
        "x": 677.86,
        "y": 263.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t024",
      "name": "East Six – Central Passage",
      "regionId": "r03",
      "adjacencies": [
        "t011",
        "t018",
        "t032",
        "t037"
      ],
      "shape": "M 772 241 L 851 241 L 851 288 L 772 288 Z",
      "position": {
        "x": 811.5,
        "y": 264.5
      },
      "badgeAnchor": {
        "x": 795.45,
        "y": 263.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t025",
      "name": "Hall of Union",
      "regionId": "r06",
      "adjacencies": [
        "t026",
        "t027",
        "t038",
        "t040"
      ],
      "shape": "M 491 252 L 491 323 L 533 323 L 533 303 L 534 302 L 561 302 L 561 286 L 534 286 L 533 285 L 533 252 Z",
      "position": {
        "x": 508.58,
        "y": 290.05
      },
      "badgeAnchor": {
        "x": 508.58,
        "y": 290.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t026",
      "name": "Palace of Heavenly Purity",
      "regionId": "r06",
      "adjacencies": [
        "t025",
        "t027",
        "tr007"
      ],
      "shape": "M 537 252 L 589 252 L 589 283 L 537 283 Z",
      "position": {
        "x": 563,
        "y": 267.5
      },
      "badgeAnchor": {
        "x": 552.44,
        "y": 267.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t027",
      "name": "Palace of Earthly Tranquility",
      "regionId": "r06",
      "adjacencies": [
        "t025",
        "t026",
        "t038",
        "t041"
      ],
      "shape": "M 593 252 L 593 285 L 592 286 L 565 286 L 565 302 L 592 302 L 593 303 L 593 323 L 635 323 L 635 252 Z",
      "position": {
        "x": 613.63,
        "y": 290.75
      },
      "badgeAnchor": {
        "x": 613.63,
        "y": 290.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t028",
      "name": "Tranquil Longevity – Eastern Court",
      "regionId": "r04",
      "adjacencies": [
        "t022a",
        "t022b",
        "t033",
        "t034",
        "tr008"
      ],
      "shape": "M 927 256 L 1000 256 L 1000 337 L 927 337 Z",
      "position": {
        "x": 963.5,
        "y": 296.5
      },
      "badgeAnchor": {
        "x": 962.36,
        "y": 292.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t029",
      "name": "West Six – Southern Gate",
      "regionId": "r02",
      "adjacencies": [
        "t016",
        "t017",
        "t020",
        "t030",
        "t035",
        "t039",
        "tr010"
      ],
      "shape": "M 302 265 L 337 265 L 337 380 L 302 380 Z",
      "position": {
        "x": 319.5,
        "y": 322.5
      },
      "badgeAnchor": {
        "x": 318.95,
        "y": 290.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t030",
      "name": "West Six – Storage Hall",
      "regionId": "r02",
      "adjacencies": [
        "t017",
        "t020",
        "t021",
        "t029",
        "t042"
      ],
      "shape": "M 341 265 L 401 265 L 401 380 L 341 380 Z",
      "position": {
        "x": 371,
        "y": 322.5
      },
      "badgeAnchor": {
        "x": 369.13,
        "y": 290.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t031",
      "name": "West Six – Servant Quarter",
      "regionId": "r02",
      "adjacencies": [
        "t003",
        "t016",
        "t035",
        "t039",
        "tr010"
      ],
      "shape": "M 152 268 L 241 268 L 241 380 L 152 380 Z",
      "position": {
        "x": 196.5,
        "y": 324
      },
      "badgeAnchor": {
        "x": 195.11,
        "y": 311.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t032",
      "name": "East Six – Southern Gate",
      "regionId": "r03",
      "adjacencies": [
        "t018",
        "t023",
        "t024",
        "t036",
        "t037",
        "tr008"
      ],
      "shape": "M 736 277 L 769 277 L 769 332 L 736 332 Z",
      "position": {
        "x": 752.5,
        "y": 304.5
      },
      "badgeAnchor": {
        "x": 751.98,
        "y": 293.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t033",
      "name": "Tranquil Longevity – Western Court",
      "regionId": "r04",
      "adjacencies": [
        "t022a",
        "t022b",
        "t028"
      ],
      "shape": "M 883 279 L 923 279 L 923 337 L 883 337 Z",
      "position": {
        "x": 903,
        "y": 308
      },
      "badgeAnchor": {
        "x": 902.38,
        "y": 299.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t034",
      "name": "Tranquil Longevity – Garden Court",
      "regionId": "r04",
      "adjacencies": [
        "t022a",
        "t022b",
        "t028"
      ],
      "shape": "M 1004 279 L 1038 279 L 1038 337 L 1004 337 Z",
      "position": {
        "x": 1021,
        "y": 308
      },
      "badgeAnchor": {
        "x": 1020.47,
        "y": 296.22
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t035",
      "name": "West Six – West Courtyard",
      "regionId": "r02",
      "adjacencies": [
        "t016",
        "t029",
        "t031",
        "t039"
      ],
      "shape": "M 244 282 L 298 282 L 298 324 L 244 324 Z",
      "position": {
        "x": 271,
        "y": 303
      },
      "badgeAnchor": {
        "x": 270.16,
        "y": 302.34
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t036",
      "name": "East Six – East Courtyard",
      "regionId": "r03",
      "adjacencies": [
        "t023",
        "t032",
        "tr008"
      ],
      "shape": "M 655 291 L 732 291 L 732 332 L 655 332 Z",
      "position": {
        "x": 693.5,
        "y": 311.5
      },
      "badgeAnchor": {
        "x": 677.86,
        "y": 310.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t037",
      "name": "East Six – West Courtyard",
      "regionId": "r03",
      "adjacencies": [
        "t024",
        "t032"
      ],
      "shape": "M 772 291 L 851 291 L 851 332 L 772 332 Z",
      "position": {
        "x": 811.5,
        "y": 311.5
      },
      "badgeAnchor": {
        "x": 795.45,
        "y": 310.86
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t038",
      "name": "Inner Court – Eastern Side Hall",
      "regionId": "r06",
      "adjacencies": [
        "t025",
        "t027",
        "t040",
        "t041"
      ],
      "shape": "M 537 306 L 589 306 L 589 346 L 537 346 Z",
      "position": {
        "x": 563,
        "y": 326
      },
      "badgeAnchor": {
        "x": 557.31,
        "y": 325.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t039",
      "name": "West Six – Garden Walk",
      "regionId": "r02",
      "adjacencies": [
        "t029",
        "t031",
        "t035"
      ],
      "shape": "M 244 327 L 298 327 L 298 380 L 244 380 Z",
      "position": {
        "x": 271,
        "y": 353.5
      },
      "badgeAnchor": {
        "x": 270.16,
        "y": 352.67
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t040",
      "name": "Inner Court – Western Side Hall",
      "regionId": "r06",
      "adjacencies": [
        "t025",
        "t038",
        "t041",
        "t043"
      ],
      "shape": "M 491 328 L 491 390 L 533 390 L 533 370 L 534 369 L 561 369 L 561 350 L 560 349 L 537 349 L 536 350 L 533 349 L 533 328 L 523 328 L 522 327 L 494 327 Z",
      "position": {
        "x": 510.08,
        "y": 356.3
      },
      "badgeAnchor": {
        "x": 510.08,
        "y": 356.3
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t041",
      "name": "Inner Court – Northern Approach",
      "regionId": "r06",
      "adjacencies": [
        "t027",
        "t038",
        "t040",
        "t043"
      ],
      "shape": "M 565 350 L 565 369 L 592 369 L 593 370 L 593 390 L 635 390 L 635 328 L 634 327 L 595 327 L 593 328 L 593 348 L 592 349 L 566 349 Z",
      "position": {
        "x": 616.3,
        "y": 355.41
      },
      "badgeAnchor": {
        "x": 616.3,
        "y": 355.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t042",
      "name": "West Six – Pavilion of Tranquillity",
      "regionId": "r02",
      "adjacencies": [
        "t021",
        "t030",
        "tr010"
      ],
      "shape": "M 405 337 L 464 337 L 464 380 L 405 380 Z",
      "position": {
        "x": 434.5,
        "y": 358.5
      },
      "badgeAnchor": {
        "x": 429.89,
        "y": 357.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t043",
      "name": "Inner Court – Southern Approach",
      "regionId": "r06",
      "adjacencies": [
        "t040",
        "t041",
        "tr011"
      ],
      "shape": "M 537 374 L 589 374 L 589 404 L 537 404 Z",
      "position": {
        "x": 563,
        "y": 389
      },
      "badgeAnchor": {
        "x": 557.42,
        "y": 388.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t044",
      "name": "Hall of Worshipping Ancestors – Front Court",
      "regionId": "r07",
      "adjacencies": [
        "t045",
        "t058",
        "t061"
      ],
      "shape": "M 883 374 L 910 374 L 910 482 L 883 482 Z",
      "position": {
        "x": 896.5,
        "y": 428
      },
      "badgeAnchor": {
        "x": 896.08,
        "y": 389.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t045",
      "name": "Hall of Worshipping Ancestors – Main",
      "regionId": "r07",
      "adjacencies": [
        "t044",
        "t046",
        "t047",
        "t058",
        "tr008"
      ],
      "shape": "M 913 375 L 914 443 L 934 443 L 934 416 L 936 414 L 987 414 L 988 443 L 1008 443 L 1008 374 Z",
      "position": {
        "x": 960.56,
        "y": 396.07
      },
      "badgeAnchor": {
        "x": 960.56,
        "y": 396.07
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t046",
      "name": "Hall of Worshipping Ancestors – Rear Court",
      "regionId": "r07",
      "adjacencies": [
        "t045",
        "t058",
        "t062"
      ],
      "shape": "M 1013 374 L 1038 374 L 1038 482 L 1013 482 Z",
      "position": {
        "x": 1025.5,
        "y": 428
      },
      "badgeAnchor": {
        "x": 1025.11,
        "y": 389.19
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t047",
      "name": "Hall of Worshipping Ancestors – East Wing",
      "regionId": "r07",
      "adjacencies": [
        "t045",
        "t058"
      ],
      "shape": "M 939 419 L 984 419 L 984 472 L 939 472 Z",
      "position": {
        "x": 961.5,
        "y": 445.5
      },
      "badgeAnchor": {
        "x": 960.8,
        "y": 441.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t048",
      "name": "Hall of Abstinence – Front Gate",
      "regionId": "r08",
      "adjacencies": [
        "t049"
      ],
      "shape": "M 656 435 L 718 435 L 718 541 L 656 541 Z",
      "position": {
        "x": 687,
        "y": 488
      },
      "badgeAnchor": {
        "x": 686.03,
        "y": 466.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t049",
      "name": "Hall of Abstinence – Side Court",
      "regionId": "r08",
      "adjacencies": [
        "t048",
        "t050",
        "t072",
        "tr008",
        "tr017"
      ],
      "shape": "M 722 435 L 762 435 L 762 541 L 722 541 Z",
      "position": {
        "x": 742,
        "y": 488
      },
      "badgeAnchor": {
        "x": 741.38,
        "y": 466.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t050",
      "name": "Hall of Abstinence – Rear Court",
      "regionId": "r08",
      "adjacencies": [
        "t049",
        "t051",
        "t072"
      ],
      "shape": "M 766 435 L 766 540 L 848 540 L 848 504 L 805 503 L 805 435 Z",
      "position": {
        "x": 785.36,
        "y": 486.7
      },
      "badgeAnchor": {
        "x": 785.36,
        "y": 486.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t051",
      "name": "Hall of Abstinence – Main",
      "regionId": "r08",
      "adjacencies": [
        "t050"
      ],
      "shape": "M 809 435 L 849 435 L 849 500 L 809 500 Z",
      "position": {
        "x": 829,
        "y": 467.5
      },
      "badgeAnchor": {
        "x": 828.38,
        "y": 456.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t052",
      "name": "Hall of Mental Cultivation – Rear Hall",
      "regionId": "r09",
      "adjacencies": [
        "t053",
        "t070",
        "t073",
        "tr010"
      ],
      "shape": "M 152 437 L 202 437 L 202 552 L 152 552 Z",
      "position": {
        "x": 177,
        "y": 494.5
      },
      "badgeAnchor": {
        "x": 176.22,
        "y": 463.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t053",
      "name": "Hall of Mental Cultivation – Eastern Warmth Chamber",
      "regionId": "r09",
      "adjacencies": [
        "t052",
        "t054",
        "t059",
        "t067",
        "t070"
      ],
      "shape": "M 206 437 L 206 530 L 244 530 L 244 515 L 246 513 L 277 513 L 277 498 L 244 497 L 244 464 L 277 463 L 277 437 Z",
      "position": {
        "x": 225.71,
        "y": 481.23
      },
      "badgeAnchor": {
        "x": 225.71,
        "y": 481.23
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t054",
      "name": "Hall of Mental Cultivation – Western Warmth Chamber",
      "regionId": "r09",
      "adjacencies": [
        "t053",
        "t059",
        "t067",
        "t071",
        "tr010"
      ],
      "shape": "M 282 437 L 282 463 L 315 464 L 315 497 L 282 498 L 282 513 L 313 513 L 315 515 L 315 530 L 347 530 L 348 438 Z",
      "position": {
        "x": 332.83,
        "y": 479.1
      },
      "badgeAnchor": {
        "x": 332.83,
        "y": 479.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t055",
      "name": "Palace of Compassion and Tranquility – Front Gate",
      "regionId": "r10",
      "adjacencies": [
        "t056",
        "t060"
      ],
      "shape": "M 373 437 L 401 437 L 401 469 L 373 469 Z",
      "position": {
        "x": 387,
        "y": 453
      },
      "badgeAnchor": {
        "x": 386.56,
        "y": 451.5
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t056",
      "name": "Palace of Compassion and Tranquility – East Wing",
      "regionId": "r10",
      "adjacencies": [
        "t055",
        "t057",
        "t060",
        "tr010"
      ],
      "shape": "M 405 437 L 434 437 L 434 469 L 405 469 Z",
      "position": {
        "x": 419.5,
        "y": 453
      },
      "badgeAnchor": {
        "x": 419.05,
        "y": 451.5
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t057",
      "name": "Palace of Compassion and Tranquility – Main",
      "regionId": "r10",
      "adjacencies": [
        "t056",
        "t060"
      ],
      "shape": "M 438 438 L 438 468 L 463 468 L 463 437 L 442 437 L 441 438 Z",
      "position": {
        "x": 450.87,
        "y": 452.89
      },
      "badgeAnchor": {
        "x": 450.87,
        "y": 452.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t058",
      "name": "Hall of Worshipping Ancestors – West Wing",
      "regionId": "r07",
      "adjacencies": [
        "t044",
        "t045",
        "t046",
        "t047",
        "t061",
        "t062",
        "t069"
      ],
      "shape": "M 913 448 L 914 528 L 1008 528 L 1008 448 L 988 448 L 987 475 L 935 475 L 934 448 Z",
      "position": {
        "x": 960.9,
        "y": 474.8
      },
      "badgeAnchor": {
        "x": 941.2,
        "y": 501.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t059",
      "name": "Hall of Mental Cultivation – Main",
      "regionId": "r09",
      "adjacencies": [
        "t053",
        "t054"
      ],
      "shape": "M 249 468 L 311 468 L 311 495 L 249 495 Z",
      "position": {
        "x": 280,
        "y": 481.5
      },
      "badgeAnchor": {
        "x": 263.53,
        "y": 481.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t060",
      "name": "Palace of Compassion and Tranquility – West Wing",
      "regionId": "r10",
      "adjacencies": [
        "t055",
        "t056",
        "t057",
        "t064",
        "t065",
        "t066"
      ],
      "shape": "M 373 473 L 464 473 L 464 505 L 373 505 Z",
      "position": {
        "x": 418.5,
        "y": 489
      },
      "badgeAnchor": {
        "x": 388.64,
        "y": 488.5
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t061",
      "name": "Worshipping Ancestors – South Gate",
      "regionId": "r07",
      "adjacencies": [
        "t044",
        "t058",
        "t069"
      ],
      "shape": "M 883 486 L 910 486 L 910 589 L 883 589 Z",
      "position": {
        "x": 896.5,
        "y": 537.5
      },
      "badgeAnchor": {
        "x": 896.08,
        "y": 500.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t062",
      "name": "Worshipping Ancestors – North Gate",
      "regionId": "r07",
      "adjacencies": [
        "t046",
        "t058",
        "t069"
      ],
      "shape": "M 1013 486 L 1038 486 L 1038 589 L 1013 589 Z",
      "position": {
        "x": 1025.5,
        "y": 537.5
      },
      "badgeAnchor": {
        "x": 1025.11,
        "y": 500.48
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t063",
      "name": "Gate of Heavenly Purity – Outer",
      "regionId": "r11",
      "adjacencies": [
        "t068",
        "tr011"
      ],
      "shape": "M 529 507 L 529 510 L 530 512 L 536 515 L 593 515 L 597 511 L 598 509 L 598 507 L 589 507 L 585 505 L 564 490 L 562 490 L 559 493 L 558 493 L 556 495 L 552 497 L 549 500 L 548 500 L 545 503 L 544 503 L 540 506 L 538 506 L 537 507 Z",
      "position": {
        "x": 562.24,
        "y": 501.63
      },
      "badgeAnchor": {
        "x": 562.24,
        "y": 501.63
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t064",
      "name": "Palace of Longevity and Health",
      "regionId": "r10",
      "adjacencies": [
        "t060",
        "t065",
        "tr013"
      ],
      "shape": "M 373 509 L 373 539 L 378 539 L 379 540 L 395 540 L 396 539 L 400 539 L 400 509 Z",
      "position": {
        "x": 387.59,
        "y": 523.93
      },
      "badgeAnchor": {
        "x": 387.59,
        "y": 523.93
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t065",
      "name": "Palace of Compassion and Tranquility – Rear Hall",
      "regionId": "r10",
      "adjacencies": [
        "t060",
        "t064",
        "t066"
      ],
      "shape": "M 405 509 L 405 539 L 424 539 L 425 540 L 432 540 L 433 539 L 433 509 Z",
      "position": {
        "x": 418.85,
        "y": 523.59
      },
      "badgeAnchor": {
        "x": 418.85,
        "y": 523.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t066",
      "name": "Compassion and Tranquility – Side Court",
      "regionId": "r10",
      "adjacencies": [
        "t060",
        "t065"
      ],
      "shape": "M 438 509 L 438 539 L 444 539 L 445 540 L 449 540 L 450 539 L 457 539 L 458 540 L 462 540 L 463 539 L 463 509 Z",
      "position": {
        "x": 450.09,
        "y": 524.85
      },
      "badgeAnchor": {
        "x": 450.09,
        "y": 524.85
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t067",
      "name": "Hall of Mental Cultivation – Front Gate",
      "regionId": "r09",
      "adjacencies": [
        "t053",
        "t054",
        "t070",
        "t071"
      ],
      "shape": "M 249 518 L 311 518 L 311 549 L 249 549 Z",
      "position": {
        "x": 280,
        "y": 533.5
      },
      "badgeAnchor": {
        "x": 265.47,
        "y": 533.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t068",
      "name": "Gate of Heavenly Purity – Inner",
      "regionId": "r11",
      "adjacencies": [
        "t063",
        "tr014"
      ],
      "shape": "M 533 538 L 533 542 L 593 542 L 593 538 L 592 537 L 592 533 L 591 532 L 591 529 L 590 528 L 590 524 L 589 523 L 589 520 L 538 520 L 537 521 L 537 525 L 536 526 L 536 529 L 535 530 L 535 533 L 534 534 L 534 537 Z",
      "position": {
        "x": 561.8,
        "y": 530.5
      },
      "badgeAnchor": {
        "x": 554.74,
        "y": 530.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t069",
      "name": "Worshipping Ancestors – Side Pavilion",
      "regionId": "r07",
      "adjacencies": [
        "t058",
        "t061",
        "t062",
        "tr017"
      ],
      "shape": "M 913 533 L 1009 533 L 1009 589 L 913 589 Z",
      "position": {
        "x": 961,
        "y": 561
      },
      "badgeAnchor": {
        "x": 941.2,
        "y": 560.13
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t070",
      "name": "Hall of Three Rare Treasures",
      "regionId": "r09",
      "adjacencies": [
        "t052",
        "t053",
        "t067",
        "t071",
        "t073",
        "t074"
      ],
      "shape": "M 206 535 L 206 595 L 277 595 L 277 553 L 276 552 L 245 552 L 244 551 L 244 535 Z",
      "position": {
        "x": 230.78,
        "y": 565.09
      },
      "badgeAnchor": {
        "x": 230.78,
        "y": 565.09
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t071",
      "name": "Mental Cultivation – Eastern Court",
      "regionId": "r09",
      "adjacencies": [
        "t054",
        "t067",
        "t070",
        "t074"
      ],
      "shape": "M 348 535 L 315 535 L 315 551 L 314 552 L 283 552 L 282 553 L 282 595 L 347 595 L 347 585 L 348 584 L 348 567 L 347 566 L 348 554 L 347 553 L 347 545 L 348 544 Z",
      "position": {
        "x": 325.69,
        "y": 566.8
      },
      "badgeAnchor": {
        "x": 325.69,
        "y": 566.8
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t072",
      "name": "Hall of Abstinence – South Pavilion",
      "regionId": "r08",
      "adjacencies": [
        "t049",
        "t050"
      ],
      "shape": "M 766 544 L 849 544 L 849 595 L 766 595 Z",
      "position": {
        "x": 807.5,
        "y": 569.5
      },
      "badgeAnchor": {
        "x": 790.51,
        "y": 568.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t073",
      "name": "Mental Cultivation – Western Court",
      "regionId": "r09",
      "adjacencies": [
        "t052",
        "t070",
        "t074",
        "t079",
        "t080"
      ],
      "shape": "M 152 556 L 152 630 L 218 630 L 218 600 L 202 600 L 201 599 L 201 556 Z",
      "position": {
        "x": 180.09,
        "y": 598.47
      },
      "badgeAnchor": {
        "x": 180.09,
        "y": 598.47
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t074",
      "name": "Mental Cultivation – Northern Court",
      "regionId": "r09",
      "adjacencies": [
        "t070",
        "t071",
        "t073",
        "t079",
        "t080",
        "t081",
        "tr013"
      ],
      "shape": "M 223 600 L 349 600 L 349 631 L 223 631 Z",
      "position": {
        "x": 286,
        "y": 615.5
      },
      "badgeAnchor": {
        "x": 240.72,
        "y": 615.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t075",
      "name": "Hall of Supreme Harmony – Front Terrace",
      "regionId": "r12",
      "adjacencies": [
        "t076",
        "t077",
        "t078",
        "t083",
        "t084",
        "t089",
        "t090",
        "tr014"
      ],
      "shape": "M 479 605 L 479 708 L 522 709 L 523 726 L 561 726 L 561 693 L 499 692 L 498 623 L 500 619 L 561 619 L 561 606 Z",
      "position": {
        "x": 538.95,
        "y": 709.61
      },
      "badgeAnchor": {
        "x": 538.95,
        "y": 709.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t076",
      "name": "Hall of Supreme Harmony – West Side Hall",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t077",
        "t078",
        "t083",
        "t084",
        "t089",
        "t090",
        "tr014"
      ],
      "shape": "M 565 605 L 565 619 L 626 619 L 628 621 L 628 691 L 626 693 L 565 693 L 565 726 L 604 726 L 605 708 L 648 708 L 648 605 Z",
      "position": {
        "x": 582.3,
        "y": 708.58
      },
      "badgeAnchor": {
        "x": 582.3,
        "y": 708.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t077",
      "name": "Hall of Supreme Harmony",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t076",
        "t078",
        "t082",
        "t083"
      ],
      "shape": "M 503 624 L 503 654 L 543 654 L 543 640 L 544 639 L 561 639 L 561 625 L 560 624 Z",
      "position": {
        "x": 523.96,
        "y": 640.57
      },
      "badgeAnchor": {
        "x": 523.96,
        "y": 640.57
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t078",
      "name": "Hall of Central Harmony",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t076",
        "t077",
        "t082",
        "t084"
      ],
      "shape": "M 565 625 L 565 639 L 582 639 L 583 640 L 583 654 L 623 654 L 623 624 L 566 624 Z",
      "position": {
        "x": 603.27,
        "y": 637.75
      },
      "badgeAnchor": {
        "x": 603.27,
        "y": 637.75
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t079",
      "name": "Mental Cultivation – Side Pavilion",
      "regionId": "r09",
      "adjacencies": [
        "t073",
        "t074",
        "t080",
        "t081"
      ],
      "shape": "M 152 635 L 152 821 L 292 821 L 292 635 L 259 635 L 258 781 L 181 779 L 181 635 Z",
      "position": {
        "x": 221.68,
        "y": 798.56
      },
      "badgeAnchor": {
        "x": 221.68,
        "y": 798.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t080",
      "name": "Mental Cultivation – Southern Court",
      "regionId": "r09",
      "adjacencies": [
        "t073",
        "t074",
        "t079"
      ],
      "shape": "M 186 635 L 255 635 L 255 777 L 186 777 Z",
      "position": {
        "x": 219.46,
        "y": 713.39
      },
      "badgeAnchor": {
        "x": 219.46,
        "y": 713.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t081",
      "name": "Mental Cultivation – Storage Hall",
      "regionId": "r09",
      "adjacencies": [
        "t074",
        "t079"
      ],
      "shape": "M 297 635 L 349 635 L 349 822 L 297 822 Z",
      "position": {
        "x": 323,
        "y": 728.5
      },
      "badgeAnchor": {
        "x": 322.19,
        "y": 730.98
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t082",
      "name": "Hall of Preserving Harmony",
      "regionId": "r12",
      "adjacencies": [
        "t077",
        "t078",
        "t083",
        "t084"
      ],
      "shape": "M 547 644 L 579 644 L 579 670 L 547 670 Z",
      "position": {
        "x": 563,
        "y": 657
      },
      "badgeAnchor": {
        "x": 560.5,
        "y": 656.59
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t083",
      "name": "Hall of Central Harmony – East Approach",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t076",
        "t077",
        "t082",
        "t084"
      ],
      "shape": "M 503 659 L 503 688 L 561 688 L 561 674 L 560 673 L 544 673 L 543 672 L 543 659 L 535 659 L 534 658 L 530 658 L 529 659 Z",
      "position": {
        "x": 523.43,
        "y": 671.88
      },
      "badgeAnchor": {
        "x": 523.43,
        "y": 671.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t084",
      "name": "Hall of Supreme Harmony – East Side Hall",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t076",
        "t078",
        "t082",
        "t083"
      ],
      "shape": "M 565 673 L 565 688 L 623 688 L 623 659 L 598 659 L 597 658 L 592 658 L 591 659 L 583 659 L 583 672 L 582 673 Z",
      "position": {
        "x": 602.46,
        "y": 672.94
      },
      "badgeAnchor": {
        "x": 602.46,
        "y": 672.94
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t085",
      "name": "Belvedere of Pleasant Sounds",
      "regionId": "r13",
      "adjacencies": [
        "t087",
        "t093"
      ],
      "shape": "M 880 665 L 921 665 L 921 779 L 880 779 Z",
      "position": {
        "x": 900.5,
        "y": 722
      },
      "badgeAnchor": {
        "x": 899.86,
        "y": 688.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t086",
      "name": "Belvedere of Pleasant Sounds – Stage",
      "regionId": "r13",
      "adjacencies": [
        "t087",
        "t093",
        "tr017"
      ],
      "shape": "M 969 665 L 1010 665 L 1010 779 L 969 779 Z",
      "position": {
        "x": 989.5,
        "y": 722
      },
      "badgeAnchor": {
        "x": 988.86,
        "y": 688.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t087",
      "name": "Belvedere of Pleasant Sounds – Audience Hall",
      "regionId": "r13",
      "adjacencies": [
        "t085",
        "t086",
        "t093"
      ],
      "shape": "M 924 666 L 965 666 L 965 779 L 924 779 Z",
      "position": {
        "x": 944.5,
        "y": 722.5
      },
      "badgeAnchor": {
        "x": 943.86,
        "y": 688.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t088",
      "name": "Pavilion of Floating Jade",
      "regionId": "r14",
      "adjacencies": [
        "tr022"
      ],
      "shape": "M 819 684 L 862 684 L 862 829 L 819 829 Z",
      "position": {
        "x": 840.5,
        "y": 756.5
      },
      "badgeAnchor": {
        "x": 839.83,
        "y": 708.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t089",
      "name": "Hall of Central Harmony – West Approach",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t076",
        "t090",
        "t091",
        "t092",
        "t095",
        "t096",
        "tr015"
      ],
      "shape": "M 561 731 L 523 731 L 522 752 L 479 752 L 479 812 L 499 811 L 500 776 L 561 776 Z",
      "position": {
        "x": 542.34,
        "y": 750.36
      },
      "badgeAnchor": {
        "x": 542.34,
        "y": 750.36
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t090",
      "name": "Hall of Preserving Harmony – East Side Hall",
      "regionId": "r12",
      "adjacencies": [
        "t075",
        "t076",
        "t089",
        "t091",
        "t092",
        "t097",
        "t098",
        "tr016"
      ],
      "shape": "M 565 731 L 565 776 L 626 776 L 628 778 L 627 781 L 628 812 L 648 812 L 648 752 L 605 752 L 604 731 Z",
      "position": {
        "x": 585.58,
        "y": 751.28
      },
      "badgeAnchor": {
        "x": 585.58,
        "y": 751.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t091",
      "name": "Outer Court – Eastern Gate of Glory",
      "regionId": "r12",
      "adjacencies": [
        "t089",
        "t090",
        "t092",
        "t094",
        "t095",
        "t096"
      ],
      "shape": "M 503 781 L 503 811 L 504 812 L 543 812 L 543 798 L 544 797 L 561 797 L 561 781 Z",
      "position": {
        "x": 521.75,
        "y": 796.77
      },
      "badgeAnchor": {
        "x": 521.75,
        "y": 796.77
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t092",
      "name": "Hall of Preserving Harmony – West Side Hall",
      "regionId": "r12",
      "adjacencies": [
        "t089",
        "t090",
        "t091",
        "t094",
        "t097",
        "t098"
      ],
      "shape": "M 565 781 L 565 797 L 582 797 L 583 798 L 583 812 L 623 812 L 623 781 Z",
      "position": {
        "x": 604.33,
        "y": 797.31
      },
      "badgeAnchor": {
        "x": 604.33,
        "y": 797.31
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t093",
      "name": "Belvedere of Pleasant Sounds – Side Court",
      "regionId": "r13",
      "adjacencies": [
        "t085",
        "t086",
        "t087",
        "tr021"
      ],
      "shape": "M 880 782 L 1010 782 L 1010 807 L 880 807 Z",
      "position": {
        "x": 945,
        "y": 794.5
      },
      "badgeAnchor": {
        "x": 894.22,
        "y": 794.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t094",
      "name": "Outer Court – Western Gate of Glory",
      "regionId": "r12",
      "adjacencies": [
        "t091",
        "t092",
        "t096",
        "t097"
      ],
      "shape": "M 578 801 L 566 801 L 565 802 L 547 802 L 547 826 L 548 827 L 578 827 Z",
      "position": {
        "x": 561.47,
        "y": 814.91
      },
      "badgeAnchor": {
        "x": 561.47,
        "y": 814.91
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t095",
      "name": "Outer Court – Northern Steps",
      "regionId": "r12",
      "adjacencies": [
        "t089",
        "t091",
        "t096",
        "t097",
        "t098",
        "t099"
      ],
      "shape": "M 479 816 L 479 867 L 506 868 L 506 910 L 533 910 L 534 878 L 561 877 L 561 851 L 500 851 L 499 817 Z",
      "position": {
        "x": 520.67,
        "y": 867.9
      },
      "badgeAnchor": {
        "x": 520.67,
        "y": 867.9
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t096",
      "name": "Outer Court – Bronze Lion Plaza",
      "regionId": "r12",
      "adjacencies": [
        "t089",
        "t091",
        "t094",
        "t095",
        "t097",
        "t098"
      ],
      "shape": "M 503 817 L 503 846 L 561 846 L 561 832 L 560 831 L 544 831 L 543 830 L 543 817 L 542 816 L 504 816 Z",
      "position": {
        "x": 521.94,
        "y": 830.65
      },
      "badgeAnchor": {
        "x": 521.94,
        "y": 830.65
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t097",
      "name": "Outer Court – Sundial Court",
      "regionId": "r12",
      "adjacencies": [
        "t090",
        "t092",
        "t094",
        "t095",
        "t096",
        "t098"
      ],
      "shape": "M 565 831 L 565 846 L 623 846 L 623 816 L 583 816 L 583 830 L 582 831 Z",
      "position": {
        "x": 604.32,
        "y": 830.88
      },
      "badgeAnchor": {
        "x": 604.32,
        "y": 830.88
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t098",
      "name": "Outer Court – Grain Measure Court",
      "regionId": "r12",
      "adjacencies": [
        "t090",
        "t092",
        "t095",
        "t096",
        "t097",
        "t099"
      ],
      "shape": "M 648 816 L 628 816 L 628 849 L 626 851 L 565 851 L 565 877 L 592 878 L 593 910 L 620 910 L 621 868 L 648 867 Z",
      "position": {
        "x": 603.33,
        "y": 869.1
      },
      "badgeAnchor": {
        "x": 603.33,
        "y": 869.1
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t099",
      "name": "Outer Court – Southern Steps",
      "regionId": "r12",
      "adjacencies": [
        "t095",
        "t098",
        "tr020"
      ],
      "shape": "M 539 882 L 589 882 L 589 911 L 539 911 Z",
      "position": {
        "x": 564,
        "y": 896.5
      },
      "badgeAnchor": {
        "x": 553.84,
        "y": 896.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t100",
      "name": "Pavilion of Crimson Snow",
      "regionId": "r15",
      "adjacencies": [
        "tr021"
      ],
      "shape": "M 1015 922 L 1015 957 L 1014 958 L 992 958 L 993 1006 L 1057 1006 L 1057 922 Z",
      "position": {
        "x": 1031.14,
        "y": 972.83
      },
      "badgeAnchor": {
        "x": 1031.14,
        "y": 972.83
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t101",
      "name": "Garden of Compassion and Tranquility – Pavilion",
      "regionId": "r16",
      "adjacencies": [
        "t102",
        "t105"
      ],
      "shape": "M 166 958 L 245 958 L 245 1004 L 166 1004 Z",
      "position": {
        "x": 205.5,
        "y": 981
      },
      "badgeAnchor": {
        "x": 189.45,
        "y": 980.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t102",
      "name": "Garden of Compassion and Tranquility – East Walk",
      "regionId": "r16",
      "adjacencies": [
        "t101",
        "t105"
      ],
      "shape": "M 249 958 L 321 958 L 321 1004 L 249 1004 Z",
      "position": {
        "x": 285,
        "y": 981
      },
      "badgeAnchor": {
        "x": 272.63,
        "y": 980.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t103",
      "name": "Southern Three Treasuries – Central Hall",
      "regionId": "r17",
      "adjacencies": [
        "t104",
        "t106",
        "t107",
        "tr022"
      ],
      "shape": "M 771 961 L 851 961 L 851 1035 L 771 1035 Z",
      "position": {
        "x": 811,
        "y": 998
      },
      "badgeAnchor": {
        "x": 808.5,
        "y": 996.84
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t104",
      "name": "Southern Three Treasuries – East Hall",
      "regionId": "r17",
      "adjacencies": [
        "t103",
        "t106"
      ],
      "shape": "M 854 961 L 902 961 L 902 1007 L 854 1007 Z",
      "position": {
        "x": 878,
        "y": 984
      },
      "badgeAnchor": {
        "x": 877.25,
        "y": 983.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t105",
      "name": "Garden of Compassion and Tranquility – West Walk",
      "regionId": "r16",
      "adjacencies": [
        "t101",
        "t102",
        "t108",
        "t110"
      ],
      "shape": "M 180 1007 L 180 1069 L 218 1069 L 218 1041 L 220 1039 L 273 1039 L 274 1069 L 307 1069 L 307 1007 Z",
      "position": {
        "x": 249.76,
        "y": 1023.7
      },
      "badgeAnchor": {
        "x": 249.76,
        "y": 1023.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t106",
      "name": "Southern Three Treasuries – West Hall",
      "regionId": "r17",
      "adjacencies": [
        "t103",
        "t104",
        "t107"
      ],
      "shape": "M 854 1011 L 893 1011 L 893 1149 L 854 1149 Z",
      "position": {
        "x": 873.5,
        "y": 1080
      },
      "badgeAnchor": {
        "x": 872.89,
        "y": 1030.41
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t107",
      "name": "Southern Three Treasuries – Courtyard",
      "regionId": "r17",
      "adjacencies": [
        "t103",
        "t106",
        "tr027"
      ],
      "shape": "M 771 1039 L 851 1039 L 851 1149 L 771 1149 Z",
      "position": {
        "x": 811,
        "y": 1094
      },
      "badgeAnchor": {
        "x": 808.5,
        "y": 1078.53
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t108",
      "name": "Garden of Compassion and Tranquility – Lotus Pond",
      "regionId": "r16",
      "adjacencies": [
        "t105",
        "t110"
      ],
      "shape": "M 223 1044 L 271 1044 L 271 1099 L 223 1099 Z",
      "position": {
        "x": 247,
        "y": 1071.5
      },
      "badgeAnchor": {
        "x": 246.25,
        "y": 1068.92
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t109",
      "name": "Gate of Supreme Harmony – Outer",
      "regionId": "r18",
      "adjacencies": [
        "t112",
        "tr020"
      ],
      "shape": "M 506 1081 L 508 1088 L 513 1094 L 516 1096 L 524 1098 L 603 1098 L 613 1094 L 617 1090 L 619 1085 L 619 1081 L 607 1081 L 597 1077 L 568 1054 L 557 1054 L 532 1074 L 531 1076 L 525 1079 L 518 1081 Z",
      "position": {
        "x": 563.51,
        "y": 1077.73
      },
      "badgeAnchor": {
        "x": 563.51,
        "y": 1077.73
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t110",
      "name": "Garden of Compassion and Tranquility – Rockery",
      "regionId": "r16",
      "adjacencies": [
        "t105",
        "t108",
        "tr025"
      ],
      "shape": "M 180 1073 L 180 1144 L 213 1199 L 307 1199 L 306 1073 L 275 1073 L 273 1103 L 219 1103 L 217 1073 Z",
      "position": {
        "x": 249.66,
        "y": 1139.31
      },
      "badgeAnchor": {
        "x": 249.66,
        "y": 1139.31
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t111",
      "name": "West Glorious Gate – Tower",
      "regionId": "r19",
      "adjacencies": [
        "t115",
        "tr025"
      ],
      "shape": "M 58 1104 L 51 1109 L 47 1117 L 47 1122 L 46 1123 L 46 1199 L 48 1208 L 53 1216 L 60 1219 L 63 1219 L 64 1203 L 70 1193 L 87 1171 L 89 1167 L 89 1154 L 65 1122 L 63 1116 L 63 1104 Z",
      "position": {
        "x": 61.6,
        "y": 1159.2
      },
      "badgeAnchor": {
        "x": 66.83,
        "y": 1159.7
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t112",
      "name": "Gate of Supreme Harmony – Inner",
      "regionId": "r18",
      "adjacencies": [
        "t109",
        "tr033"
      ],
      "shape": "M 527 1103 L 524 1119 L 522 1124 L 522 1129 L 520 1134 L 518 1148 L 608 1148 L 599 1103 Z",
      "position": {
        "x": 563.51,
        "y": 1127.33
      },
      "badgeAnchor": {
        "x": 563.51,
        "y": 1127.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t113",
      "name": "East Glorious Gate – Tower",
      "regionId": "r20",
      "adjacencies": [
        "t114",
        "tr026"
      ],
      "shape": "M 1074 1104 L 1068 1104 L 1068 1117 L 1064 1125 L 1042 1154 L 1042 1168 L 1065 1199 L 1068 1207 L 1068 1219 L 1074 1218 L 1080 1213 L 1085 1199 L 1085 1190 L 1084 1189 L 1084 1119 L 1081 1111 Z",
      "position": {
        "x": 1064.13,
        "y": 1160.21
      },
      "badgeAnchor": {
        "x": 1064.13,
        "y": 1160.21
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t114",
      "name": "East Glorious Gate – Passage",
      "regionId": "r20",
      "adjacencies": [
        "t113"
      ],
      "shape": "M 1090 1124 L 1090 1189 L 1089 1190 L 1090 1198 L 1129 1210 L 1148 1214 L 1148 1108 Z",
      "position": {
        "x": 1118.49,
        "y": 1160.73
      },
      "badgeAnchor": {
        "x": 1118.49,
        "y": 1160.73
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t115",
      "name": "West Glorious Gate – Passage",
      "regionId": "r19",
      "adjacencies": [
        "t111"
      ],
      "shape": "M 7 1114 L 3 1114 L 3 1209 L 23 1204 L 26 1202 L 41 1199 L 41 1124 L 17 1118 Z",
      "position": {
        "x": 20.1,
        "y": 1160.5
      },
      "badgeAnchor": {
        "x": 21.41,
        "y": 1139.23
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t116",
      "name": "Hall of Military Eminence – Main",
      "regionId": "r21",
      "adjacencies": [
        "t117",
        "t118"
      ],
      "shape": "M 74 1227 L 113 1227 L 113 1267 L 74 1267 Z",
      "position": {
        "x": 93.5,
        "y": 1247
      },
      "badgeAnchor": {
        "x": 92.89,
        "y": 1246.38
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t117",
      "name": "Hall of Military Eminence – Front Gate",
      "regionId": "r21",
      "adjacencies": [
        "t116",
        "t118",
        "t119",
        "t127",
        "t130"
      ],
      "shape": "M 117 1247 L 185 1247 L 185 1320 L 117 1320 Z",
      "position": {
        "x": 151,
        "y": 1283.5
      },
      "badgeAnchor": {
        "x": 140.38,
        "y": 1280.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t118",
      "name": "Hall of Military Eminence – Rear Hall",
      "regionId": "r21",
      "adjacencies": [
        "t116",
        "t117",
        "t127"
      ],
      "shape": "M 74 1270 L 113 1270 L 113 1299 L 74 1299 Z",
      "position": {
        "x": 93.5,
        "y": 1284.5
      },
      "badgeAnchor": {
        "x": 92.89,
        "y": 1284.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t119",
      "name": "Hall of Military Eminence – East Side Hall",
      "regionId": "r21",
      "adjacencies": [
        "t117",
        "t120",
        "t130"
      ],
      "shape": "M 188 1274 L 233 1274 L 233 1334 L 188 1334 Z",
      "position": {
        "x": 210.5,
        "y": 1304
      },
      "badgeAnchor": {
        "x": 209.8,
        "y": 1297.44
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t120",
      "name": "Military Eminence – Stone Bridge",
      "regionId": "r21",
      "adjacencies": [
        "t119",
        "t121",
        "t123",
        "t130",
        "tr025"
      ],
      "shape": "M 188 1342 L 189 1351 L 331 1351 L 331 1337 L 283 1336 L 283 1274 L 237 1274 L 237 1336 L 189 1337 Z",
      "position": {
        "x": 258.17,
        "y": 1314.16
      },
      "badgeAnchor": {
        "x": 258.17,
        "y": 1314.16
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t121",
      "name": "Hall of Military Eminence – West Side Hall",
      "regionId": "r21",
      "adjacencies": [
        "t120",
        "t123"
      ],
      "shape": "M 288 1274 L 332 1274 L 332 1334 L 288 1334 Z",
      "position": {
        "x": 310,
        "y": 1304
      },
      "badgeAnchor": {
        "x": 309.31,
        "y": 1295.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t122",
      "name": "Meridian Gate – Central Arch",
      "regionId": "r22",
      "adjacencies": [
        "t129",
        "t131",
        "tr033"
      ],
      "shape": "M 509 1319 L 509 1323 L 539 1354 L 586 1354 L 617 1321 L 617 1319 L 572 1279 L 554 1279 Z",
      "position": {
        "x": 562.9,
        "y": 1318.5
      },
      "badgeAnchor": {
        "x": 561.31,
        "y": 1320.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t123",
      "name": "Pavilion of Imperial Library",
      "regionId": "r21",
      "adjacencies": [
        "t120",
        "t121"
      ],
      "shape": "M 336 1284 L 384 1284 L 384 1352 L 336 1352 Z",
      "position": {
        "x": 360,
        "y": 1318
      },
      "badgeAnchor": {
        "x": 359.25,
        "y": 1308.44
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t124",
      "name": "Hall of Literary Glory – Front Gate",
      "regionId": "r23",
      "adjacencies": [
        "t125",
        "t126"
      ],
      "shape": "M 748 1284 L 814 1284 L 814 1352 L 748 1352 Z",
      "position": {
        "x": 781,
        "y": 1318
      },
      "badgeAnchor": {
        "x": 779.97,
        "y": 1312.51
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t125",
      "name": "Hall of Literary Glory – Main",
      "regionId": "r23",
      "adjacencies": [
        "t124",
        "t126"
      ],
      "shape": "M 817 1284 L 867 1284 L 867 1320 L 817 1320 Z",
      "position": {
        "x": 842,
        "y": 1302
      },
      "badgeAnchor": {
        "x": 834.97,
        "y": 1301.44
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t126",
      "name": "Pavilion of Literary Profundity",
      "regionId": "r23",
      "adjacencies": [
        "t124",
        "t125",
        "t128",
        "tr026"
      ],
      "shape": "M 948 1284 L 871 1284 L 871 1323 L 817 1324 L 817 1350 L 919 1351 L 919 1317 L 921 1315 L 948 1315 Z",
      "position": {
        "x": 892.3,
        "y": 1318.1
      },
      "badgeAnchor": {
        "x": 896.83,
        "y": 1312.51
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t127",
      "name": "Military Eminence – Western Court",
      "regionId": "r21",
      "adjacencies": [
        "t117",
        "t118",
        "t130"
      ],
      "shape": "M 74 1303 L 113 1303 L 113 1352 L 74 1352 Z",
      "position": {
        "x": 93.5,
        "y": 1327.5
      },
      "badgeAnchor": {
        "x": 92.89,
        "y": 1322.14
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t128",
      "name": "Hall of Literary Glory – Side Court",
      "regionId": "r23",
      "adjacencies": [
        "t126"
      ],
      "shape": "M 924 1320 L 924 1351 L 947 1351 L 948 1350 L 948 1320 Z",
      "position": {
        "x": 938.2,
        "y": 1338.4
      },
      "badgeAnchor": {
        "x": 935.63,
        "y": 1332.11
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t129",
      "name": "Meridian Gate – East Wing",
      "regionId": "r22",
      "adjacencies": [
        "t122"
      ],
      "shape": "M 594 1352 L 594 1354 L 651 1354 L 652 1356 L 655 1355 L 664 1356 L 666 1354 L 680 1354 L 682 1356 L 694 1356 L 698 1355 L 698 1348 L 693 1348 L 692 1349 L 672 1349 L 671 1348 L 662 1347 L 643 1339 L 629 1330 L 622 1324 L 620 1324 Z",
      "position": {
        "x": 621.82,
        "y": 1339.63
      },
      "badgeAnchor": {
        "x": 621.82,
        "y": 1339.63
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t130",
      "name": "Military Eminence – Southern Court",
      "regionId": "r21",
      "adjacencies": [
        "t117",
        "t119",
        "t120",
        "t127"
      ],
      "shape": "M 117 1324 L 185 1324 L 185 1352 L 117 1352 Z",
      "position": {
        "x": 151,
        "y": 1338
      },
      "badgeAnchor": {
        "x": 140.38,
        "y": 1337.56
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "t131",
      "name": "Meridian Gate – West Wing",
      "regionId": "r22",
      "adjacencies": [
        "t122"
      ],
      "shape": "M 531 1352 L 505 1325 L 503 1325 L 493 1333 L 483 1339 L 468 1346 L 460 1347 L 455 1349 L 437 1349 L 436 1348 L 431 1348 L 432 1355 L 434 1356 L 447 1356 L 448 1354 L 451 1354 L 452 1355 L 463 1354 L 465 1356 L 476 1356 L 477 1354 L 531 1354 Z",
      "position": {
        "x": 500.34,
        "y": 1342.28
      },
      "badgeAnchor": {
        "x": 500.34,
        "y": 1342.28
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr002",
      "name": "Outer Golden Water Bridges",
      "regionId": "roads",
      "adjacencies": [
        "t006",
        "tr001",
        "tr006"
      ],
      "shape": "M 444 93 L 443 92 L 426 92 L 423 87 L 418 82 L 413 79 L 410 79 L 409 78 L 401 78 L 400 79 L 397 79 L 393 81 L 389 85 L 388 85 L 384 92 L 141 92 L 141 112 L 384 112 L 386 114 L 387 117 L 392 122 L 396 124 L 396 128 L 414 128 L 414 124 L 419 121 L 426 112 L 443 112 L 443 109 L 444 108 Z",
      "position": {
        "x": 405,
        "y": 102
      },
      "badgeAnchor": {
        "x": 401.39,
        "y": 100.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr008",
      "name": "West Flowery Gate Road",
      "regionId": "roads",
      "adjacencies": [
        "t028",
        "t032",
        "t036",
        "t045",
        "t049"
      ],
      "shape": "M 723 389 L 724 390 L 725 395 L 728 400 L 735 405 L 735 418 L 736 419 L 735 431 L 736 432 L 753 432 L 753 406 L 762 398 L 763 395 L 765 393 L 785 393 L 786 392 L 792 392 L 793 391 L 798 390 L 805 386 L 818 375 L 822 373 L 826 369 L 831 367 L 835 367 L 836 366 L 953 366 L 954 367 L 953 371 L 972 371 L 972 341 L 954 341 L 953 342 L 953 348 L 952 349 L 950 348 L 835 348 L 834 349 L 829 349 L 817 354 L 805 364 L 804 364 L 803 366 L 800 367 L 798 370 L 796 370 L 794 372 L 792 372 L 788 374 L 785 374 L 784 375 L 765 375 L 763 373 L 760 367 L 753 362 L 753 336 L 736 336 L 736 341 L 735 342 L 735 362 L 732 364 L 725 372 L 724 378 L 723 379 Z",
      "position": {
        "x": 745,
        "y": 384
      },
      "badgeAnchor": {
        "x": 742.45,
        "y": 382.5
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr013",
      "name": "Outer Court Promenade",
      "regionId": "roads",
      "adjacencies": [
        "t064",
        "t074",
        "tr014",
        "tr019"
      ],
      "shape": "M 396 543 L 382 543 L 381 544 L 378 544 L 378 553 L 377 554 L 376 554 L 370 560 L 370 561 L 367 566 L 367 570 L 366 571 L 366 579 L 367 580 L 367 583 L 368 584 L 368 586 L 369 587 L 370 590 L 374 594 L 375 594 L 378 597 L 378 609 L 377 610 L 352 610 L 352 627 L 377 627 L 378 628 L 378 667 L 377 668 L 377 670 L 376 671 L 376 673 L 374 676 L 374 678 L 373 679 L 373 681 L 372 682 L 372 687 L 371 688 L 371 699 L 373 699 L 374 700 L 385 700 L 386 699 L 389 699 L 389 690 L 390 689 L 390 686 L 392 683 L 392 681 L 393 680 L 393 678 L 394 677 L 394 675 L 396 672 L 396 667 L 397 666 L 397 663 L 396 662 L 396 603 L 397 602 L 397 596 L 398 595 L 401 594 L 405 590 L 405 589 L 408 584 L 422 584 L 422 566 L 421 565 L 408 565 L 406 563 L 405 560 L 400 555 L 399 555 L 396 552 Z",
      "position": {
        "x": 388,
        "y": 575
      },
      "badgeAnchor": {
        "x": 388.09,
        "y": 574.89
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr019",
      "name": "West Wall Walk",
      "regionId": "roads",
      "adjacencies": [
        "tr013",
        "tr015",
        "tr023",
        "tr032"
      ],
      "shape": "M 389 702 L 372 702 L 372 767 L 365 773 L 365 774 L 363 776 L 362 782 L 361 783 L 361 785 L 362 786 L 362 798 L 363 799 L 363 801 L 364 803 L 372 811 L 372 893 L 371 894 L 328 894 L 328 912 L 352 912 L 353 913 L 352 915 L 347 915 L 347 958 L 364 958 L 365 957 L 365 923 L 364 922 L 364 918 L 365 917 L 365 915 L 364 913 L 365 912 L 388 912 L 389 911 L 389 810 L 391 809 L 397 803 L 400 797 L 400 781 L 399 780 L 399 778 L 397 776 L 396 773 L 389 767 Z",
      "position": {
        "x": 381,
        "y": 787
      },
      "badgeAnchor": {
        "x": 380.88,
        "y": 786
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr025",
      "name": "East Moat Bridge",
      "regionId": "roads",
      "adjacencies": [
        "t110",
        "t111",
        "t120",
        "tr012",
        "tr033"
      ],
      "shape": "M 91 1028 L 91 1040 L 95 1054 L 152 1151 L 151 1153 L 94 1153 L 94 1170 L 162 1170 L 173 1187 L 214 1258 L 241 1258 L 244 1263 L 254 1271 L 268 1271 L 274 1268 L 282 1258 L 329 1258 L 330 1257 L 330 1240 L 329 1239 L 281 1239 L 280 1236 L 271 1228 L 271 1204 L 253 1204 L 252 1228 L 246 1232 L 242 1239 L 224 1239 L 188 1179 L 166 1139 L 148 1110 L 148 1108 L 114 1052 L 109 1040 L 109 1028 Z",
      "position": {
        "x": 261,
        "y": 1249
      },
      "badgeAnchor": {
        "x": 259.05,
        "y": 1252.02
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr026",
      "name": "Dragon Way",
      "regionId": "roads",
      "adjacencies": [
        "t113",
        "t126",
        "tr021",
        "tr027"
      ],
      "shape": "M 965 1058 L 947 1058 L 947 1141 L 940 1147 L 936 1155 L 936 1168 L 937 1169 L 937 1171 L 941 1178 L 947 1183 L 947 1209 L 946 1210 L 884 1210 L 884 1228 L 897 1228 L 898 1229 L 897 1231 L 897 1281 L 915 1281 L 915 1229 L 916 1228 L 965 1228 L 965 1183 L 969 1181 L 974 1176 L 977 1170 L 1001 1170 L 1001 1158 L 1002 1157 L 1004 1158 L 1004 1170 L 1039 1170 L 1039 1153 L 977 1153 L 975 1151 L 974 1148 L 965 1140 Z",
      "position": {
        "x": 957,
        "y": 1162
      },
      "badgeAnchor": {
        "x": 956.19,
        "y": 1159.05
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr001",
      "name": "Imperial Way – Southern Spur",
      "regionId": "roads",
      "adjacencies": [
        "tr002",
        "tr012"
      ],
      "shape": "M 104 78 L 98 78 L 91 80 L 83 87 L 80 93 L 80 97 L 79 98 L 79 104 L 81 111 L 89 120 L 93 122 L 93 124 L 91 127 L 91 130 L 88 138 L 80 153 L 78 160 L 78 164 L 77 165 L 77 471 L 93 471 L 93 165 L 97 152 L 105 137 L 108 126 L 108 122 L 112 120 L 118 114 L 120 110 L 136 110 L 136 92 L 120 92 L 117 86 L 114 83 Z",
      "position": {
        "x": 100,
        "y": 101
      },
      "badgeAnchor": {
        "x": 100.05,
        "y": 96.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr003",
      "name": "Imperial Way – Central Line",
      "regionId": "roads",
      "adjacencies": [
        "t010",
        "tr004",
        "tr006"
      ],
      "shape": "M 685 92 L 685 110 L 730 110 L 732 112 L 732 113 L 735 116 L 735 117 L 737 119 L 738 119 L 740 121 L 741 121 L 742 122 L 742 126 L 758 126 L 758 122 L 759 121 L 760 121 L 762 119 L 763 119 L 766 116 L 766 115 L 768 113 L 768 112 L 770 110 L 831 110 L 831 92 L 770 92 L 768 90 L 768 89 L 767 88 L 767 87 L 761 81 L 760 81 L 759 80 L 757 80 L 756 79 L 754 79 L 753 78 L 746 78 L 745 79 L 743 79 L 742 80 L 741 80 L 740 81 L 739 81 L 733 87 L 733 88 L 731 90 L 731 91 L 730 92 Z",
      "position": {
        "x": 750,
        "y": 101
      },
      "badgeAnchor": {
        "x": 751.16,
        "y": 101.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr004",
      "name": "Inner Golden Water Bridges",
      "regionId": "roads",
      "adjacencies": [
        "t014",
        "tr003"
      ],
      "shape": "M 984 98 L 983 97 L 983 95 L 982 94 L 982 92 L 981 91 L 981 90 L 980 89 L 980 88 L 973 81 L 972 81 L 969 79 L 967 79 L 966 78 L 959 78 L 958 79 L 956 79 L 955 80 L 954 80 L 953 81 L 952 81 L 951 82 L 950 82 L 946 86 L 946 87 L 945 88 L 945 89 L 942 92 L 835 92 L 835 110 L 943 110 L 944 111 L 944 112 L 945 113 L 945 114 L 951 120 L 952 120 L 954 122 L 954 126 L 970 126 L 970 122 L 971 121 L 972 121 L 973 120 L 974 120 L 980 114 L 980 113 L 982 110 L 982 108 L 983 107 L 983 104 L 984 103 Z",
      "position": {
        "x": 962,
        "y": 101
      },
      "badgeAnchor": {
        "x": 963.05,
        "y": 101.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr006",
      "name": "Imperial Way – Northern Spur",
      "regionId": "roads",
      "adjacencies": [
        "t002",
        "t015",
        "tr002",
        "tr003"
      ],
      "shape": "M 446 110 L 463 110 L 464 111 L 467 111 L 471 114 L 472 114 L 477 119 L 478 119 L 490 131 L 491 131 L 494 134 L 500 137 L 502 137 L 503 138 L 506 138 L 507 139 L 544 139 L 547 145 L 551 149 L 555 151 L 555 159 L 571 159 L 571 151 L 578 146 L 579 143 L 582 139 L 621 139 L 622 138 L 627 137 L 633 134 L 636 131 L 637 131 L 653 115 L 656 114 L 660 111 L 663 111 L 664 110 L 680 110 L 680 96 L 681 95 L 681 93 L 680 92 L 666 92 L 665 93 L 662 93 L 661 94 L 658 94 L 657 95 L 655 95 L 651 97 L 649 99 L 648 99 L 645 102 L 644 102 L 640 106 L 640 107 L 638 108 L 632 114 L 632 115 L 630 117 L 629 117 L 627 119 L 625 119 L 619 122 L 585 122 L 584 123 L 582 123 L 580 119 L 573 112 L 572 112 L 570 110 L 570 108 L 571 107 L 571 103 L 555 103 L 555 111 L 551 113 L 547 117 L 547 118 L 543 123 L 541 123 L 540 122 L 538 122 L 537 123 L 528 123 L 527 122 L 508 122 L 507 121 L 504 121 L 500 119 L 497 116 L 496 116 L 494 114 L 494 113 L 492 111 L 491 111 L 487 106 L 486 106 L 479 99 L 478 99 L 476 97 L 472 95 L 470 95 L 469 94 L 466 94 L 465 93 L 463 93 L 462 92 L 446 92 Z",
      "position": {
        "x": 563,
        "y": 131
      },
      "badgeAnchor": {
        "x": 559.83,
        "y": 130.73
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr007",
      "name": "East Flowery Gate Road",
      "regionId": "roads",
      "adjacencies": [
        "t015",
        "t026"
      ],
      "shape": "M 553 211 L 553 247 L 574 247 L 574 211 Z",
      "position": {
        "x": 563,
        "y": 221
      },
      "badgeAnchor": {
        "x": 563.17,
        "y": 221.69
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr010",
      "name": "East Prosperity Road",
      "regionId": "roads",
      "adjacencies": [
        "t029",
        "t031",
        "t042",
        "t052",
        "t054",
        "t056"
      ],
      "shape": "M 427 400 L 332 400 L 326 392 L 325 392 L 322 389 L 318 387 L 316 387 L 315 386 L 309 386 L 308 387 L 304 388 L 298 393 L 297 393 L 293 400 L 185 400 L 185 380 L 169 380 L 169 437 L 185 437 L 185 417 L 293 417 L 298 425 L 299 425 L 302 428 L 309 432 L 316 432 L 323 427 L 324 427 L 328 423 L 331 417 L 410 417 L 411 418 L 411 432 L 427 432 Z",
      "position": {
        "x": 312,
        "y": 408
      },
      "badgeAnchor": {
        "x": 310.09,
        "y": 407.61
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr011",
      "name": "West Prosperity Road",
      "regionId": "roads",
      "adjacencies": [
        "t043",
        "t063"
      ],
      "shape": "M 555 408 L 555 435 L 553 437 L 552 437 L 548 441 L 548 442 L 547 443 L 547 444 L 546 445 L 546 446 L 545 447 L 545 449 L 544 450 L 544 459 L 545 460 L 545 462 L 546 463 L 546 464 L 547 465 L 547 466 L 553 472 L 554 472 L 555 473 L 555 488 L 556 488 L 558 486 L 559 486 L 562 483 L 564 483 L 566 485 L 567 485 L 569 487 L 570 487 L 571 488 L 571 473 L 572 472 L 573 472 L 579 466 L 579 465 L 580 464 L 580 462 L 581 461 L 581 459 L 582 458 L 582 449 L 581 448 L 581 447 L 580 446 L 580 445 L 579 444 L 579 443 L 578 442 L 578 441 L 574 437 L 573 437 L 571 435 L 571 408 Z",
      "position": {
        "x": 563,
        "y": 454
      },
      "badgeAnchor": {
        "x": 557.42,
        "y": 454.25
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr012",
      "name": "Cypress Avenue",
      "regionId": "roads",
      "adjacencies": [
        "tr001",
        "tr023",
        "tr025"
      ],
      "shape": "M 77 475 L 77 826 L 81 839 L 89 852 L 91 859 L 91 882 L 88 883 L 83 888 L 79 896 L 79 907 L 83 916 L 91 922 L 91 1024 L 107 1024 L 107 922 L 116 915 L 118 910 L 154 910 L 154 894 L 119 894 L 116 889 L 107 881 L 106 854 L 93 827 L 92 821 L 93 818 L 93 476 Z",
      "position": {
        "x": 99,
        "y": 902
      },
      "badgeAnchor": {
        "x": 99.86,
        "y": 895.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr014",
      "name": "Inner Court Promenade",
      "regionId": "roads",
      "adjacencies": [
        "t068",
        "t075",
        "t076",
        "tr013",
        "tr015",
        "tr017"
      ],
      "shape": "M 602 566 L 582 566 L 581 565 L 581 564 L 579 562 L 579 561 L 573 555 L 572 555 L 571 554 L 571 547 L 555 547 L 555 554 L 548 559 L 548 560 L 546 562 L 546 563 L 544 566 L 425 566 L 425 582 L 544 582 L 545 583 L 545 584 L 546 585 L 547 588 L 552 593 L 553 593 L 555 595 L 555 600 L 571 600 L 571 594 L 572 593 L 575 592 L 579 588 L 579 587 L 582 582 L 602 582 Z",
      "position": {
        "x": 563,
        "y": 574
      },
      "badgeAnchor": {
        "x": 560.52,
        "y": 574.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr015",
      "name": "South Wall Walk",
      "regionId": "roads",
      "adjacencies": [
        "t089",
        "tr014",
        "tr019",
        "tr020"
      ],
      "shape": "M 447 587 L 447 591 L 446 592 L 446 595 L 447 596 L 447 629 L 446 630 L 446 632 L 447 633 L 447 712 L 442 717 L 441 717 L 440 718 L 440 719 L 437 723 L 437 725 L 436 726 L 436 728 L 435 729 L 435 739 L 436 740 L 439 747 L 447 754 L 447 814 L 462 814 L 462 808 L 463 807 L 463 801 L 462 800 L 462 798 L 463 797 L 463 753 L 465 751 L 466 751 L 470 747 L 470 746 L 472 743 L 472 741 L 473 740 L 473 738 L 474 737 L 474 730 L 473 729 L 473 726 L 472 725 L 472 723 L 470 721 L 469 718 L 468 718 L 462 712 L 462 696 L 463 695 L 463 678 L 462 677 L 462 628 L 463 627 L 463 613 L 462 612 L 462 587 Z",
      "position": {
        "x": 454,
        "y": 733
      },
      "badgeAnchor": {
        "x": 453.89,
        "y": 732.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr016",
      "name": "East Wall Walk",
      "regionId": "roads",
      "adjacencies": [
        "t090",
        "tr017",
        "tr020"
      ],
      "shape": "M 664 587 L 664 713 L 658 718 L 658 719 L 655 723 L 655 725 L 654 726 L 654 729 L 653 730 L 653 736 L 654 737 L 654 741 L 655 742 L 656 745 L 658 747 L 658 748 L 664 753 L 664 813 L 665 814 L 680 814 L 680 753 L 681 752 L 684 751 L 689 745 L 689 744 L 690 743 L 690 741 L 692 738 L 692 730 L 691 729 L 691 725 L 690 724 L 688 719 L 684 715 L 683 715 L 680 713 L 680 587 Z",
      "position": {
        "x": 673,
        "y": 732
      },
      "badgeAnchor": {
        "x": 671.89,
        "y": 732.42
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr017",
      "name": "North Wall Walk",
      "regionId": "roads",
      "adjacencies": [
        "t049",
        "t069",
        "t086",
        "tr014",
        "tr016",
        "tr020"
      ],
      "shape": "M 607 566 L 607 584 L 735 585 L 735 601 L 737 609 L 755 643 L 755 646 L 744 658 L 743 673 L 748 683 L 755 688 L 755 778 L 757 779 L 773 778 L 773 688 L 781 682 L 784 676 L 802 676 L 815 674 L 827 668 L 832 663 L 848 653 L 862 648 L 972 648 L 972 593 L 953 593 L 952 630 L 859 630 L 850 632 L 838 638 L 812 656 L 804 658 L 784 658 L 782 654 L 772 645 L 771 634 L 754 603 L 753 545 L 735 545 L 734 566 Z",
      "position": {
        "x": 764,
        "y": 667
      },
      "badgeAnchor": {
        "x": 760.98,
        "y": 665.66
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr032",
      "name": "Phoenix Way",
      "regionId": "roads",
      "adjacencies": [
        "tr019",
        "tr020",
        "tr033"
      ],
      "shape": "M 355 959 L 354 960 L 347 960 L 347 1035 L 343 1039 L 342 1039 L 341 1040 L 341 1041 L 338 1044 L 338 1045 L 336 1048 L 336 1050 L 335 1051 L 335 1061 L 336 1062 L 336 1064 L 337 1065 L 338 1068 L 340 1070 L 340 1071 L 342 1073 L 343 1073 L 347 1077 L 347 1123 L 353 1123 L 354 1124 L 357 1124 L 358 1123 L 363 1123 L 363 1080 L 362 1079 L 362 1077 L 365 1074 L 366 1074 L 370 1070 L 370 1069 L 371 1068 L 371 1067 L 372 1066 L 372 1065 L 374 1062 L 374 1050 L 372 1047 L 372 1045 L 370 1043 L 370 1042 L 366 1038 L 365 1038 L 363 1036 L 363 1019 L 362 1018 L 362 1015 L 363 1014 L 363 995 L 364 994 L 378 994 L 378 978 L 364 978 L 363 977 L 363 961 L 362 960 L 359 960 L 358 959 Z",
      "position": {
        "x": 354,
        "y": 1056
      },
      "badgeAnchor": {
        "x": 354.48,
        "y": 1054.39
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr020",
      "name": "Stone Lion Approach",
      "regionId": "roads",
      "adjacencies": [
        "t099",
        "t109",
        "tr015",
        "tr016",
        "tr017",
        "tr022",
        "tr032"
      ],
      "shape": "M 771 781 L 755 781 L 755 887 L 736 888 L 735 978 L 680 977 L 680 818 L 664 818 L 663 978 L 582 978 L 578 971 L 571 966 L 571 915 L 555 915 L 555 966 L 548 971 L 544 978 L 464 978 L 462 976 L 462 818 L 447 818 L 447 977 L 383 978 L 383 994 L 544 994 L 547 1000 L 555 1006 L 555 1049 L 561 1050 L 571 1049 L 571 1006 L 578 1001 L 582 994 L 751 994 L 752 905 L 794 904 L 794 888 L 772 888 L 770 884 Z",
      "position": {
        "x": 563,
        "y": 986
      },
      "badgeAnchor": {
        "x": 569.23,
        "y": 986.95
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr021",
      "name": "Bronze Caldron Walk",
      "regionId": "roads",
      "adjacencies": [
        "t093",
        "t100",
        "tr022",
        "tr026"
      ],
      "shape": "M 947 811 L 947 876 L 940 882 L 936 888 L 887 888 L 887 904 L 936 904 L 938 906 L 940 911 L 947 917 L 947 1053 L 957 1054 L 958 1053 L 963 1053 L 963 917 L 965 915 L 968 914 L 972 910 L 975 904 L 1028 904 L 1029 905 L 1029 917 L 1044 917 L 1044 888 L 975 888 L 973 886 L 972 883 L 967 878 L 963 876 L 963 811 Z",
      "position": {
        "x": 955,
        "y": 896
      },
      "badgeAnchor": {
        "x": 956.19,
        "y": 898.33
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr022",
      "name": "Vermilion Path",
      "regionId": "roads",
      "adjacencies": [
        "t088",
        "t103",
        "tr020",
        "tr021"
      ],
      "shape": "M 837 832 L 836 833 L 832 833 L 832 876 L 830 878 L 829 878 L 824 883 L 824 884 L 822 886 L 822 887 L 821 888 L 798 888 L 798 904 L 821 904 L 822 905 L 822 906 L 823 907 L 823 908 L 824 909 L 824 910 L 826 912 L 827 912 L 829 914 L 830 914 L 832 916 L 834 916 L 835 917 L 846 917 L 847 916 L 848 916 L 849 915 L 850 915 L 851 914 L 852 914 L 856 910 L 856 909 L 858 907 L 858 905 L 859 904 L 883 904 L 883 888 L 859 888 L 858 887 L 858 886 L 857 885 L 857 884 L 855 882 L 855 881 L 854 881 L 851 878 L 850 878 L 848 876 L 848 833 L 846 833 L 845 832 Z",
      "position": {
        "x": 840,
        "y": 896
      },
      "badgeAnchor": {
        "x": 839.17,
        "y": 897.08
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr023",
      "name": "Jade Belt Path",
      "regionId": "roads",
      "adjacencies": [
        "tr012",
        "tr019"
      ],
      "shape": "M 158 894 L 158 909 L 159 910 L 223 910 L 225 912 L 225 913 L 227 915 L 227 916 L 229 918 L 230 918 L 232 920 L 233 920 L 236 922 L 238 922 L 239 923 L 246 923 L 247 922 L 249 922 L 250 921 L 252 921 L 254 919 L 255 919 L 259 915 L 259 914 L 260 913 L 260 912 L 262 910 L 323 910 L 324 909 L 324 894 L 262 894 L 261 893 L 261 892 L 259 890 L 259 889 L 253 883 L 252 883 L 249 881 L 246 881 L 245 880 L 239 880 L 238 881 L 236 881 L 235 882 L 234 882 L 233 883 L 232 883 L 226 889 L 226 890 L 224 892 L 224 893 L 223 894 Z",
      "position": {
        "x": 242,
        "y": 902
      },
      "badgeAnchor": {
        "x": 243.59,
        "y": 902.17
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr033",
      "name": "West Moat Bridge",
      "regionId": "roads",
      "adjacencies": [
        "t112",
        "t122",
        "tr025",
        "tr027",
        "tr032"
      ],
      "shape": "M 347 1127 L 347 1238 L 332 1240 L 332 1256 L 445 1256 L 458 1251 L 483 1230 L 492 1225 L 544 1225 L 548 1232 L 555 1238 L 555 1274 L 571 1274 L 571 1237 L 578 1232 L 582 1225 L 640 1225 L 672 1251 L 678 1254 L 686 1256 L 740 1256 L 740 1239 L 684 1239 L 673 1233 L 654 1216 L 643 1211 L 582 1210 L 578 1203 L 571 1198 L 571 1153 L 555 1153 L 555 1198 L 548 1203 L 544 1210 L 487 1211 L 478 1215 L 456 1234 L 447 1239 L 364 1239 L 362 1225 L 363 1131 L 360 1127 Z",
      "position": {
        "x": 563,
        "y": 1217
      },
      "badgeAnchor": {
        "x": 567.88,
        "y": 1216.58
      },
      "ownerId": "",
      "armies": 0
    },
    {
      "id": "tr027",
      "name": "Imperial Garden Walk",
      "regionId": "roads",
      "adjacencies": [
        "t107",
        "tr026",
        "tr033"
      ],
      "shape": "M 880 1210 L 836 1210 L 835 1209 L 834 1206 L 832 1204 L 832 1203 L 825 1198 L 825 1153 L 810 1153 L 809 1154 L 809 1198 L 807 1200 L 806 1200 L 801 1205 L 800 1208 L 798 1210 L 793 1210 L 792 1211 L 790 1211 L 789 1212 L 787 1212 L 784 1214 L 782 1214 L 780 1216 L 779 1216 L 775 1220 L 774 1220 L 768 1226 L 767 1226 L 758 1234 L 757 1234 L 755 1236 L 754 1236 L 749 1239 L 745 1239 L 745 1256 L 747 1256 L 748 1255 L 751 1255 L 752 1254 L 754 1254 L 757 1252 L 759 1252 L 761 1250 L 762 1250 L 766 1246 L 767 1246 L 772 1241 L 773 1241 L 778 1236 L 779 1236 L 782 1233 L 783 1233 L 786 1230 L 787 1230 L 790 1228 L 792 1228 L 793 1227 L 798 1227 L 799 1228 L 799 1229 L 800 1230 L 801 1233 L 806 1238 L 807 1238 L 809 1240 L 811 1240 L 812 1241 L 814 1241 L 815 1242 L 821 1242 L 822 1241 L 824 1241 L 825 1240 L 828 1239 L 833 1234 L 833 1233 L 834 1232 L 834 1231 L 837 1226 L 880 1226 Z",
      "position": {
        "x": 817,
        "y": 1219
      },
      "badgeAnchor": {
        "x": 818.83,
        "y": 1218.98
      },
      "ownerId": "",
      "armies": 0
    }
  ],
  "geometryVersion": "v1-0b4c3b1d-76d87956",
  "seaRoutes": [
    {
      "aId": "t001",
      "bId": "t002",
      "from": {
        "x": 603,
        "y": 51
      },
      "to": {
        "x": 603,
        "y": 56
      }
    },
    {
      "aId": "t002",
      "bId": "tr006",
      "from": {
        "x": 611,
        "y": 97
      },
      "to": {
        "x": 625,
        "y": 119
      }
    },
    {
      "aId": "t003",
      "bId": "t004",
      "from": {
        "x": 241,
        "y": 131
      },
      "to": {
        "x": 244,
        "y": 131
      }
    },
    {
      "aId": "t003",
      "bId": "t016",
      "from": {
        "x": 241,
        "y": 264
      },
      "to": {
        "x": 244,
        "y": 278
      }
    },
    {
      "aId": "t003",
      "bId": "t031",
      "from": {
        "x": 241,
        "y": 264
      },
      "to": {
        "x": 241,
        "y": 268
      }
    },
    {
      "aId": "t004",
      "bId": "t005",
      "from": {
        "x": 337,
        "y": 131
      },
      "to": {
        "x": 341,
        "y": 131
      }
    },
    {
      "aId": "t004",
      "bId": "t016",
      "from": {
        "x": 244,
        "y": 184
      },
      "to": {
        "x": 244,
        "y": 188
      }
    },
    {
      "aId": "t004",
      "bId": "t017",
      "from": {
        "x": 337,
        "y": 184
      },
      "to": {
        "x": 337,
        "y": 188
      }
    },
    {
      "aId": "t005",
      "bId": "t006",
      "from": {
        "x": 379,
        "y": 131
      },
      "to": {
        "x": 383,
        "y": 131
      }
    },
    {
      "aId": "t005",
      "bId": "t017",
      "from": {
        "x": 341,
        "y": 205
      },
      "to": {
        "x": 337,
        "y": 188
      }
    },
    {
      "aId": "t005",
      "bId": "t020",
      "from": {
        "x": 341,
        "y": 205
      },
      "to": {
        "x": 341,
        "y": 208
      }
    },
    {
      "aId": "t006",
      "bId": "t007",
      "from": {
        "x": 423,
        "y": 131
      },
      "to": {
        "x": 427,
        "y": 131
      }
    },
    {
      "aId": "t006",
      "bId": "t020",
      "from": {
        "x": 383,
        "y": 205
      },
      "to": {
        "x": 401,
        "y": 208
      }
    },
    {
      "aId": "t006",
      "bId": "t021",
      "from": {
        "x": 423,
        "y": 205
      },
      "to": {
        "x": 405,
        "y": 208
      }
    },
    {
      "aId": "t006",
      "bId": "tr002",
      "from": {
        "x": 423,
        "y": 131
      },
      "to": {
        "x": 414,
        "y": 128
      }
    },
    {
      "aId": "t007",
      "bId": "t021",
      "from": {
        "x": 464,
        "y": 205
      },
      "to": {
        "x": 464,
        "y": 208
      }
    },
    {
      "aId": "t008",
      "bId": "t009",
      "from": {
        "x": 686,
        "y": 131
      },
      "to": {
        "x": 691,
        "y": 131
      }
    },
    {
      "aId": "t008",
      "bId": "t010",
      "from": {
        "x": 731,
        "y": 188
      },
      "to": {
        "x": 728,
        "y": 184
      }
    },
    {
      "aId": "t008",
      "bId": "t018",
      "from": {
        "x": 731,
        "y": 188
      },
      "to": {
        "x": 736,
        "y": 188
      }
    },
    {
      "aId": "t008",
      "bId": "t023",
      "from": {
        "x": 655,
        "y": 237
      },
      "to": {
        "x": 655,
        "y": 241
      }
    },
    {
      "aId": "t009",
      "bId": "t010",
      "from": {
        "x": 724,
        "y": 131
      },
      "to": {
        "x": 728,
        "y": 131
      }
    },
    {
      "aId": "t010",
      "bId": "t011",
      "from": {
        "x": 776,
        "y": 184
      },
      "to": {
        "x": 773,
        "y": 188
      }
    },
    {
      "aId": "t010",
      "bId": "t012",
      "from": {
        "x": 776,
        "y": 131
      },
      "to": {
        "x": 780,
        "y": 131
      }
    },
    {
      "aId": "t010",
      "bId": "t018",
      "from": {
        "x": 776,
        "y": 184
      },
      "to": {
        "x": 769,
        "y": 188
      }
    },
    {
      "aId": "t010",
      "bId": "tr003",
      "from": {
        "x": 728,
        "y": 131
      },
      "to": {
        "x": 742,
        "y": 126
      }
    },
    {
      "aId": "t011",
      "bId": "t012",
      "from": {
        "x": 817,
        "y": 131
      },
      "to": {
        "x": 814,
        "y": 131
      }
    },
    {
      "aId": "t011",
      "bId": "t018",
      "from": {
        "x": 773,
        "y": 188
      },
      "to": {
        "x": 769,
        "y": 188
      }
    },
    {
      "aId": "t011",
      "bId": "t024",
      "from": {
        "x": 773,
        "y": 237
      },
      "to": {
        "x": 772,
        "y": 241
      }
    },
    {
      "aId": "t013a",
      "bId": "t013b",
      "from": {
        "x": 958,
        "y": 183
      },
      "to": {
        "x": 963,
        "y": 183
      }
    },
    {
      "aId": "t013a",
      "bId": "t014",
      "from": {
        "x": 923,
        "y": 167
      },
      "to": {
        "x": 927,
        "y": 164
      }
    },
    {
      "aId": "t013a",
      "bId": "t019",
      "from": {
        "x": 922,
        "y": 185
      },
      "to": {
        "x": 927,
        "y": 188
      }
    },
    {
      "aId": "t013a",
      "bId": "t022a",
      "from": {
        "x": 922,
        "y": 206
      },
      "to": {
        "x": 922,
        "y": 210
      }
    },
    {
      "aId": "t013b",
      "bId": "t014",
      "from": {
        "x": 1004,
        "y": 131
      },
      "to": {
        "x": 1000,
        "y": 131
      }
    },
    {
      "aId": "t013b",
      "bId": "t019",
      "from": {
        "x": 1004,
        "y": 185
      },
      "to": {
        "x": 1000,
        "y": 188
      }
    },
    {
      "aId": "t013b",
      "bId": "t022b",
      "from": {
        "x": 1004,
        "y": 206
      },
      "to": {
        "x": 1004,
        "y": 210
      }
    },
    {
      "aId": "t014",
      "bId": "tr004",
      "from": {
        "x": 927,
        "y": 131
      },
      "to": {
        "x": 945,
        "y": 114
      }
    },
    {
      "aId": "t015",
      "bId": "tr006",
      "from": {
        "x": 531,
        "y": 164
      },
      "to": {
        "x": 555,
        "y": 159
      }
    },
    {
      "aId": "t015",
      "bId": "tr007",
      "from": {
        "x": 531,
        "y": 207
      },
      "to": {
        "x": 553,
        "y": 211
      }
    },
    {
      "aId": "t016",
      "bId": "t017",
      "from": {
        "x": 298,
        "y": 188
      },
      "to": {
        "x": 302,
        "y": 188
      }
    },
    {
      "aId": "t016",
      "bId": "t029",
      "from": {
        "x": 298,
        "y": 278
      },
      "to": {
        "x": 302,
        "y": 265
      }
    },
    {
      "aId": "t016",
      "bId": "t031",
      "from": {
        "x": 244,
        "y": 278
      },
      "to": {
        "x": 241,
        "y": 268
      }
    },
    {
      "aId": "t016",
      "bId": "t035",
      "from": {
        "x": 298,
        "y": 278
      },
      "to": {
        "x": 298,
        "y": 282
      }
    },
    {
      "aId": "t017",
      "bId": "t020",
      "from": {
        "x": 337,
        "y": 262
      },
      "to": {
        "x": 341,
        "y": 262
      }
    },
    {
      "aId": "t017",
      "bId": "t029",
      "from": {
        "x": 337,
        "y": 262
      },
      "to": {
        "x": 337,
        "y": 265
      }
    },
    {
      "aId": "t017",
      "bId": "t030",
      "from": {
        "x": 337,
        "y": 262
      },
      "to": {
        "x": 341,
        "y": 265
      }
    },
    {
      "aId": "t018",
      "bId": "t023",
      "from": {
        "x": 736,
        "y": 274
      },
      "to": {
        "x": 732,
        "y": 288
      }
    },
    {
      "aId": "t018",
      "bId": "t024",
      "from": {
        "x": 769,
        "y": 274
      },
      "to": {
        "x": 772,
        "y": 288
      }
    },
    {
      "aId": "t018",
      "bId": "t032",
      "from": {
        "x": 769,
        "y": 274
      },
      "to": {
        "x": 769,
        "y": 277
      }
    },
    {
      "aId": "t019",
      "bId": "t022a",
      "from": {
        "x": 927,
        "y": 230
      },
      "to": {
        "x": 923,
        "y": 233
      }
    },
    {
      "aId": "t019",
      "bId": "t022b",
      "from": {
        "x": 1000,
        "y": 230
      },
      "to": {
        "x": 1003,
        "y": 233
      }
    },
    {
      "aId": "t020",
      "bId": "t021",
      "from": {
        "x": 401,
        "y": 208
      },
      "to": {
        "x": 405,
        "y": 208
      }
    },
    {
      "aId": "t020",
      "bId": "t029",
      "from": {
        "x": 341,
        "y": 262
      },
      "to": {
        "x": 337,
        "y": 265
      }
    },
    {
      "aId": "t020",
      "bId": "t030",
      "from": {
        "x": 401,
        "y": 262
      },
      "to": {
        "x": 401,
        "y": 265
      }
    },
    {
      "aId": "t021",
      "bId": "t030",
      "from": {
        "x": 405,
        "y": 334
      },
      "to": {
        "x": 401,
        "y": 380
      }
    },
    {
      "aId": "t021",
      "bId": "t042",
      "from": {
        "x": 464,
        "y": 334
      },
      "to": {
        "x": 464,
        "y": 337
      }
    },
    {
      "aId": "t022a",
      "bId": "t022b",
      "from": {
        "x": 958,
        "y": 251
      },
      "to": {
        "x": 964,
        "y": 251
      }
    },
    {
      "aId": "t022a",
      "bId": "t028",
      "from": {
        "x": 922,
        "y": 252
      },
      "to": {
        "x": 927,
        "y": 256
      }
    },
    {
      "aId": "t022a",
      "bId": "t033",
      "from": {
        "x": 884,
        "y": 274
      },
      "to": {
        "x": 883,
        "y": 279
      }
    },
    {
      "aId": "t022b",
      "bId": "t028",
      "from": {
        "x": 1004,
        "y": 252
      },
      "to": {
        "x": 1000,
        "y": 256
      }
    },
    {
      "aId": "t022b",
      "bId": "t034",
      "from": {
        "x": 1004,
        "y": 274
      },
      "to": {
        "x": 1004,
        "y": 279
      }
    },
    {
      "aId": "t023",
      "bId": "t032",
      "from": {
        "x": 732,
        "y": 288
      },
      "to": {
        "x": 736,
        "y": 277
      }
    },
    {
      "aId": "t023",
      "bId": "t036",
      "from": {
        "x": 732,
        "y": 288
      },
      "to": {
        "x": 732,
        "y": 291
      }
    },
    {
      "aId": "t024",
      "bId": "t032",
      "from": {
        "x": 772,
        "y": 288
      },
      "to": {
        "x": 769,
        "y": 277
      }
    },
    {
      "aId": "t024",
      "bId": "t037",
      "from": {
        "x": 851,
        "y": 288
      },
      "to": {
        "x": 851,
        "y": 291
      }
    },
    {
      "aId": "t025",
      "bId": "t026",
      "from": {
        "x": 533,
        "y": 252
      },
      "to": {
        "x": 537,
        "y": 252
      }
    },
    {
      "aId": "t025",
      "bId": "t027",
      "from": {
        "x": 561,
        "y": 302
      },
      "to": {
        "x": 565,
        "y": 302
      }
    },
    {
      "aId": "t025",
      "bId": "t038",
      "from": {
        "x": 533,
        "y": 303
      },
      "to": {
        "x": 537,
        "y": 306
      }
    },
    {
      "aId": "t025",
      "bId": "t040",
      "from": {
        "x": 491,
        "y": 323
      },
      "to": {
        "x": 491,
        "y": 328
      }
    },
    {
      "aId": "t026",
      "bId": "t027",
      "from": {
        "x": 589,
        "y": 252
      },
      "to": {
        "x": 593,
        "y": 252
      }
    },
    {
      "aId": "t026",
      "bId": "tr007",
      "from": {
        "x": 589,
        "y": 252
      },
      "to": {
        "x": 574,
        "y": 247
      }
    },
    {
      "aId": "t027",
      "bId": "t038",
      "from": {
        "x": 592,
        "y": 302
      },
      "to": {
        "x": 589,
        "y": 306
      }
    },
    {
      "aId": "t027",
      "bId": "t041",
      "from": {
        "x": 635,
        "y": 323
      },
      "to": {
        "x": 634,
        "y": 327
      }
    },
    {
      "aId": "t028",
      "bId": "t033",
      "from": {
        "x": 927,
        "y": 337
      },
      "to": {
        "x": 923,
        "y": 337
      }
    },
    {
      "aId": "t028",
      "bId": "t034",
      "from": {
        "x": 1000,
        "y": 337
      },
      "to": {
        "x": 1004,
        "y": 337
      }
    },
    {
      "aId": "t028",
      "bId": "tr008",
      "from": {
        "x": 927,
        "y": 337
      },
      "to": {
        "x": 950,
        "y": 348
      }
    },
    {
      "aId": "t029",
      "bId": "t030",
      "from": {
        "x": 337,
        "y": 265
      },
      "to": {
        "x": 341,
        "y": 265
      }
    },
    {
      "aId": "t029",
      "bId": "t035",
      "from": {
        "x": 302,
        "y": 265
      },
      "to": {
        "x": 298,
        "y": 282
      }
    },
    {
      "aId": "t029",
      "bId": "t039",
      "from": {
        "x": 302,
        "y": 380
      },
      "to": {
        "x": 298,
        "y": 380
      }
    },
    {
      "aId": "t029",
      "bId": "tr010",
      "from": {
        "x": 302,
        "y": 380
      },
      "to": {
        "x": 304,
        "y": 388
      }
    },
    {
      "aId": "t030",
      "bId": "t042",
      "from": {
        "x": 401,
        "y": 380
      },
      "to": {
        "x": 405,
        "y": 380
      }
    },
    {
      "aId": "t031",
      "bId": "t035",
      "from": {
        "x": 241,
        "y": 268
      },
      "to": {
        "x": 244,
        "y": 282
      }
    },
    {
      "aId": "t031",
      "bId": "t039",
      "from": {
        "x": 241,
        "y": 380
      },
      "to": {
        "x": 244,
        "y": 380
      }
    },
    {
      "aId": "t031",
      "bId": "tr010",
      "from": {
        "x": 152,
        "y": 380
      },
      "to": {
        "x": 169,
        "y": 380
      }
    },
    {
      "aId": "t032",
      "bId": "t036",
      "from": {
        "x": 736,
        "y": 332
      },
      "to": {
        "x": 732,
        "y": 332
      }
    },
    {
      "aId": "t032",
      "bId": "t037",
      "from": {
        "x": 769,
        "y": 332
      },
      "to": {
        "x": 772,
        "y": 332
      }
    },
    {
      "aId": "t032",
      "bId": "tr008",
      "from": {
        "x": 736,
        "y": 332
      },
      "to": {
        "x": 736,
        "y": 336
      }
    },
    {
      "aId": "t035",
      "bId": "t039",
      "from": {
        "x": 298,
        "y": 324
      },
      "to": {
        "x": 298,
        "y": 327
      }
    },
    {
      "aId": "t036",
      "bId": "tr008",
      "from": {
        "x": 732,
        "y": 332
      },
      "to": {
        "x": 736,
        "y": 336
      }
    },
    {
      "aId": "t038",
      "bId": "t040",
      "from": {
        "x": 537,
        "y": 346
      },
      "to": {
        "x": 537,
        "y": 349
      }
    },
    {
      "aId": "t038",
      "bId": "t041",
      "from": {
        "x": 589,
        "y": 346
      },
      "to": {
        "x": 592,
        "y": 349
      }
    },
    {
      "aId": "t040",
      "bId": "t041",
      "from": {
        "x": 561,
        "y": 369
      },
      "to": {
        "x": 565,
        "y": 369
      }
    },
    {
      "aId": "t040",
      "bId": "t043",
      "from": {
        "x": 533,
        "y": 370
      },
      "to": {
        "x": 537,
        "y": 374
      }
    },
    {
      "aId": "t041",
      "bId": "t043",
      "from": {
        "x": 593,
        "y": 370
      },
      "to": {
        "x": 589,
        "y": 374
      }
    },
    {
      "aId": "t042",
      "bId": "tr010",
      "from": {
        "x": 405,
        "y": 380
      },
      "to": {
        "x": 427,
        "y": 400
      }
    },
    {
      "aId": "t043",
      "bId": "tr011",
      "from": {
        "x": 589,
        "y": 404
      },
      "to": {
        "x": 571,
        "y": 408
      }
    },
    {
      "aId": "t044",
      "bId": "t045",
      "from": {
        "x": 910,
        "y": 374
      },
      "to": {
        "x": 913,
        "y": 375
      }
    },
    {
      "aId": "t044",
      "bId": "t058",
      "from": {
        "x": 910,
        "y": 482
      },
      "to": {
        "x": 935,
        "y": 475
      }
    },
    {
      "aId": "t044",
      "bId": "t061",
      "from": {
        "x": 910,
        "y": 482
      },
      "to": {
        "x": 910,
        "y": 486
      }
    },
    {
      "aId": "t045",
      "bId": "t046",
      "from": {
        "x": 1008,
        "y": 374
      },
      "to": {
        "x": 1013,
        "y": 374
      }
    },
    {
      "aId": "t045",
      "bId": "t047",
      "from": {
        "x": 934,
        "y": 416
      },
      "to": {
        "x": 939,
        "y": 419
      }
    },
    {
      "aId": "t045",
      "bId": "t058",
      "from": {
        "x": 934,
        "y": 443
      },
      "to": {
        "x": 934,
        "y": 448
      }
    },
    {
      "aId": "t045",
      "bId": "tr008",
      "from": {
        "x": 1008,
        "y": 374
      },
      "to": {
        "x": 972,
        "y": 371
      }
    },
    {
      "aId": "t046",
      "bId": "t058",
      "from": {
        "x": 1013,
        "y": 482
      },
      "to": {
        "x": 987,
        "y": 475
      }
    },
    {
      "aId": "t046",
      "bId": "t062",
      "from": {
        "x": 1038,
        "y": 482
      },
      "to": {
        "x": 1038,
        "y": 486
      }
    },
    {
      "aId": "t047",
      "bId": "t058",
      "from": {
        "x": 984,
        "y": 472
      },
      "to": {
        "x": 987,
        "y": 475
      }
    },
    {
      "aId": "t048",
      "bId": "t049",
      "from": {
        "x": 718,
        "y": 435
      },
      "to": {
        "x": 722,
        "y": 435
      }
    },
    {
      "aId": "t049",
      "bId": "t050",
      "from": {
        "x": 762,
        "y": 435
      },
      "to": {
        "x": 766,
        "y": 435
      }
    },
    {
      "aId": "t049",
      "bId": "t072",
      "from": {
        "x": 762,
        "y": 541
      },
      "to": {
        "x": 766,
        "y": 544
      }
    },
    {
      "aId": "t049",
      "bId": "tr008",
      "from": {
        "x": 762,
        "y": 435
      },
      "to": {
        "x": 753,
        "y": 432
      }
    },
    {
      "aId": "t049",
      "bId": "tr017",
      "from": {
        "x": 762,
        "y": 541
      },
      "to": {
        "x": 753,
        "y": 545
      }
    },
    {
      "aId": "t050",
      "bId": "t051",
      "from": {
        "x": 805,
        "y": 435
      },
      "to": {
        "x": 809,
        "y": 435
      }
    },
    {
      "aId": "t050",
      "bId": "t072",
      "from": {
        "x": 766,
        "y": 540
      },
      "to": {
        "x": 766,
        "y": 544
      }
    },
    {
      "aId": "t052",
      "bId": "t053",
      "from": {
        "x": 202,
        "y": 437
      },
      "to": {
        "x": 206,
        "y": 437
      }
    },
    {
      "aId": "t052",
      "bId": "t070",
      "from": {
        "x": 202,
        "y": 552
      },
      "to": {
        "x": 206,
        "y": 535
      }
    },
    {
      "aId": "t052",
      "bId": "t073",
      "from": {
        "x": 152,
        "y": 552
      },
      "to": {
        "x": 152,
        "y": 556
      }
    },
    {
      "aId": "t052",
      "bId": "tr010",
      "from": {
        "x": 152,
        "y": 437
      },
      "to": {
        "x": 169,
        "y": 437
      }
    },
    {
      "aId": "t053",
      "bId": "t054",
      "from": {
        "x": 277,
        "y": 513
      },
      "to": {
        "x": 282,
        "y": 513
      }
    },
    {
      "aId": "t053",
      "bId": "t059",
      "from": {
        "x": 244,
        "y": 497
      },
      "to": {
        "x": 249,
        "y": 495
      }
    },
    {
      "aId": "t053",
      "bId": "t067",
      "from": {
        "x": 244,
        "y": 515
      },
      "to": {
        "x": 249,
        "y": 518
      }
    },
    {
      "aId": "t053",
      "bId": "t070",
      "from": {
        "x": 206,
        "y": 530
      },
      "to": {
        "x": 206,
        "y": 535
      }
    },
    {
      "aId": "t054",
      "bId": "t059",
      "from": {
        "x": 315,
        "y": 497
      },
      "to": {
        "x": 311,
        "y": 495
      }
    },
    {
      "aId": "t054",
      "bId": "t067",
      "from": {
        "x": 315,
        "y": 515
      },
      "to": {
        "x": 311,
        "y": 518
      }
    },
    {
      "aId": "t054",
      "bId": "t071",
      "from": {
        "x": 315,
        "y": 530
      },
      "to": {
        "x": 315,
        "y": 535
      }
    },
    {
      "aId": "t054",
      "bId": "tr010",
      "from": {
        "x": 282,
        "y": 437
      },
      "to": {
        "x": 298,
        "y": 425
      }
    },
    {
      "aId": "t055",
      "bId": "t056",
      "from": {
        "x": 401,
        "y": 437
      },
      "to": {
        "x": 405,
        "y": 437
      }
    },
    {
      "aId": "t055",
      "bId": "t060",
      "from": {
        "x": 373,
        "y": 469
      },
      "to": {
        "x": 373,
        "y": 473
      }
    },
    {
      "aId": "t056",
      "bId": "t057",
      "from": {
        "x": 434,
        "y": 437
      },
      "to": {
        "x": 438,
        "y": 438
      }
    },
    {
      "aId": "t056",
      "bId": "t060",
      "from": {
        "x": 434,
        "y": 469
      },
      "to": {
        "x": 464,
        "y": 473
      }
    },
    {
      "aId": "t056",
      "bId": "tr010",
      "from": {
        "x": 405,
        "y": 437
      },
      "to": {
        "x": 411,
        "y": 432
      }
    },
    {
      "aId": "t057",
      "bId": "t060",
      "from": {
        "x": 463,
        "y": 468
      },
      "to": {
        "x": 464,
        "y": 473
      }
    },
    {
      "aId": "t058",
      "bId": "t061",
      "from": {
        "x": 935,
        "y": 475
      },
      "to": {
        "x": 910,
        "y": 486
      }
    },
    {
      "aId": "t058",
      "bId": "t062",
      "from": {
        "x": 987,
        "y": 475
      },
      "to": {
        "x": 1013,
        "y": 486
      }
    },
    {
      "aId": "t058",
      "bId": "t069",
      "from": {
        "x": 914,
        "y": 528
      },
      "to": {
        "x": 913,
        "y": 533
      }
    },
    {
      "aId": "t060",
      "bId": "t064",
      "from": {
        "x": 373,
        "y": 505
      },
      "to": {
        "x": 373,
        "y": 509
      }
    },
    {
      "aId": "t060",
      "bId": "t065",
      "from": {
        "x": 464,
        "y": 505
      },
      "to": {
        "x": 433,
        "y": 509
      }
    },
    {
      "aId": "t060",
      "bId": "t066",
      "from": {
        "x": 464,
        "y": 505
      },
      "to": {
        "x": 463,
        "y": 509
      }
    },
    {
      "aId": "t061",
      "bId": "t069",
      "from": {
        "x": 910,
        "y": 589
      },
      "to": {
        "x": 913,
        "y": 589
      }
    },
    {
      "aId": "t062",
      "bId": "t069",
      "from": {
        "x": 1013,
        "y": 589
      },
      "to": {
        "x": 1009,
        "y": 589
      }
    },
    {
      "aId": "t063",
      "bId": "t068",
      "from": {
        "x": 536,
        "y": 515
      },
      "to": {
        "x": 538,
        "y": 520
      }
    },
    {
      "aId": "t063",
      "bId": "tr011",
      "from": {
        "x": 562,
        "y": 490
      },
      "to": {
        "x": 559,
        "y": 486
      }
    },
    {
      "aId": "t064",
      "bId": "t065",
      "from": {
        "x": 400,
        "y": 539
      },
      "to": {
        "x": 405,
        "y": 539
      }
    },
    {
      "aId": "t064",
      "bId": "tr013",
      "from": {
        "x": 395,
        "y": 540
      },
      "to": {
        "x": 396,
        "y": 543
      }
    },
    {
      "aId": "t065",
      "bId": "t066",
      "from": {
        "x": 433,
        "y": 539
      },
      "to": {
        "x": 438,
        "y": 539
      }
    },
    {
      "aId": "t067",
      "bId": "t070",
      "from": {
        "x": 249,
        "y": 549
      },
      "to": {
        "x": 245,
        "y": 552
      }
    },
    {
      "aId": "t067",
      "bId": "t071",
      "from": {
        "x": 311,
        "y": 549
      },
      "to": {
        "x": 314,
        "y": 552
      }
    },
    {
      "aId": "t068",
      "bId": "tr014",
      "from": {
        "x": 533,
        "y": 542
      },
      "to": {
        "x": 555,
        "y": 547
      }
    },
    {
      "aId": "t069",
      "bId": "tr017",
      "from": {
        "x": 1009,
        "y": 589
      },
      "to": {
        "x": 972,
        "y": 593
      }
    },
    {
      "aId": "t070",
      "bId": "t071",
      "from": {
        "x": 277,
        "y": 595
      },
      "to": {
        "x": 282,
        "y": 595
      }
    },
    {
      "aId": "t070",
      "bId": "t073",
      "from": {
        "x": 206,
        "y": 595
      },
      "to": {
        "x": 202,
        "y": 600
      }
    },
    {
      "aId": "t070",
      "bId": "t074",
      "from": {
        "x": 206,
        "y": 595
      },
      "to": {
        "x": 223,
        "y": 600
      }
    },
    {
      "aId": "t071",
      "bId": "t074",
      "from": {
        "x": 347,
        "y": 595
      },
      "to": {
        "x": 349,
        "y": 600
      }
    },
    {
      "aId": "t073",
      "bId": "t074",
      "from": {
        "x": 218,
        "y": 600
      },
      "to": {
        "x": 223,
        "y": 600
      }
    },
    {
      "aId": "t073",
      "bId": "t079",
      "from": {
        "x": 152,
        "y": 630
      },
      "to": {
        "x": 152,
        "y": 635
      }
    },
    {
      "aId": "t073",
      "bId": "t080",
      "from": {
        "x": 218,
        "y": 630
      },
      "to": {
        "x": 186,
        "y": 635
      }
    },
    {
      "aId": "t074",
      "bId": "t079",
      "from": {
        "x": 223,
        "y": 631
      },
      "to": {
        "x": 259,
        "y": 635
      }
    },
    {
      "aId": "t074",
      "bId": "t080",
      "from": {
        "x": 223,
        "y": 631
      },
      "to": {
        "x": 255,
        "y": 635
      }
    },
    {
      "aId": "t074",
      "bId": "t081",
      "from": {
        "x": 349,
        "y": 631
      },
      "to": {
        "x": 349,
        "y": 635
      }
    },
    {
      "aId": "t074",
      "bId": "tr013",
      "from": {
        "x": 349,
        "y": 631
      },
      "to": {
        "x": 352,
        "y": 627
      }
    },
    {
      "aId": "t075",
      "bId": "t076",
      "from": {
        "x": 561,
        "y": 726
      },
      "to": {
        "x": 565,
        "y": 726
      }
    },
    {
      "aId": "t075",
      "bId": "t077",
      "from": {
        "x": 498,
        "y": 623
      },
      "to": {
        "x": 503,
        "y": 624
      }
    },
    {
      "aId": "t075",
      "bId": "t078",
      "from": {
        "x": 561,
        "y": 619
      },
      "to": {
        "x": 566,
        "y": 624
      }
    },
    {
      "aId": "t075",
      "bId": "t083",
      "from": {
        "x": 561,
        "y": 693
      },
      "to": {
        "x": 561,
        "y": 688
      }
    },
    {
      "aId": "t075",
      "bId": "t084",
      "from": {
        "x": 561,
        "y": 693
      },
      "to": {
        "x": 565,
        "y": 688
      }
    },
    {
      "aId": "t075",
      "bId": "t089",
      "from": {
        "x": 523,
        "y": 726
      },
      "to": {
        "x": 523,
        "y": 731
      }
    },
    {
      "aId": "t075",
      "bId": "t090",
      "from": {
        "x": 561,
        "y": 726
      },
      "to": {
        "x": 565,
        "y": 731
      }
    },
    {
      "aId": "t075",
      "bId": "tr014",
      "from": {
        "x": 561,
        "y": 606
      },
      "to": {
        "x": 555,
        "y": 600
      }
    },
    {
      "aId": "t076",
      "bId": "t077",
      "from": {
        "x": 565,
        "y": 619
      },
      "to": {
        "x": 560,
        "y": 624
      }
    },
    {
      "aId": "t076",
      "bId": "t078",
      "from": {
        "x": 565,
        "y": 619
      },
      "to": {
        "x": 566,
        "y": 624
      }
    },
    {
      "aId": "t076",
      "bId": "t083",
      "from": {
        "x": 565,
        "y": 693
      },
      "to": {
        "x": 561,
        "y": 688
      }
    },
    {
      "aId": "t076",
      "bId": "t084",
      "from": {
        "x": 565,
        "y": 693
      },
      "to": {
        "x": 565,
        "y": 688
      }
    },
    {
      "aId": "t076",
      "bId": "t089",
      "from": {
        "x": 565,
        "y": 726
      },
      "to": {
        "x": 561,
        "y": 731
      }
    },
    {
      "aId": "t076",
      "bId": "t090",
      "from": {
        "x": 565,
        "y": 726
      },
      "to": {
        "x": 565,
        "y": 731
      }
    },
    {
      "aId": "t076",
      "bId": "tr014",
      "from": {
        "x": 565,
        "y": 605
      },
      "to": {
        "x": 571,
        "y": 600
      }
    },
    {
      "aId": "t077",
      "bId": "t078",
      "from": {
        "x": 561,
        "y": 639
      },
      "to": {
        "x": 565,
        "y": 639
      }
    },
    {
      "aId": "t077",
      "bId": "t082",
      "from": {
        "x": 543,
        "y": 640
      },
      "to": {
        "x": 547,
        "y": 644
      }
    },
    {
      "aId": "t077",
      "bId": "t083",
      "from": {
        "x": 503,
        "y": 654
      },
      "to": {
        "x": 503,
        "y": 659
      }
    },
    {
      "aId": "t078",
      "bId": "t082",
      "from": {
        "x": 583,
        "y": 640
      },
      "to": {
        "x": 579,
        "y": 644
      }
    },
    {
      "aId": "t078",
      "bId": "t084",
      "from": {
        "x": 583,
        "y": 654
      },
      "to": {
        "x": 583,
        "y": 659
      }
    },
    {
      "aId": "t079",
      "bId": "t080",
      "from": {
        "x": 259,
        "y": 635
      },
      "to": {
        "x": 255,
        "y": 635
      }
    },
    {
      "aId": "t079",
      "bId": "t081",
      "from": {
        "x": 292,
        "y": 635
      },
      "to": {
        "x": 297,
        "y": 635
      }
    },
    {
      "aId": "t082",
      "bId": "t083",
      "from": {
        "x": 547,
        "y": 670
      },
      "to": {
        "x": 544,
        "y": 673
      }
    },
    {
      "aId": "t082",
      "bId": "t084",
      "from": {
        "x": 579,
        "y": 670
      },
      "to": {
        "x": 582,
        "y": 673
      }
    },
    {
      "aId": "t083",
      "bId": "t084",
      "from": {
        "x": 561,
        "y": 688
      },
      "to": {
        "x": 565,
        "y": 688
      }
    },
    {
      "aId": "t085",
      "bId": "t087",
      "from": {
        "x": 921,
        "y": 779
      },
      "to": {
        "x": 924,
        "y": 779
      }
    },
    {
      "aId": "t085",
      "bId": "t093",
      "from": {
        "x": 880,
        "y": 779
      },
      "to": {
        "x": 880,
        "y": 782
      }
    },
    {
      "aId": "t086",
      "bId": "t087",
      "from": {
        "x": 969,
        "y": 779
      },
      "to": {
        "x": 965,
        "y": 779
      }
    },
    {
      "aId": "t086",
      "bId": "t093",
      "from": {
        "x": 1010,
        "y": 779
      },
      "to": {
        "x": 1010,
        "y": 782
      }
    },
    {
      "aId": "t086",
      "bId": "tr017",
      "from": {
        "x": 969,
        "y": 665
      },
      "to": {
        "x": 972,
        "y": 648
      }
    },
    {
      "aId": "t087",
      "bId": "t093",
      "from": {
        "x": 924,
        "y": 779
      },
      "to": {
        "x": 880,
        "y": 782
      }
    },
    {
      "aId": "t088",
      "bId": "tr022",
      "from": {
        "x": 819,
        "y": 829
      },
      "to": {
        "x": 832,
        "y": 833
      }
    },
    {
      "aId": "t089",
      "bId": "t090",
      "from": {
        "x": 561,
        "y": 731
      },
      "to": {
        "x": 565,
        "y": 731
      }
    },
    {
      "aId": "t089",
      "bId": "t091",
      "from": {
        "x": 499,
        "y": 811
      },
      "to": {
        "x": 503,
        "y": 811
      }
    },
    {
      "aId": "t089",
      "bId": "t092",
      "from": {
        "x": 561,
        "y": 776
      },
      "to": {
        "x": 565,
        "y": 781
      }
    },
    {
      "aId": "t089",
      "bId": "t095",
      "from": {
        "x": 479,
        "y": 812
      },
      "to": {
        "x": 479,
        "y": 816
      }
    },
    {
      "aId": "t089",
      "bId": "t096",
      "from": {
        "x": 499,
        "y": 811
      },
      "to": {
        "x": 504,
        "y": 816
      }
    },
    {
      "aId": "t089",
      "bId": "tr015",
      "from": {
        "x": 479,
        "y": 752
      },
      "to": {
        "x": 470,
        "y": 747
      }
    },
    {
      "aId": "t090",
      "bId": "t091",
      "from": {
        "x": 565,
        "y": 776
      },
      "to": {
        "x": 561,
        "y": 781
      }
    },
    {
      "aId": "t090",
      "bId": "t092",
      "from": {
        "x": 627,
        "y": 781
      },
      "to": {
        "x": 623,
        "y": 781
      }
    },
    {
      "aId": "t090",
      "bId": "t097",
      "from": {
        "x": 628,
        "y": 812
      },
      "to": {
        "x": 623,
        "y": 816
      }
    },
    {
      "aId": "t090",
      "bId": "t098",
      "from": {
        "x": 628,
        "y": 812
      },
      "to": {
        "x": 628,
        "y": 816
      }
    },
    {
      "aId": "t090",
      "bId": "tr016",
      "from": {
        "x": 648,
        "y": 752
      },
      "to": {
        "x": 656,
        "y": 745
      }
    },
    {
      "aId": "t091",
      "bId": "t092",
      "from": {
        "x": 561,
        "y": 797
      },
      "to": {
        "x": 565,
        "y": 797
      }
    },
    {
      "aId": "t091",
      "bId": "t094",
      "from": {
        "x": 543,
        "y": 798
      },
      "to": {
        "x": 547,
        "y": 802
      }
    },
    {
      "aId": "t091",
      "bId": "t095",
      "from": {
        "x": 504,
        "y": 812
      },
      "to": {
        "x": 499,
        "y": 817
      }
    },
    {
      "aId": "t091",
      "bId": "t096",
      "from": {
        "x": 504,
        "y": 812
      },
      "to": {
        "x": 504,
        "y": 816
      }
    },
    {
      "aId": "t092",
      "bId": "t094",
      "from": {
        "x": 565,
        "y": 797
      },
      "to": {
        "x": 566,
        "y": 801
      }
    },
    {
      "aId": "t092",
      "bId": "t097",
      "from": {
        "x": 583,
        "y": 812
      },
      "to": {
        "x": 583,
        "y": 816
      }
    },
    {
      "aId": "t092",
      "bId": "t098",
      "from": {
        "x": 623,
        "y": 812
      },
      "to": {
        "x": 628,
        "y": 816
      }
    },
    {
      "aId": "t093",
      "bId": "tr021",
      "from": {
        "x": 1010,
        "y": 807
      },
      "to": {
        "x": 963,
        "y": 811
      }
    },
    {
      "aId": "t094",
      "bId": "t096",
      "from": {
        "x": 547,
        "y": 826
      },
      "to": {
        "x": 543,
        "y": 830
      }
    },
    {
      "aId": "t094",
      "bId": "t097",
      "from": {
        "x": 578,
        "y": 827
      },
      "to": {
        "x": 582,
        "y": 831
      }
    },
    {
      "aId": "t095",
      "bId": "t096",
      "from": {
        "x": 499,
        "y": 817
      },
      "to": {
        "x": 503,
        "y": 817
      }
    },
    {
      "aId": "t095",
      "bId": "t097",
      "from": {
        "x": 561,
        "y": 851
      },
      "to": {
        "x": 565,
        "y": 846
      }
    },
    {
      "aId": "t095",
      "bId": "t098",
      "from": {
        "x": 561,
        "y": 877
      },
      "to": {
        "x": 565,
        "y": 877
      }
    },
    {
      "aId": "t095",
      "bId": "t099",
      "from": {
        "x": 533,
        "y": 910
      },
      "to": {
        "x": 539,
        "y": 911
      }
    },
    {
      "aId": "t096",
      "bId": "t097",
      "from": {
        "x": 561,
        "y": 846
      },
      "to": {
        "x": 565,
        "y": 846
      }
    },
    {
      "aId": "t096",
      "bId": "t098",
      "from": {
        "x": 561,
        "y": 846
      },
      "to": {
        "x": 565,
        "y": 851
      }
    },
    {
      "aId": "t097",
      "bId": "t098",
      "from": {
        "x": 565,
        "y": 846
      },
      "to": {
        "x": 565,
        "y": 851
      }
    },
    {
      "aId": "t098",
      "bId": "t099",
      "from": {
        "x": 593,
        "y": 910
      },
      "to": {
        "x": 589,
        "y": 911
      }
    },
    {
      "aId": "t099",
      "bId": "tr020",
      "from": {
        "x": 539,
        "y": 911
      },
      "to": {
        "x": 555,
        "y": 915
      }
    },
    {
      "aId": "t100",
      "bId": "tr021",
      "from": {
        "x": 1057,
        "y": 922
      },
      "to": {
        "x": 1044,
        "y": 917
      }
    },
    {
      "aId": "t101",
      "bId": "t102",
      "from": {
        "x": 245,
        "y": 958
      },
      "to": {
        "x": 249,
        "y": 958
      }
    },
    {
      "aId": "t101",
      "bId": "t105",
      "from": {
        "x": 166,
        "y": 1004
      },
      "to": {
        "x": 180,
        "y": 1007
      }
    },
    {
      "aId": "t102",
      "bId": "t105",
      "from": {
        "x": 321,
        "y": 1004
      },
      "to": {
        "x": 307,
        "y": 1007
      }
    },
    {
      "aId": "t103",
      "bId": "t104",
      "from": {
        "x": 851,
        "y": 961
      },
      "to": {
        "x": 854,
        "y": 961
      }
    },
    {
      "aId": "t103",
      "bId": "t106",
      "from": {
        "x": 851,
        "y": 1035
      },
      "to": {
        "x": 854,
        "y": 1011
      }
    },
    {
      "aId": "t103",
      "bId": "t107",
      "from": {
        "x": 851,
        "y": 1035
      },
      "to": {
        "x": 851,
        "y": 1039
      }
    },
    {
      "aId": "t103",
      "bId": "tr022",
      "from": {
        "x": 851,
        "y": 961
      },
      "to": {
        "x": 846,
        "y": 917
      }
    },
    {
      "aId": "t104",
      "bId": "t106",
      "from": {
        "x": 854,
        "y": 1007
      },
      "to": {
        "x": 854,
        "y": 1011
      }
    },
    {
      "aId": "t105",
      "bId": "t108",
      "from": {
        "x": 273,
        "y": 1039
      },
      "to": {
        "x": 271,
        "y": 1044
      }
    },
    {
      "aId": "t105",
      "bId": "t110",
      "from": {
        "x": 180,
        "y": 1069
      },
      "to": {
        "x": 180,
        "y": 1073
      }
    },
    {
      "aId": "t106",
      "bId": "t107",
      "from": {
        "x": 854,
        "y": 1149
      },
      "to": {
        "x": 851,
        "y": 1149
      }
    },
    {
      "aId": "t107",
      "bId": "tr027",
      "from": {
        "x": 851,
        "y": 1149
      },
      "to": {
        "x": 825,
        "y": 1153
      }
    },
    {
      "aId": "t108",
      "bId": "t110",
      "from": {
        "x": 271,
        "y": 1099
      },
      "to": {
        "x": 273,
        "y": 1103
      }
    },
    {
      "aId": "t109",
      "bId": "t112",
      "from": {
        "x": 524,
        "y": 1098
      },
      "to": {
        "x": 527,
        "y": 1103
      }
    },
    {
      "aId": "t109",
      "bId": "tr020",
      "from": {
        "x": 557,
        "y": 1054
      },
      "to": {
        "x": 555,
        "y": 1049
      }
    },
    {
      "aId": "t110",
      "bId": "tr025",
      "from": {
        "x": 180,
        "y": 1144
      },
      "to": {
        "x": 166,
        "y": 1139
      }
    },
    {
      "aId": "t111",
      "bId": "t115",
      "from": {
        "x": 46,
        "y": 1199
      },
      "to": {
        "x": 41,
        "y": 1199
      }
    },
    {
      "aId": "t111",
      "bId": "tr025",
      "from": {
        "x": 89,
        "y": 1154
      },
      "to": {
        "x": 94,
        "y": 1153
      }
    },
    {
      "aId": "t112",
      "bId": "tr033",
      "from": {
        "x": 518,
        "y": 1148
      },
      "to": {
        "x": 555,
        "y": 1153
      }
    },
    {
      "aId": "t113",
      "bId": "t114",
      "from": {
        "x": 1085,
        "y": 1190
      },
      "to": {
        "x": 1089,
        "y": 1190
      }
    },
    {
      "aId": "t113",
      "bId": "tr026",
      "from": {
        "x": 1042,
        "y": 1154
      },
      "to": {
        "x": 1039,
        "y": 1153
      }
    },
    {
      "aId": "t116",
      "bId": "t117",
      "from": {
        "x": 113,
        "y": 1227
      },
      "to": {
        "x": 117,
        "y": 1247
      }
    },
    {
      "aId": "t116",
      "bId": "t118",
      "from": {
        "x": 113,
        "y": 1267
      },
      "to": {
        "x": 113,
        "y": 1270
      }
    },
    {
      "aId": "t117",
      "bId": "t118",
      "from": {
        "x": 117,
        "y": 1320
      },
      "to": {
        "x": 113,
        "y": 1299
      }
    },
    {
      "aId": "t117",
      "bId": "t119",
      "from": {
        "x": 185,
        "y": 1320
      },
      "to": {
        "x": 188,
        "y": 1334
      }
    },
    {
      "aId": "t117",
      "bId": "t127",
      "from": {
        "x": 117,
        "y": 1320
      },
      "to": {
        "x": 113,
        "y": 1303
      }
    },
    {
      "aId": "t117",
      "bId": "t130",
      "from": {
        "x": 185,
        "y": 1320
      },
      "to": {
        "x": 185,
        "y": 1324
      }
    },
    {
      "aId": "t118",
      "bId": "t127",
      "from": {
        "x": 113,
        "y": 1299
      },
      "to": {
        "x": 113,
        "y": 1303
      }
    },
    {
      "aId": "t119",
      "bId": "t120",
      "from": {
        "x": 188,
        "y": 1334
      },
      "to": {
        "x": 189,
        "y": 1337
      }
    },
    {
      "aId": "t119",
      "bId": "t130",
      "from": {
        "x": 188,
        "y": 1334
      },
      "to": {
        "x": 185,
        "y": 1324
      }
    },
    {
      "aId": "t120",
      "bId": "t121",
      "from": {
        "x": 331,
        "y": 1337
      },
      "to": {
        "x": 332,
        "y": 1334
      }
    },
    {
      "aId": "t120",
      "bId": "t123",
      "from": {
        "x": 331,
        "y": 1351
      },
      "to": {
        "x": 336,
        "y": 1352
      }
    },
    {
      "aId": "t120",
      "bId": "t130",
      "from": {
        "x": 189,
        "y": 1351
      },
      "to": {
        "x": 185,
        "y": 1352
      }
    },
    {
      "aId": "t120",
      "bId": "tr025",
      "from": {
        "x": 283,
        "y": 1274
      },
      "to": {
        "x": 274,
        "y": 1268
      }
    },
    {
      "aId": "t121",
      "bId": "t123",
      "from": {
        "x": 332,
        "y": 1274
      },
      "to": {
        "x": 336,
        "y": 1284
      }
    },
    {
      "aId": "t122",
      "bId": "t129",
      "from": {
        "x": 617,
        "y": 1321
      },
      "to": {
        "x": 620,
        "y": 1324
      }
    },
    {
      "aId": "t122",
      "bId": "t131",
      "from": {
        "x": 509,
        "y": 1323
      },
      "to": {
        "x": 505,
        "y": 1325
      }
    },
    {
      "aId": "t122",
      "bId": "tr033",
      "from": {
        "x": 572,
        "y": 1279
      },
      "to": {
        "x": 571,
        "y": 1274
      }
    },
    {
      "aId": "t124",
      "bId": "t125",
      "from": {
        "x": 814,
        "y": 1284
      },
      "to": {
        "x": 817,
        "y": 1284
      }
    },
    {
      "aId": "t124",
      "bId": "t126",
      "from": {
        "x": 814,
        "y": 1352
      },
      "to": {
        "x": 817,
        "y": 1350
      }
    },
    {
      "aId": "t125",
      "bId": "t126",
      "from": {
        "x": 867,
        "y": 1284
      },
      "to": {
        "x": 871,
        "y": 1284
      }
    },
    {
      "aId": "t126",
      "bId": "t128",
      "from": {
        "x": 919,
        "y": 1351
      },
      "to": {
        "x": 924,
        "y": 1351
      }
    },
    {
      "aId": "t126",
      "bId": "tr026",
      "from": {
        "x": 871,
        "y": 1284
      },
      "to": {
        "x": 897,
        "y": 1281
      }
    },
    {
      "aId": "t127",
      "bId": "t130",
      "from": {
        "x": 113,
        "y": 1352
      },
      "to": {
        "x": 117,
        "y": 1352
      }
    },
    {
      "aId": "tr002",
      "bId": "tr001",
      "from": {
        "x": 141,
        "y": 92
      },
      "to": {
        "x": 136,
        "y": 92
      }
    },
    {
      "aId": "tr002",
      "bId": "tr006",
      "from": {
        "x": 444,
        "y": 93
      },
      "to": {
        "x": 446,
        "y": 92
      }
    },
    {
      "aId": "tr013",
      "bId": "tr014",
      "from": {
        "x": 422,
        "y": 566
      },
      "to": {
        "x": 425,
        "y": 566
      }
    },
    {
      "aId": "tr013",
      "bId": "tr019",
      "from": {
        "x": 374,
        "y": 700
      },
      "to": {
        "x": 372,
        "y": 702
      }
    },
    {
      "aId": "tr019",
      "bId": "tr015",
      "from": {
        "x": 400,
        "y": 797
      },
      "to": {
        "x": 447,
        "y": 814
      }
    },
    {
      "aId": "tr019",
      "bId": "tr023",
      "from": {
        "x": 328,
        "y": 894
      },
      "to": {
        "x": 324,
        "y": 894
      }
    },
    {
      "aId": "tr019",
      "bId": "tr032",
      "from": {
        "x": 347,
        "y": 958
      },
      "to": {
        "x": 347,
        "y": 960
      }
    },
    {
      "aId": "tr025",
      "bId": "tr012",
      "from": {
        "x": 91,
        "y": 1028
      },
      "to": {
        "x": 91,
        "y": 1024
      }
    },
    {
      "aId": "tr025",
      "bId": "tr033",
      "from": {
        "x": 330,
        "y": 1240
      },
      "to": {
        "x": 332,
        "y": 1240
      }
    },
    {
      "aId": "tr026",
      "bId": "tr021",
      "from": {
        "x": 947,
        "y": 1058
      },
      "to": {
        "x": 947,
        "y": 1053
      }
    },
    {
      "aId": "tr026",
      "bId": "tr027",
      "from": {
        "x": 884,
        "y": 1210
      },
      "to": {
        "x": 880,
        "y": 1210
      }
    },
    {
      "aId": "tr001",
      "bId": "tr012",
      "from": {
        "x": 77,
        "y": 471
      },
      "to": {
        "x": 77,
        "y": 475
      }
    },
    {
      "aId": "tr003",
      "bId": "tr004",
      "from": {
        "x": 831,
        "y": 110
      },
      "to": {
        "x": 835,
        "y": 110
      }
    },
    {
      "aId": "tr003",
      "bId": "tr006",
      "from": {
        "x": 685,
        "y": 92
      },
      "to": {
        "x": 681,
        "y": 93
      }
    },
    {
      "aId": "tr012",
      "bId": "tr023",
      "from": {
        "x": 154,
        "y": 894
      },
      "to": {
        "x": 158,
        "y": 894
      }
    },
    {
      "aId": "tr014",
      "bId": "tr015",
      "from": {
        "x": 425,
        "y": 582
      },
      "to": {
        "x": 447,
        "y": 587
      }
    },
    {
      "aId": "tr014",
      "bId": "tr017",
      "from": {
        "x": 602,
        "y": 566
      },
      "to": {
        "x": 607,
        "y": 566
      }
    },
    {
      "aId": "tr015",
      "bId": "tr020",
      "from": {
        "x": 447,
        "y": 814
      },
      "to": {
        "x": 447,
        "y": 818
      }
    },
    {
      "aId": "tr016",
      "bId": "tr017",
      "from": {
        "x": 680,
        "y": 587
      },
      "to": {
        "x": 735,
        "y": 585
      }
    },
    {
      "aId": "tr016",
      "bId": "tr020",
      "from": {
        "x": 680,
        "y": 814
      },
      "to": {
        "x": 680,
        "y": 818
      }
    },
    {
      "aId": "tr017",
      "bId": "tr020",
      "from": {
        "x": 757,
        "y": 779
      },
      "to": {
        "x": 755,
        "y": 781
      }
    },
    {
      "aId": "tr032",
      "bId": "tr020",
      "from": {
        "x": 378,
        "y": 994
      },
      "to": {
        "x": 383,
        "y": 994
      }
    },
    {
      "aId": "tr032",
      "bId": "tr033",
      "from": {
        "x": 347,
        "y": 1123
      },
      "to": {
        "x": 347,
        "y": 1127
      }
    },
    {
      "aId": "tr020",
      "bId": "tr022",
      "from": {
        "x": 794,
        "y": 904
      },
      "to": {
        "x": 798,
        "y": 904
      }
    },
    {
      "aId": "tr021",
      "bId": "tr022",
      "from": {
        "x": 887,
        "y": 888
      },
      "to": {
        "x": 883,
        "y": 888
      }
    },
    {
      "aId": "tr033",
      "bId": "tr027",
      "from": {
        "x": 740,
        "y": 1256
      },
      "to": {
        "x": 745,
        "y": 1256
      }
    }
  ]
}
